import { defineMessage } from 'react-intl';

/**
 *  Only a few of the descriptions have been filled in.
 *  This is because the translations migrated over from another translation system, and we essentially used the desc
 *  as a key to map the translations
 */
export const commonMessages = {
    advancedFilters: {
        'birthStateProvinceCode.all': defineMessage({
            defaultMessage: 'All Provinces/States',
            description: 'idToName.birthStateProvinceCode.all',
        }),
        'conference.1': defineMessage({
            defaultMessage: 'Eastern Conference (1993-2013)',
            description: 'idToName.conference.1',
        }),
        'conference.2': defineMessage({
            defaultMessage: 'Western Conference (1993-2013)',
            description: 'idToName.conference.2',
        }),
        'conference.3': defineMessage({
            defaultMessage: 'Prince Of Wales Conference',
            description: 'idToName.conference.3',
        }),
        'conference.4': defineMessage({
            defaultMessage: 'Clarence Campbell Conference',
            description: 'idToName.conference.4',
        }),
        'conference.5': defineMessage({
            defaultMessage: 'Western Conference',
            description: 'idToName.conference.5',
        }),
        'conference.6': defineMessage({
            defaultMessage: 'Eastern Conference',
            description: 'idToName.conference.6',
        }),
        'division.1': defineMessage({
            defaultMessage: 'Atlantic Division (1993-2013)',
            description: 'idToName.division.1',
        }),
        'division.10': defineMessage({
            defaultMessage: 'West Division',
            description: 'idToName.division.10',
        }),
        'division.11': defineMessage({
            defaultMessage: 'Adams Division',
            description: 'idToName.division.11',
        }),
        'division.12': defineMessage({
            defaultMessage: 'Norris Division',
            description: 'idToName.division.12',
        }),
        'division.13': defineMessage({
            defaultMessage: 'Patrick Division',
            description: 'idToName.division.13',
        }),
        'division.14': defineMessage({
            defaultMessage: 'Smythe Division',
            description: 'idToName.division.14',
        }),
        'division.15': defineMessage({
            defaultMessage: 'Pacific Division',
            description: 'idToName.division.15',
        }),
        'division.16': defineMessage({
            defaultMessage: 'Central Division',
            description: 'idToName.division.16',
        }),
        'division.17': defineMessage({
            defaultMessage: 'Atlantic Division',
            description: 'idToName.division.17',
        }),
        'division.18': defineMessage({
            defaultMessage: 'Metropolitan Division',
            description: 'idToName.division.18',
        }),
        'division.2': defineMessage({
            defaultMessage: 'Northeast Division',
            description: 'idToName.division.2',
        }),
        'division.3': defineMessage({
            defaultMessage: 'Southeast Division',
            description: 'idToName.division.3',
        }),
        'division.4': defineMessage({
            defaultMessage: 'Central Division (1993-2013)',
            description: 'idToName.division.4',
        }),
        'division.5': defineMessage({
            defaultMessage: 'Northwest Division',
            description: 'idToName.division.5',
        }),
        'division.6': defineMessage({
            defaultMessage: 'Pacific Division (1993-2013)',
            description: 'idToName.division.6',
        }),
        'division.7': defineMessage({
            defaultMessage: 'Canadian Division',
            description: 'idToName.division.7',
        }),
        'division.8': defineMessage({
            defaultMessage: 'American Division',
            description: 'idToName.division.8',
        }),
        'division.9': defineMessage({
            defaultMessage: 'East Division',
            description: 'idToName.division.9',
        }),
        'experienceAndStatus': defineMessage({
            defaultMessage: 'Experience/Status',
            description:
                'Two words one describing how much experience a player has in the league (rookie or veteran) the other describes their status in the league (Active, Inactive or Hall of Famer)',
        }),
        'nationalityCode.all': defineMessage({
            defaultMessage: 'All Nationalities',
            description: `A phrase that describes all nationalities`,
        }),
        'team.all': defineMessage({
            defaultMessage: 'All Teams',
            description: 'idToName.team.all',
        }),
    },
    ariaLabels: {
        franchise: {
            dropdownButton: defineMessage({
                defaultMessage: 'Expand Franchise Options',
                description:
                    'Label for select element button, prompting user to expand franchise options in a dropdown menu',
            }),
            optionsBox: defineMessage({
                defaultMessage: 'Franchise Options',
                description: 'Label indicating that user is viewing a list of franchise options for a select component',
            }),
        },
        gameType: {
            dropdownButton: defineMessage({
                defaultMessage: 'Expand Game Type Options',
                description:
                    'Label for select element button, prompting user to expand game type options in a dropdown menu',
            }),
            optionsBox: defineMessage({
                defaultMessage: 'Game Type Options',
                description: 'Label indicating that user is viewing a list of game type options for a select component',
            }),
        },
        rowSize: {
            dropdownButton: defineMessage({
                defaultMessage: 'Expand Row Size Options',
                description:
                    'Label for select element button, prompting user to expand row size options (ex. 25, 50, 75, 100), in a dropdown menu',
            }),
            optionsBox: defineMessage({
                defaultMessage: 'Row Size Options',
                description: 'Label indicating that user is viewing a list of row size options for a select component',
            }),
        },
        season: {
            dropdownButton: defineMessage({
                defaultMessage: 'Expand Season Options',
                description:
                    'Label for select element button, prompting user to expand season options in a dropdown menu',
            }),
            optionsBox: defineMessage({
                defaultMessage: 'Season Options',
                description: 'Label indicating that user is viewing a list of season options for a select component',
            }),
        },
    },
    columns: {
        assists: defineMessage({
            defaultMessage: 'A',
            description: 'columns.assists',
        }),
        assists5v5: defineMessage({
            defaultMessage: 'A',
            description: 'columns.assists5v5',
        }),
        assistsPer605v5: defineMessage({
            defaultMessage: 'A/60',
            description: 'columns.assistsPer605v5',
        }),
        assistsPerGame: defineMessage({
            defaultMessage: 'A/GP',
            description: 'columns.assistsPerGame',
        }),
        benchMinorPenalties: defineMessage({
            defaultMessage: 'Bench',
            description: 'columns.benchMinorPenalties',
        }),
        birthCity: defineMessage({
            defaultMessage: 'Birth City',
            description: 'columns.birthCity',
        }),
        birthCountryCode: defineMessage({
            defaultMessage: 'Ctry',
            description: 'columns.birthCountryCode',
        }),
        birthDate: defineMessage({
            defaultMessage: 'DOB',
            description: 'columns.birthDate',
        }),
        birthStateProvinceCode: defineMessage({
            defaultMessage: 'S/P',
            description: 'columns.birthStateProvinceCode',
        }),
        blockedShots: defineMessage({
            defaultMessage: 'BkS',
            description: 'columns.blockedShots',
        }),
        blockedShotsPer60: defineMessage({
            defaultMessage: 'BkS/60',
            description: 'columns.blockedShotsPer60',
        }),
        blocksPerGame: defineMessage({
            defaultMessage: 'BkS/GP',
            description: 'columns.blocksPerGame',
        }),
        careerShootoutGameDecidingGoals: defineMessage({
            defaultMessage: 'Career {br} GDG',
            description: 'columns.careerShootoutGameDecidingGoals',
        }),
        careerShootoutGamesPlayed: defineMessage({
            defaultMessage: 'Career {br} S/O GP',
            description: 'columns.careerShootoutGamesPlayed',
        }),
        careerShootoutGoals: defineMessage({
            defaultMessage: 'Career {br} S/O G',
            description: 'columns.careerShootoutGoals',
        }),
        careerShootoutGoalsAllowed: defineMessage({
            defaultMessage: 'Career {br} S/O GA',
            description: 'columns.careerShootoutGoalsAllowed',
        }),
        careerShootoutLosses: defineMessage({
            defaultMessage: 'Career {br} S/O L',
            description: 'columns.careerShootoutLosses',
        }),
        careerShootoutSavePct: defineMessage({
            defaultMessage: 'Career {br} S/O Sv %',
            description: 'columns.careerShootoutSavePct',
        }),
        careerShootoutSaves: defineMessage({
            defaultMessage: 'Career {br} S/O Sv',
            description: 'columns.careerShootoutSaves',
        }),
        careerShootoutShootingPct: defineMessage({
            defaultMessage: 'Career {br} S/O S%',
            description: 'columns.careerShootoutShootingPct',
        }),
        careerShootoutShots: defineMessage({
            defaultMessage: 'Career {br} S/O S',
            description: 'columns.careerShootoutShots',
        }),
        careerShootoutShotsAgainst: defineMessage({
            defaultMessage: 'Career {br} S/O SA',
            description: 'columns.careerShootoutShotsAgainst',
        }),
        careerShootoutWins: defineMessage({
            defaultMessage: 'Career {br} S/O W',
            description: 'columns.careerShootoutWins',
        }),
        completeGamePct: defineMessage({
            defaultMessage: 'CG%',
            description: 'columns.completeGamePct',
        }),
        completeGames: defineMessage({
            defaultMessage: 'CG',
            description: 'columns.completeGames',
        }),
        currentTeamAbbrev: defineMessage({
            defaultMessage: 'Team',
            description: 'columns.currentTeamAbbrev',
        }),
        daysRest: defineMessage({
            defaultMessage: 'Days Btwn Games',
            description: 'columns.daysRest',
        }),
        defensiveZoneFaceoffLosses: defineMessage({
            defaultMessage: 'DZ FOL',
            description: 'columns.defensiveZoneFaceoffLosses',
        }),
        defensiveZoneFaceoffPct: defineMessage({
            defaultMessage: 'DZ FOW%',
            description: 'columns.defensiveZoneFaceoffPct',
        }),
        defensiveZoneStartPct: defineMessage({
            defaultMessage: 'DZ Start%',
            description: 'Header for a column showing what percentage of zone starts came in the defensive zone',
        }),
        defensiveZoneFaceoffWins: defineMessage({
            defaultMessage: 'DZ FOW',
            description: 'columns.defensiveZoneFaceoffWins',
        }),
        defensiveZoneFaceoffs: defineMessage({
            defaultMessage: 'DZ FO',
            description: 'columns.defensiveZoneFaceoffs',
        }),
        draftOverall: defineMessage({
            defaultMessage: 'Overall',
            description: 'columns.draftOverall',
        }),
        draftRound: defineMessage({
            defaultMessage: 'Round',
            description: 'columns.draftRound',
        }),
        draftYear: defineMessage({
            defaultMessage: 'Draft Yr',
            description: 'columns.draftYear',
        }),
        emptyNetAssists: defineMessage({
            defaultMessage: 'ENA',
            description: 'columns.emptyNetAssists',
        }),
        emptyNetGoals: defineMessage({
            defaultMessage: 'ENG',
            description: 'columns.emptyNetGoals',
        }),
        emptyNetGoalsAgainst: defineMessage({
            defaultMessage: 'EN GA',
            description: 'An abbreviation for Empty Net Goals Against',
        }),
        emptyNetPoints: defineMessage({
            defaultMessage: 'ENP',
            description: 'columns.emptyNetPoints',
        }),
        evFaceoffPct: defineMessage({
            defaultMessage: 'EV FOW%',
            description: 'columns.evFaceoffPct',
        }),
        evFaceoffs: defineMessage({
            defaultMessage: 'EV FO',
            description: 'columns.evFaceoffs',
        }),
        evFaceoffsLost: defineMessage({
            defaultMessage: 'EV FOL',
            description: 'columns.evFaceoffsLost',
        }),
        evFaceoffsWon: defineMessage({
            defaultMessage: 'EV FOW',
            description: 'columns.evFaceoffsWon',
        }),
        evGoals: defineMessage({
            defaultMessage: 'EVG',
            description: 'columns.evGoals',
        }),
        evGoalsAgainst: defineMessage({
            defaultMessage: 'EV GA',
            description: 'columns.evGoalsAgainst',
        }),
        evGoalsFor: defineMessage({
            defaultMessage: 'EV GF',
            description: 'columns.evGoalsFor',
        }),
        evPoints: defineMessage({
            defaultMessage: 'EVP',
            description: 'columns.evPoints',
        }),
        evSavePct: defineMessage({
            defaultMessage: 'EV Sv%',
            description: 'columns.evSavePct',
        }),
        evSaves: defineMessage({
            defaultMessage: 'EV Svs',
            description: 'columns.evSaves',
        }),
        evShotsAgainst: defineMessage({
            defaultMessage: 'EV SA',
            description: 'columns.evShotsAgainst',
        }),
        evTimeOnIce: defineMessage({
            defaultMessage: 'EV TOI',
            description: 'columns.evTimeOnIce',
        }),
        evTimeOnIcePerGame: defineMessage({
            defaultMessage: 'EV TOI/GP',
            description: 'columns.evTimeOnIcePerGame',
        }),
        evenStrengthGoalDifference: defineMessage({
            defaultMessage: 'On-Ice EV GD',
            description: 'columns.evenStrengthGoalDifference',
        }),
        evenStrengthGoalsAgainst: defineMessage({
            defaultMessage: 'On-Ice EV GA',
            description: 'columns.evenStrengthGoalsAgainst',
        }),
        evenStrengthGoalsFor: defineMessage({
            defaultMessage: 'On-Ice EV GF',
            description: 'columns.evenStrengthGoalsFor',
        }),
        evenStrengthGoalsForPct: defineMessage({
            defaultMessage: 'On-Ice EV GF%',
            description: 'columns.evenStrengthGoalsForPct',
        }),
        evenStrengthTimeOnIcePerGame: defineMessage({
            defaultMessage: 'EV TOI/GP',
            description: 'columns.evenStrengthTimeOnIcePerGame',
        }),
        faceoffLosses: defineMessage({
            defaultMessage: 'FOL',
            description: 'columns.faceoffLosses',
        }),
        faceoffPct5v5: defineMessage({
            defaultMessage: 'FOW%',
            description: 'columns.faceoffPct5v5',
        }),
        faceoffWinPct: defineMessage({
            defaultMessage: 'FOW%',
            description: 'columns.faceoffWinPct',
        }),
        faceoffWins: defineMessage({
            defaultMessage: 'FOW',
            description: 'columns.faceoffWins',
        }),
        faceoffsLost: defineMessage({
            defaultMessage: 'FOL',
            description: 'columns.faceoffsLost',
        }),
        faceoffsWon: defineMessage({
            defaultMessage: 'FOW',
            description: 'columns.faceoffsWon',
        }),
        firstGoals: defineMessage({
            defaultMessage: '1g',
            description: 'columns.firstGoals',
        }),
        firstSeasonForGameType: defineMessage({
            defaultMessage: '1st Season',
            description: 'columns.firstSeasonForGameType',
        }),
        franchiseName: defineMessage({
            defaultMessage: 'Team',
            description: 'columns.franchiseName',
        }),
        gameDate: defineMessage({
            defaultMessage: 'Game Date',
            description: 'columns.gameDate',
        }),
        gameId: defineMessage({
            defaultMessage: 'Game',
            description: 'columns.gameId',
        }),
        gameMisconductPenalties: defineMessage({
            defaultMessage: 'G Msct',
            description: 'columns.gameMisconductPenalties',
        }),
        gameMisconducts: defineMessage({
            defaultMessage: 'G Msct',
            description: 'columns.gameMisconducts',
        }),
        gameWinningGoals: defineMessage({
            defaultMessage: 'GWG',
            description: 'columns.gameWinningGoals',
        }),
        gamesPlayed: defineMessage({
            defaultMessage: 'GP',
            description: 'columns.gamesPlayed',
        }),
        gamesPlayedDaysRest0: defineMessage({
            defaultMessage: '0 Days Rest',
            description: 'columns.gamesPlayedDaysRest0',
        }),
        gamesPlayedDaysRest1: defineMessage({
            defaultMessage: '1 Days Rest',
            description: 'columns.gamesPlayedDaysRest1',
        }),
        gamesPlayedDaysRest2: defineMessage({
            defaultMessage: '2 Days Rest',
            description: 'columns.gamesPlayedDaysRest2',
        }),
        gamesPlayedDaysRest3: defineMessage({
            defaultMessage: '3 Days Rest',
            description: 'columns.gamesPlayedDaysRest3',
        }),
        gamesPlayedDaysRest4Plus: defineMessage({
            defaultMessage: '4+ Days Rest',
            description: 'columns.gamesPlayedDaysRest4Plus',
        }),
        gamesRelieved: defineMessage({
            defaultMessage: 'GR',
            description: 'columns.gamesRelieved',
        }),
        gamesRelievedGoalsAgainst: defineMessage({
            defaultMessage: 'GR GA',
            description: 'columns.gamesRelievedGoalsAgainst',
        }),
        gamesRelievedLosses: defineMessage({
            defaultMessage: 'GR L',
            description: 'columns.gamesRelievedLosses',
        }),
        gamesRelievedOtLosses: defineMessage({
            defaultMessage: 'GR OT',
            description: 'columns.gamesRelievedOtLosses',
        }),
        gamesRelievedSavePct: defineMessage({
            defaultMessage: 'GR Sv %',
            description: 'columns.gamesRelievedSavePct',
        }),
        gamesRelievedSaves: defineMessage({
            defaultMessage: 'GR Svs',
            description: 'columns.gamesRelievedSaves',
        }),
        gamesRelievedShotsAgainst: defineMessage({
            defaultMessage: 'GR SA',
            description: 'columns.gamesRelievedShotsAgainst',
        }),
        gamesRelievedTies: defineMessage({
            defaultMessage: 'GR T',
            description: 'columns.gamesRelievedTies',
        }),
        gamesRelievedWins: defineMessage({
            defaultMessage: 'GR W',
            description: 'columns.gamesRelievedWins',
        }),
        gamesStarted: defineMessage({
            defaultMessage: 'GS',
            description: 'columns.gamesStarted',
        }),
        gamesStartedGoalsAgainst: defineMessage({
            defaultMessage: 'GS GA',
            description: 'columns.gamesStartedGoalsAgainst',
        }),
        gamesStartedLosses: defineMessage({
            defaultMessage: 'GS L',
            description: 'columns.gamesStartedLosses',
        }),
        gamesStartedOtLosses: defineMessage({
            defaultMessage: 'GS OT',
            description: 'columns.gamesStartedOtLosses',
        }),
        gamesStartedSavePct: defineMessage({
            defaultMessage: 'GS Sv %',
            description: 'columns.gamesStartedSavePct',
        }),
        gamesStartedSaves: defineMessage({
            defaultMessage: 'GS Svs',
            description: 'columns.gamesStartedSaves',
        }),
        gamesStartedShotsAgainst: defineMessage({
            defaultMessage: 'GS SA',
            description: 'columns.gamesStartedShotsAgainst',
        }),
        gamesStartedTies: defineMessage({
            defaultMessage: 'GS T',
            description: 'columns.gamesStartedTies',
        }),
        gamesStartedWins: defineMessage({
            defaultMessage: 'GS W',
            description: 'columns.gamesStartedWins',
        }),
        giveaways: defineMessage({
            defaultMessage: 'GvA',
            description: 'columns.giveaways',
        }),
        giveawaysPer60: defineMessage({
            defaultMessage: 'GvA/60',
            description: 'columns.giveawaysPer60',
        }),
        goalieFullName: defineMessage({
            defaultMessage: 'Player',
            description: 'columns.goalieFullName',
        }),
        goalieGoalsAgainst: defineMessage({
            defaultMessage: 'Goalie GA',
            description: 'An abbreviation for Goalie Goals Against',
        }),
        goals: defineMessage({
            defaultMessage: 'G',
            description: 'columns.goals',
        }),
        goals4v3: defineMessage({
            defaultMessage: '4v3 GF',
            description: 'columns.goals4v3',
        }),
        goals5v3: defineMessage({
            defaultMessage: '5v3 GF',
            description: 'columns.goals5v3',
        }),
        goals5v4: defineMessage({
            defaultMessage: '5v4 GF',
            description: 'columns.goals5v4',
        }),
        goals5v5: defineMessage({
            defaultMessage: 'G',
            description: 'columns.goals5v5',
        }),
        goalsAgainst: defineMessage({
            defaultMessage: 'GA',
            description: 'columns.goalsAgainst',
        }),
        goalsAgainst3On3: defineMessage({
            defaultMessage: 'GA 3v3',
            description: 'columns.goalsAgainst3On3',
        }),
        goalsAgainst3On4: defineMessage({
            defaultMessage: 'GA 3v4',
            description: 'columns.goalsAgainst3On4',
        }),
        goalsAgainst3On5: defineMessage({
            defaultMessage: 'GA 3v5',
            description: 'columns.goalsAgainst3On5',
        }),
        goalsAgainst3On6: defineMessage({
            defaultMessage: 'GA 3v6',
            description: 'columns.goalsAgainst3On6',
        }),
        goalsAgainst3v4: defineMessage({
            defaultMessage: 'GA 3v4',
            description: 'columns.goalsAgainst3v4',
        }),
        goalsAgainst3v5: defineMessage({
            defaultMessage: 'GA 3v5',
            description: 'columns.goalsAgainst3v5',
        }),
        goalsAgainst4On3: defineMessage({
            defaultMessage: 'GA 4v3',
            description: 'columns.goalsAgainst4On3',
        }),
        goalsAgainst4On4: defineMessage({
            defaultMessage: 'GA 4v4',
            description: 'columns.goalsAgainst4On4',
        }),
        goalsAgainst4On5: defineMessage({
            defaultMessage: 'GA 4v5',
            description: 'columns.goalsAgainst4On5',
        }),
        goalsAgainst4On6: defineMessage({
            defaultMessage: 'GA 4v6',
            description: 'columns.goalsAgainst4On6',
        }),
        goalsAgainst4v5: defineMessage({
            defaultMessage: 'GA 4v5',
            description: 'columns.goalsAgainst4v5',
        }),
        goalsAgainst5On3: defineMessage({
            defaultMessage: 'GA 5v3',
            description: 'columns.goalsAgainst5On3',
        }),
        goalsAgainst5On4: defineMessage({
            defaultMessage: 'GA 5v4',
            description: 'columns.goalsAgainst5On4',
        }),
        goalsAgainst5On5: defineMessage({
            defaultMessage: 'GA 5v5',
            description: 'columns.goalsAgainst5On5',
        }),
        goalsAgainst5On6: defineMessage({
            defaultMessage: 'GA 5v6',
            description: 'columns.goalsAgainst5On6',
        }),
        goalsAgainst6On3: defineMessage({
            defaultMessage: 'GA 6v3',
            description: 'columns.goalsAgainst6On3',
        }),
        goalsAgainst6On4: defineMessage({
            defaultMessage: 'GA 6v4',
            description: 'columns.goalsAgainst6On4',
        }),
        goalsAgainst6On5: defineMessage({
            defaultMessage: 'GA 6v5',
            description: 'columns.goalsAgainst6On5',
        }),
        goalsAgainst6On6: defineMessage({
            defaultMessage: 'GA 6v6',
            description: 'columns.goalsAgainst6On6',
        }),
        goalsAgainstAverage: defineMessage({
            defaultMessage: 'GAA',
            description: 'columns.goalsAgainstAverage',
        }),
        goalsAgainstEmptyNet: defineMessage({
            defaultMessage: 'EN GA',
            description: 'An abbreviation for the amount of goals a team has scored against them when their goalie is pulled',
        }),
        goalsAgainstExtraAttacker: defineMessage({
            defaultMessage: 'XA GA',
            description: 'An abbreviation for the amount of goals a team has scored against them when facing an extra attacker',
        }),
        goalsAgainstPenaltyShots: defineMessage({
            defaultMessage: 'PS GA',
            description: 'columns.goalsAgainstPenaltyShots',
        }),
        goalsAgainstPerGame: defineMessage({
            defaultMessage: 'GA/GP',
            description: 'columns.goalsAgainstPerGame',
        }),
        goalsAgainstPerRegulationLoss: defineMessage({
            defaultMessage: 'GA / ROL',
            description: 'columns.goalsAgainstPerRegulationLoss',
        }),
        goalsBackhand: defineMessage({
            defaultMessage: 'G Back',
            description: 'columns.goalsBackhand',
        }),
        goalsBat: defineMessage({
            defaultMessage: 'G Bat',
            description: 'An abbreviation that describes how many goals a player batted in',
        }),
        goalsBetweenLegs: defineMessage({
            defaultMessage: 'G Legs',
            description: 'An abbreviation that describes how many goals a player scored between their legs',
        }),
        goalsCradle: defineMessage({
            defaultMessage: 'G Cradle',
            description: 'An abbreviation that describes how many cradle goals a player has',
        }),
        goalsDeflected: defineMessage({
            defaultMessage: 'G Dflct',
            description: 'columns.goalsDeflected',
        }),
        goalsFor: defineMessage({
            defaultMessage: 'GF',
            description: 'columns.goalsFor',
        }),
        goalsFor3On3: defineMessage({
            defaultMessage: 'GF 3v3',
            description: 'columns.goalsFor3On3',
        }),
        goalsFor3On4: defineMessage({
            defaultMessage: 'GF 3v4',
            description: 'columns.goalsFor3On4',
        }),
        goalsFor3On5: defineMessage({
            defaultMessage: 'GF 3v5',
            description: 'columns.goalsFor3On5',
        }),
        goalsFor3On6: defineMessage({
            defaultMessage: 'GF 3v6',
            description: 'columns.goalsFor3On6',
        }),
        goalsFor4On3: defineMessage({
            defaultMessage: 'GF 4v3',
            description: 'columns.goalsFor4On3',
        }),
        goalsFor4On4: defineMessage({
            defaultMessage: 'GF 4v4',
            description: 'columns.goalsFor4On4',
        }),
        goalsFor4On5: defineMessage({
            defaultMessage: 'GF 4v5',
            description: 'columns.goalsFor4On5',
        }),
        goalsFor4On6: defineMessage({
            defaultMessage: 'GF 4v6',
            description: 'columns.goalsFor4On6',
        }),
        goalsFor5On3: defineMessage({
            defaultMessage: 'GF 5v3',
            description: 'columns.goalsFor5On3',
        }),
        goalsFor5On4: defineMessage({
            defaultMessage: 'GF 5v4',
            description: 'columns.goalsFor5On4',
        }),
        goalsFor5On5: defineMessage({
            defaultMessage: 'GF 5v5',
            description: 'columns.goalsFor5On5',
        }),
        goalsFor5On6: defineMessage({
            defaultMessage: 'GF 5v6',
            description: 'columns.goalsFor5On6',
        }),
        goalsFor6On3: defineMessage({
            defaultMessage: 'GF 6v3',
            description: 'columns.goalsFor6On3',
        }),
        goalsFor6On4: defineMessage({
            defaultMessage: 'GF 6v4',
            description: 'columns.goalsFor6On4',
        }),
        goalsFor6On5: defineMessage({
            defaultMessage: 'GF 6v5',
            description: 'columns.goalsFor6On5',
        }),
        goalsFor6On6: defineMessage({
            defaultMessage: 'GF 6v6',
            description: 'An abbreviation for the amount of goals a team scored when both teams have 6 skaters on the ice',
        }),
        goalsAgainstAllPulls: defineMessage({
            defaultMessage: 'GA',
            description: 'An abbreviation for the amount of goals scored against a team when either goalie is pulled',
        }),
        goalsForAllPulls: defineMessage({
            defaultMessage: 'GF',
            description: 'An abbreviation for the amount of goals a team scored when either goalie is pulled',
        }),
        goalsForAverage: defineMessage({
            defaultMessage: 'GFA',
            description: 'columns.goalsForAverage',
        }),
        goalsForEmptyNet: defineMessage({
            defaultMessage: 'EN GF',
            description: 'An abbreviation for the amount of empty net goals a team scored',
        }),
        goalsForExtraAttacker: defineMessage({
            defaultMessage: 'XA GF',
            description: 'An abbreviation for the amount of goals your team scored when you have an extra attacker',
        }),
        goalsForPct: defineMessage({
            defaultMessage: 'GF%',
            description: 'columns.goalsForPct',
        }),
        goalsForPenaltyShots: defineMessage({
            defaultMessage: 'PS GF',
            description: 'columns.goalsForPenaltyShots',
        }),
        goalsForPerGame: defineMessage({
            defaultMessage: 'GF/GP',
            description: 'columns.goalsForPerGame',
        }),
        goalsPct: defineMessage({
            defaultMessage: 'On-Ice GF %',
            description:
                'A phrase which is the following calculation, GF/(GF + GA). GF is the amount of goals the team scored while the player is on the ice. GA is the amount of goals scored on the team while the player is on the ice',
        }),
        goalsPer605v5: defineMessage({
            defaultMessage: 'G/60',
            description: 'columns.goalsPer605v5',
        }),
        goalsPerGame: defineMessage({
            defaultMessage: 'G/GP',
            description: 'columns.goalsPerGame',
        }),
        goalsPoke: defineMessage({
            defaultMessage: 'G Poke',
            description: 'An abbreviation that describes how many goals a player poked in',
        }),
        goalsSlap: defineMessage({
            defaultMessage: 'G Slap',
            description: 'columns.goalsSlap',
        }),
        goalsSnap: defineMessage({
            defaultMessage: 'G Snap',
            description: 'columns.goalsSnap',
        }),
        goalsTipIn: defineMessage({
            defaultMessage: 'G Tip',
            description: 'columns.goalsTipIn',
        }),
        goalsWrapAround: defineMessage({
            defaultMessage: 'G Wrap',
            description: 'columns.goalsWrapAround',
        }),
        goalsWrist: defineMessage({
            defaultMessage: 'G Wrist',
            description: 'columns.goalsWrist',
        }),
        height: defineMessage({
            defaultMessage: 'Ht',
            description: 'columns.height',
        }),
        hits: defineMessage({
            defaultMessage: 'Hits',
            description: 'columns.hits',
        }),
        hitsPer60: defineMessage({
            defaultMessage: 'Hits/60',
            description: 'columns.hitsPer60',
        }),
        hitsPerGame: defineMessage({
            defaultMessage: 'Hits/GP',
            description: 'columns.hitsPerGame',
        }),
        homeRoad: defineMessage({
            defaultMessage: 'Game Location',
            description: 'columns.homeRoad',
        }),
        incompleteGames: defineMessage({
            defaultMessage: 'IG',
            description: 'columns.incompleteGames',
        }),
        individualSatForPer60: defineMessage({
            defaultMessage: 'iSAT/60',
            description: 'columns.individualSatForPer60',
        }),
        individualShotsForPer60: defineMessage({
            defaultMessage: '5v5 S/60',
            description: 'columns.individualShotsForPer60',
        }),
        isInHallOfFameYn: defineMessage({
            defaultMessage: 'HOF',
            description: 'columns.isInHallOfFameYn',
        }),
        lastName: defineMessage({
            defaultMessage: 'Player',
            description: 'columns.lastName',
        }),
        lossLeadPeriod1: defineMessage({
            defaultMessage: 'Loss Lead 1P',
            description: 'columns.lossLeadPeriod1',
        }),
        lossLeadPeriod2: defineMessage({
            defaultMessage: 'Loss Lead 2P',
            description: 'columns.lossLeadPeriod2',
        }),
        lossTrailPeriod1: defineMessage({
            defaultMessage: 'Loss Trail 1P',
            description: 'columns.lossTrailPeriod1',
        }),
        lossTrailPeriod2: defineMessage({
            defaultMessage: 'Loss Trail 2P',
            description: 'columns.lossTrailPeriod2',
        }),
        losses: defineMessage({
            defaultMessage: 'L',
            description: 'columns.losses',
        }),
        lossesEvenShots: defineMessage({
            defaultMessage: 'Loss Even Shots',
            description: 'columns.lossesEvenShots',
        }),
        lossesOneGoalGames: defineMessage({
            defaultMessage: 'Loss 1 Goal Game',
            description: 'columns.lossesOneGoalGames',
        }),
        lossesOutshootOpponent: defineMessage({
            defaultMessage: 'Loss Outshoot Opp',
            description: 'columns.lossesOutshootOpponent',
        }),
        lossesOutshotByOpponent: defineMessage({
            defaultMessage: 'Loss Outshot by Opp',
            description: 'columns.lossesOutshotByOpponent',
        }),
        lossesScoringFirst: defineMessage({
            defaultMessage: 'L SF',
            description: 'columns.lossesScoringFirst',
        }),
        lossesThreeGoalGames: defineMessage({
            defaultMessage: 'Loss 3 Goal Game',
            description: 'columns.lossesThreeGoalGames',
        }),
        lossesTrailingFirst: defineMessage({
            defaultMessage: 'L TF',
            description: 'columns.lossesTrailingFirst',
        }),
        lossesTwoGoalGames: defineMessage({
            defaultMessage: 'Loss 2 Goal Game',
            description: 'columns.lossesTwoGoalGames',
        }),
        majorPenalties: defineMessage({
            defaultMessage: 'Major',
            description: 'columns.majorPenalties',
        }),
        majors: defineMessage({
            defaultMessage: 'Major',
            description: 'columns.majors',
        }),
        matchPenalties: defineMessage({
            defaultMessage: 'Match',
            description: 'columns.matchPenalties',
        }),
        minorPenalties: defineMessage({
            defaultMessage: 'Minor',
            description: 'columns.minorPenalties',
        }),
        minors: defineMessage({
            defaultMessage: 'Minor',
            description: 'columns.minors',
        }),
        misconductPenalties: defineMessage({
            defaultMessage: 'Msct',
            description: 'columns.misconductPenalties',
        }),
        misconducts: defineMessage({
            defaultMessage: 'Msct',
            description: 'columns.misconducts',
        }),
        missedShotCrossbar: defineMessage({
            defaultMessage: 'MsS Cross',
            description: 'columns.missedShotCrossbar',
        }),
        missedShotGoalpost: defineMessage({
            defaultMessage: 'MsS Post',
            description: 'columns.missedShotGoalpost',
        }),
        missedShotOverNet: defineMessage({
            defaultMessage: 'MsS Over',
            description: 'columns.missedShotOverNet',
        }),
        missedShotShort: defineMessage({
            defaultMessage: 'MsS Short',
            description: 'columns.missedShotShort',
        }),
        missedShotWideOfNet: defineMessage({
            defaultMessage: 'MsS Wide',
            description: 'columns.missedShotWideOfNet',
        }),
        missedShots: defineMessage({
            defaultMessage: 'MsS',
            description: 'columns.missedShots',
        }),
        nationalityCode: defineMessage({
            defaultMessage: 'Ntnlty',
            description: 'columns.nationalityCode',
        }),
        netGoalsPerGame: defineMessage({
            defaultMessage: 'GD/GP',
            description: 'columns.netGoalsPerGame',
        }),
        netMinorPenaltiesPer60: defineMessage({
            defaultMessage: 'Net Minors/60',
            description: 'columns.netMinorPenaltiesPer60',
        }),
        netPenalties: defineMessage({
            defaultMessage: 'Net Pen',
            description: 'columns.netPenalties',
        }),
        netPenaltiesPer60: defineMessage({
            defaultMessage: 'Net Pen/60',
            description: 'columns.netPenaltiesPer60',
        }),
        netShotsPerGame: defineMessage({
            defaultMessage: 'SD/GP',
            description: 'columns.netShotsPerGame',
        }),
        neutralZoneFaceoffLosses: defineMessage({
            defaultMessage: 'NZ FOL',
            description: 'columns.neutralZoneFaceoffLosses',
        }),
        neutralZoneFaceoffPct: defineMessage({
            defaultMessage: 'NZ FOW%',
            description: 'columns.neutralZoneFaceoffPct',
        }),
        neutralZoneStartPct: defineMessage({
            defaultMessage: 'NZ Start%',
            description: 'Header for a column showing what percentage of zone starts came in the neutral zone',
        }),
        neutralZoneFaceoffWins: defineMessage({
            defaultMessage: 'NZ FOW',
            description: 'columns.neutralZoneFaceoffWins',
        }),
        neutralZoneFaceoffs: defineMessage({
            defaultMessage: 'NZ FO',
            description: 'columns.neutralZoneFaceoffs',
        }),
        offensiveZoneFaceoffLosses: defineMessage({
            defaultMessage: 'OZ FOL',
            description: 'columns.offensiveZoneFaceoffLosses',
        }),
        offensiveZoneFaceoffPct: defineMessage({
            defaultMessage: 'OZ FOW%',
            description: 'columns.offensiveZoneFaceoffPct',
        }),
        offensiveZoneStartRatio: defineMessage({
            defaultMessage: 'OZ Ratio',
            description: 'Header for a column showing what ratio of zone starts came in the offensive zone',
        }),
        offensiveZoneStartPct: defineMessage({
            defaultMessage: 'OZ Start%',
            description: 'Header for a column showing what percentage of zone starts came in the offensive zone',
        }),
        offensiveZoneFaceoffWins: defineMessage({
            defaultMessage: 'OZ FOW',
            description: 'columns.offensiveZoneFaceoffWins',
        }),
        offensiveZoneFaceoffs: defineMessage({
            defaultMessage: 'OZ FO',
            description: 'columns.offensiveZoneFaceoffs',
        }),
        offensiveZoneStartPct5v5: defineMessage({
            defaultMessage: 'OZ%',
            description: 'columns.offensiveZoneStartPct5v5',
        }),
        onIceGoalsAgainst: defineMessage({
            defaultMessage: 'GA',
            description: 'columns.onIceGoalsAgainst',
        }),
        onIceGoalsFor: defineMessage({
            defaultMessage: 'GF',
            description: 'columns.onIceGoalsFor',
        }),
        onIceShootingPct: defineMessage({
            defaultMessage: 'On-Ice S%',
            description: 'columns.onIceShootingPct',
        }),
        onIceShootingPct5v5: defineMessage({
            defaultMessage: 'On-Ice S%',
            description: 'columns.onIceShootingPct5v5',
        }),
        opponentTeamAbbrev: defineMessage({
            defaultMessage: 'Opp Team',
            description: 'columns.opponentTeamAbbrev',
        }),
        opportunities4v3: defineMessage({
            defaultMessage: '4v3 Opp',
            description: 'columns.opportunities4v3',
        }),
        opportunities5v3: defineMessage({
            defaultMessage: '5v3 Opp',
            description: 'columns.opportunities5v3',
        }),
        opportunities5v4: defineMessage({
            defaultMessage: '5v4 Opp',
            description: 'columns.opportunities5v4',
        }),
        otGoals: defineMessage({
            defaultMessage: 'OTG',
            description: 'columns.otGoals',
        }),
        otLossLeadPeriod1: defineMessage({
            defaultMessage: 'OT Loss Lead 1P',
            description: 'columns.otLossLeadPeriod1',
        }),
        otLossLeadPeriod2: defineMessage({
            defaultMessage: 'OT Loss Lead 2P',
            description: 'columns.otLossLeadPeriod2',
        }),
        otLossTrailPeriod1: defineMessage({
            defaultMessage: 'OT Loss Trail 1P',
            description: 'columns.otLossTrailPeriod1',
        }),
        otLossTrailPeriod2: defineMessage({
            defaultMessage: 'OT Loss Trail 2P',
            description: 'columns.otLossTrailPeriod2',
        }),
        otLosses: defineMessage({
            defaultMessage: 'OT',
            description: 'columns.otLosses',
        }),
        otLossesEvenShots: defineMessage({
            defaultMessage: 'OT Loss Even Shots',
            description: 'columns.otLossesEvenShots',
        }),
        otLossesOneGoalGames: defineMessage({
            defaultMessage: 'OT Loss 1 Goal Game',
            description: 'columns.otLossesOneGoalGames',
        }),
        otLossesOutshootOpponent: defineMessage({
            defaultMessage: 'OT Loss Outshoot Opp',
            description: 'columns.otLossesOutshootOpponent',
        }),
        otLossesOutshotByOpponent: defineMessage({
            defaultMessage: 'OT Loss Outshot by Opp',
            description: 'columns.otLossesOutshotByOpponent',
        }),
        otLossesScoringFirst: defineMessage({
            defaultMessage: 'OT SF',
            description: 'columns.otLossesScoringFirst',
        }),
        otLossesTrailingFirst: defineMessage({
            defaultMessage: 'OT TF',
            description: 'columns.otLossesTrailingFirst',
        }),
        otPoints: defineMessage({
            defaultMessage: 'OTP',
            description: 'columns.otPoints',
        }),
        otTimeOnIce: defineMessage({
            defaultMessage: 'OT TOI',
            description: 'columns.otTimeOnIce',
        }),
        otTimeOnIcePerOtGame: defineMessage({
            defaultMessage: 'OT TOI/OT GP',
            description: 'columns.otTimeOnIcePerOtGame',
        }),
        overallPenaltyKillPct: defineMessage({
            defaultMessage: 'PK%',
            description: 'columns.overallPenaltyKillPct',
        }),
        overallPowerPlayPct: defineMessage({
            defaultMessage: 'PP%',
            description: 'columns.overallPowerPlayPct',
        }),
        penalties: defineMessage({
            defaultMessage: 'Pen Taken',
            description: 'columns.penalties',
        }),
        penaltiesDrawn: defineMessage({
            defaultMessage: 'Pen Drawn',
            description: 'columns.penaltiesDrawn',
        }),
        penaltiesDrawnPer60: defineMessage({
            defaultMessage: 'Pen Drawn/60',
            description: 'columns.penaltiesDrawnPer60',
        }),
        penaltiesTakenPer60: defineMessage({
            defaultMessage: 'Pen Taken/60',
            description: 'columns.penaltiesTakenPer60',
        }),
        penaltyKillNetPct: defineMessage({
            defaultMessage: 'Net PK%',
            description: 'columns.penaltyKillNetPct',
        }),
        penaltyKillPct: defineMessage({
            defaultMessage: 'PK%',
            description: 'columns.penaltyKillPct',
        }),
        penaltyKillPct3v4: defineMessage({
            defaultMessage: 'PK% 3v4',
            description: 'columns.penaltyKillPct3v4',
        }),
        penaltyKillPct3v5: defineMessage({
            defaultMessage: 'PK% 3v5',
            description: 'columns.penaltyKillPct3v5',
        }),
        penaltyKillPct4v5: defineMessage({
            defaultMessage: 'PK% 4v5',
            description: 'columns.penaltyKillPct4v5',
        }),
        penaltyMinutes: defineMessage({
            defaultMessage: 'PIM',
            description: 'columns.penaltyMinutes',
        }),
        penaltyMinutesPerGame: defineMessage({
            defaultMessage: 'PIM/GP',
            description: 'columns.penaltyMinutesPerGame',
        }),
        penaltyMinutesPerTimeOnIce: defineMessage({
            defaultMessage: 'PIM/TOI%',
            description: 'columns.penaltyMinutesPerTimeOnIce',
        }),
        penaltySecondsPerGame: defineMessage({
            defaultMessage: 'PIM/GP',
            description: 'columns.penaltySecondsPerGame',
        }),
        penaltyShotAttempts: defineMessage({
            defaultMessage: 'PS Att',
            description: 'columns.penaltyShotAttempts',
        }),
        penaltyShotSavePct: defineMessage({
            defaultMessage: 'PS Sv%',
            description: 'columns.penaltyShotSavePct',
        }),
        penaltyShotShootingPct: defineMessage({
            defaultMessage: 'PS S%',
            description: 'columns.penaltyShotShootingPct',
        }),
        penaltyShotsAgainst: defineMessage({
            defaultMessage: 'PS SA',
            description: 'columns.penaltyShotsAgainst',
        }),
        penaltyShotsFailed: defineMessage({
            defaultMessage: 'PS F',
            description: 'columns.penaltyShotsFailed',
        }),
        penaltyShotsGoals: defineMessage({
            defaultMessage: 'PS G',
            description: 'columns.penaltyShotsGoals',
        }),
        penaltyShotsGoalsAgainst: defineMessage({
            defaultMessage: 'PS GA',
            description: 'columns.penaltyShotsGoalsAgainst',
        }),
        penaltyShotsSaves: defineMessage({
            defaultMessage: 'PS Svs',
            description: 'columns.penaltyShotsSaves',
        }),
        period1GoalsAgainst: defineMessage({
            defaultMessage: 'GA in P1',
            description: 'columns.period1GoalsAgainst',
        }),
        period1GoalsFor: defineMessage({
            defaultMessage: 'GF in P1',
            description: 'columns.period1GoalsFor',
        }),
        period2GoalsAgainst: defineMessage({
            defaultMessage: 'GA in P2',
            description: 'columns.period2GoalsAgainst',
        }),
        period2GoalsFor: defineMessage({
            defaultMessage: 'GF in P2',
            description: 'columns.period2GoalsFor',
        }),
        period3GoalsAgainst: defineMessage({
            defaultMessage: 'GA in P3',
            description: 'columns.period3GoalsAgainst',
        }),
        period3GoalsFor: defineMessage({
            defaultMessage: 'GF in P3',
            description: 'columns.period3GoalsFor',
        }),
        periodOtGoalsAgainst: defineMessage({
            defaultMessage: 'GA in OT',
            description: 'columns.periodOtGoalsAgainst',
        }),
        periodOtGoalsFor: defineMessage({
            defaultMessage: 'GF in OT',
            description: 'columns.periodOtGoalsFor',
        }),
        pkNetGoals: defineMessage({
            defaultMessage: 'SH GD',
            description: 'columns.pkNetGoals',
        }),
        pkNetGoalsPerGame: defineMessage({
            defaultMessage: 'SH GD/GP',
            description: 'columns.pkNetGoalsPerGame',
        }),
        pkPctg: defineMessage({
            defaultMessage: 'PK%',
            description: 'columns.pkPctg',
        }),
        pkTimeOnIcePerGame: defineMessage({
            defaultMessage: 'SH TOI/GP',
            description: 'columns.pkTimeOnIcePerGame',
        }),
        playerTeamsPlayedFor: defineMessage({
            defaultMessage: 'Team',
            description: 'columns.playerTeamsPlayedFor',
        }),
        plusMinus: defineMessage({
            defaultMessage: '+/-',
            description: 'columns.plusMinus',
        }),
        pointPct: defineMessage({
            defaultMessage: 'P%',
            description: 'columns.pointPct',
        }),
        points: defineMessage({
            defaultMessage: 'P',
            description: 'columns.points',
        }),
        points5v5: defineMessage({
            defaultMessage: 'P',
            description: 'columns.points5v5',
        }),
        pointsPct: defineMessage({
            defaultMessage: 'P%',
            description: 'columns.pointsPct',
        }),
        pointsPer605v5: defineMessage({
            defaultMessage: 'P/60',
            description: 'columns.pointsPer605v5',
        }),
        pointsPerGame: defineMessage({
            defaultMessage: 'P/GP',
            description: 'columns.pointsPerGame',
        }),
        positionCode: defineMessage({
            defaultMessage: 'Pos',
            description: 'columns.positionCode',
        }),
        powerPlayGoalFor: defineMessage({
            defaultMessage: 'On-Ice PP GF',
            description: 'columns.powerPlayGoalFor',
        }),
        powerPlayGoalsAgainst: defineMessage({
            defaultMessage: 'On-Ice PP GA',
            description: 'columns.powerPlayGoalsAgainst',
        }),
        powerPlayGoalsFor: defineMessage({
            defaultMessage: 'PP GF',
            description: 'columns.powerPlayGoalsFor',
        }),
        powerPlayNetPct: defineMessage({
            defaultMessage: 'Net PP%',
            description: 'columns.powerPlayNetPct',
        }),
        powerPlayPct: defineMessage({
            defaultMessage: 'PP%',
            description: 'columns.powerPlayPct',
        }),
        powerPlayPct4v3: defineMessage({
            defaultMessage: '4v3 PP %',
            description: 'columns.powerPlayPct4v3',
        }),
        powerPlayPct5v3: defineMessage({
            defaultMessage: '5v3 PP %',
            description: 'columns.powerPlayPct5v3',
        }),
        powerPlayPct5v4: defineMessage({
            defaultMessage: '5v4 PP %',
            description: 'columns.powerPlayPct5v4',
        }),
        powerPlayTimeOnIcePerGame: defineMessage({
            defaultMessage: 'PP TOI/GP',
            description: 'columns.powerPlayTimeOnIcePerGame',
        }),
        ppAssists: defineMessage({
            defaultMessage: 'PPA',
            description: 'columns.ppAssists',
        }),
        ppFaceoffPct: defineMessage({
            defaultMessage: 'PP FOW%',
            description: 'columns.ppFaceoffPct',
        }),
        ppFaceoffs: defineMessage({
            defaultMessage: 'PP FO',
            description: 'columns.ppFaceoffs',
        }),
        ppFaceoffsLost: defineMessage({
            defaultMessage: 'PP FOL',
            description: 'columns.ppFaceoffsLost',
        }),
        ppFaceoffsWon: defineMessage({
            defaultMessage: 'PP FOW',
            description: 'columns.ppFaceoffsWon',
        }),
        ppGoals: defineMessage({
            defaultMessage: 'PPG',
            description: 'columns.ppGoals',
        }),
        ppGoalsAgainst: defineMessage({
            defaultMessage: 'PP GA',
            description: 'columns.ppGoalsAgainst',
        }),
        ppGoalsAgainstPer60: defineMessage({
            defaultMessage: 'PP GA/60',
            description: 'columns.ppGoalsAgainstPer60',
        }),
        ppGoalsAgainstPerGame: defineMessage({
            defaultMessage: 'PP GA/GP',
            description: 'columns.ppGoalsAgainstPerGame',
        }),
        ppGoalsFor: defineMessage({
            defaultMessage: 'PP GF',
            description: 'columns.ppGoalsFor',
        }),
        ppGoalsForPer60: defineMessage({
            defaultMessage: 'PP GF/60',
            description: 'columns.ppGoalsForPer60',
        }),
        ppGoalsPer60: defineMessage({
            defaultMessage: 'PPG/60',
            description: 'columns.ppGoalsPer60',
        }),
        ppGoalsPerGame: defineMessage({
            defaultMessage: 'PP GF/GP',
            description: 'columns.ppGoalsPerGame',
        }),
        ppIndividualSatFor: defineMessage({
            defaultMessage: 'PP iSAT',
            description: 'columns.ppIndividualSatFor',
        }),
        ppIndividualSatForPer60: defineMessage({
            defaultMessage: 'PP iSAT/60',
            description: 'columns.ppIndividualSatForPer60',
        }),
        ppNetGoals: defineMessage({
            defaultMessage: 'PP GD',
            description: 'columns.ppNetGoals',
        }),
        ppNetGoalsPerGame: defineMessage({
            defaultMessage: 'PP GD/GP',
            description: 'columns.ppNetGoalsPerGame',
        }),
        ppOpportunities: defineMessage({
            defaultMessage: 'PP Opp',
            description: 'columns.ppOpportunities',
        }),
        ppOpportunitiesPerGame: defineMessage({
            defaultMessage: 'PP Opp/GP',
            description: 'columns.ppOpportunitiesPerGame',
        }),
        ppPctg: defineMessage({
            defaultMessage: 'PP%',
            description: 'columns.ppPctg',
        }),
        ppPoints: defineMessage({
            defaultMessage: 'PPP',
            description: 'columns.ppPoints',
        }),
        ppPointsPer60: defineMessage({
            defaultMessage: 'PPP/60',
            description: 'columns.ppPointsPer60',
        }),
        ppPrimaryAssists: defineMessage({
            defaultMessage: 'PPA1',
            description: 'columns.ppPrimaryAssists',
        }),
        ppPrimaryAssistsPer60: defineMessage({
            defaultMessage: 'PPA1/60',
            description: 'columns.ppPrimaryAssistsPer60',
        }),
        ppSavePct: defineMessage({
            defaultMessage: 'PP Sv%',
            description: 'columns.ppSavePct',
        }),
        ppSaves: defineMessage({
            defaultMessage: 'PP Svs',
            description: 'columns.ppSaves',
        }),
        ppSecondaryAssists: defineMessage({
            defaultMessage: 'PPA2',
            description: 'columns.ppSecondaryAssists',
        }),
        ppSecondaryAssistsPer60: defineMessage({
            defaultMessage: 'PPA2/60',
            description: 'columns.ppSecondaryAssistsPer60',
        }),
        ppShootingPct: defineMessage({
            defaultMessage: 'PP S%',
            description: 'columns.ppShootingPct',
        }),
        ppShots: defineMessage({
            defaultMessage: 'PP Shots',
            description: 'columns.ppShots',
        }),
        ppShotsAgainst: defineMessage({
            defaultMessage: 'PP SA',
            description: 'columns.ppShotsAgainst',
        }),
        ppShotsPer60: defineMessage({
            defaultMessage: 'PP S/60',
            description: 'columns.ppShotsPer60',
        }),
        ppTimeOnIce: defineMessage({
            defaultMessage: 'PP TOI',
            description: 'columns.ppTimeOnIce',
        }),
        ppTimeOnIcePctPerGame: defineMessage({
            defaultMessage: 'PP TOI%',
            description: 'columns.ppTimeOnIcePctPerGame',
        }),
        ppTimeOnIcePerGame: defineMessage({
            defaultMessage: 'PP TOI/GP',
            description: 'columns.ppTimeOnIcePerGame',
        }),
        primaryAssists5v5: defineMessage({
            defaultMessage: 'A1',
            description: 'columns.primaryAssists5v5',
        }),
        primaryAssistsPer605v5: defineMessage({
            defaultMessage: 'A1/60',
            description: 'columns.primaryAssistsPer605v5',
        }),
        primaryAssistsPerGame: defineMessage({
            defaultMessage: 'A1/GP',
            description: 'columns.primaryAssistsPerGame',
        }),
        qualityStart: defineMessage({
            defaultMessage: 'GS > .900',
            description: 'columns.qualityStart',
        }),
        qualityStartsPct: defineMessage({
            defaultMessage: 'GS > .900 %',
            description: 'columns.qualityStartsPct',
        }),
        regulationAndOtWins: defineMessage({
            defaultMessage: 'ROW',
            description: 'columns.regulationAndOtWins',
        }),
        regulationLosses: defineMessage({
            defaultMessage: 'ROL',
            description: 'columns.regulationLosses',
        }),
        regulationWins: defineMessage({
            defaultMessage: 'ROW',
            description: 'columns.regulationWins',
        }),
        satAgainst: defineMessage({
            defaultMessage: 'SAT Agst',
            description: 'columns.satAgainst',
        }),
        satAhead: defineMessage({
            defaultMessage: 'SAT Ahead',
            description: 'columns.satAhead',
        }),
        satBehind: defineMessage({
            defaultMessage: 'SAT Behind',
            description: 'columns.satBehind',
        }),
        satClose: defineMessage({
            defaultMessage: 'SAT Close',
            description: 'columns.satClose',
        }),
        satFor: defineMessage({
            defaultMessage: 'SAT For',
            description: 'columns.satFor',
        }),
        satPct: defineMessage({
            defaultMessage: 'SAT%',
            description: 'columns.satPct',
        }),
        satPctAhead: defineMessage({
            defaultMessage: 'SAT% Ahead',
            description: 'columns.satPctAhead',
        }),
        satPctBehind: defineMessage({
            defaultMessage: 'SAT% Behind',
            description: 'columns.satPctBehind',
        }),
        satPctClose: defineMessage({
            defaultMessage: 'SAT% Close',
            description: 'columns.satPctClose',
        }),
        satPctTied: defineMessage({
            defaultMessage: 'SAT% Tied',
            description: 'columns.satPctTied',
        }),
        satPercentage: defineMessage({
            defaultMessage: 'SAT%',
            description: 'columns.satPercentage',
        }),
        satPercentageAhead: defineMessage({
            defaultMessage: 'SAT% Ahead',
            description: 'columns.satPercentageAhead',
        }),
        satPercentageBehind: defineMessage({
            defaultMessage: 'SAT% Behind',
            description: 'columns.satPercentageBehind',
        }),
        satPercentageClose: defineMessage({
            defaultMessage: 'SAT% Close',
            description: 'columns.satPercentageClose',
        }),
        satPercentageTied: defineMessage({
            defaultMessage: 'SAT% Tied',
            description: 'columns.satPercentageTied',
        }),
        satRelative: defineMessage({
            defaultMessage: 'SAT% Relative',
            description: 'columns.satRelative',
        }),
        satRelative5v5: defineMessage({
            defaultMessage: 'SAT Rel%',
            description: 'columns.satRelative5v5',
        }),
        satTied: defineMessage({
            defaultMessage: 'SAT Tied',
            description: 'columns.satTied',
        }),
        satTotal: defineMessage({
            defaultMessage: 'SAT',
            description: 'columns.satTotal',
        }),
        savePct: defineMessage({
            defaultMessage: 'Sv%',
            description: 'columns.savePct',
        }),
        savePct5v5: defineMessage({
            defaultMessage: '5v5 Sv%',
            description: 'columns.savePct5v5',
        }),
        savePctDaysRest0: defineMessage({
            defaultMessage: '0 Days Sv%',
            description: 'columns.savePctDaysRest0',
        }),
        savePctDaysRest1: defineMessage({
            defaultMessage: '1 Days Sv%',
            description: 'columns.savePctDaysRest1',
        }),
        savePctDaysRest2: defineMessage({
            defaultMessage: '2 Days Sv%',
            description: 'columns.savePctDaysRest2',
        }),
        savePctDaysRest3: defineMessage({
            defaultMessage: '3 Days Sv%',
            description: 'columns.savePctDaysRest3',
        }),
        savePctDaysRest4Plus: defineMessage({
            defaultMessage: '4+ Days Sv%',
            description: 'columns.savePctDaysRest4Plus',
        }),
        saves: defineMessage({
            defaultMessage: 'Svs',
            description: 'columns.saves',
        }),
        scoringFirstGamesPlayed: defineMessage({
            defaultMessage: 'SF GP',
            description: 'columns.scoringFirstGamesPlayed',
        }),
        seasonId: defineMessage({
            defaultMessage: 'Season',
            description: 'columns.seasonId',
        }),
        secondaryAssists5v5: defineMessage({
            defaultMessage: 'A2',
            description: 'columns.secondaryAssists5v5',
        }),
        secondaryAssistsPer605v5: defineMessage({
            defaultMessage: 'A2/60',
            description: 'columns.secondaryAssistsPer605v5',
        }),
        secondaryAssistsPerGame: defineMessage({
            defaultMessage: 'A2/GP',
            description: 'columns.secondaryAssistsPerGame',
        }),
        shAssists: defineMessage({
            defaultMessage: 'SHA',
            description: 'columns.shAssists',
        }),
        shFaceoffPct: defineMessage({
            defaultMessage: 'SH FOW%',
            description: 'columns.shFaceoffPct',
        }),
        shFaceoffs: defineMessage({
            defaultMessage: 'SH FO',
            description: 'columns.shFaceoffs',
        }),
        shFaceoffsLost: defineMessage({
            defaultMessage: 'SH FOL',
            description: 'columns.shFaceoffsLost',
        }),
        shFaceoffsWon: defineMessage({
            defaultMessage: 'SH FOW',
            description: 'columns.shFaceoffsWon',
        }),
        shGoals: defineMessage({
            defaultMessage: 'SHG',
            description: 'columns.shGoals',
        }),
        shGoalsAgainst: defineMessage({
            defaultMessage: 'SH GA',
            description: 'columns.shGoalsAgainst',
        }),
        shGoalsAgainstPerGame: defineMessage({
            defaultMessage: 'SH GA/GP',
            description: 'columns.shGoalsAgainstPerGame',
        }),
        shGoalsFor: defineMessage({
            defaultMessage: 'SH GF',
            description: 'columns.shGoalsFor',
        }),
        shGoalsForPerGame: defineMessage({
            defaultMessage: 'SH GF/GP',
            description: 'columns.shGoalsForPerGame',
        }),
        shGoalsPer60: defineMessage({
            defaultMessage: 'SHG/60',
            description: 'columns.shGoalsPer60',
        }),
        shIndividualSatFor: defineMessage({
            defaultMessage: 'SH iSAT',
            description: 'columns.shIndividualSatFor',
        }),
        shIndividualSatForPer60: defineMessage({
            defaultMessage: 'SH iSAT/60',
            description: 'columns.shIndividualSatForPer60',
        }),
        shNumTimes: defineMessage({
            defaultMessage: 'TS',
            description: 'columns.shNumTimes',
        }),
        shPoints: defineMessage({
            defaultMessage: 'SHP',
            description: 'columns.shPoints',
        }),
        shPointsPer60: defineMessage({
            defaultMessage: 'SHP/60',
            description: 'columns.shPointsPer60',
        }),
        shPrimaryAssists: defineMessage({
            defaultMessage: 'SHA1',
            description: 'columns.shPrimaryAssists',
        }),
        shPrimaryAssistsPer60: defineMessage({
            defaultMessage: 'SHA1/60',
            description: 'columns.shPrimaryAssistsPer60',
        }),
        shSavePct: defineMessage({
            defaultMessage: 'SH Sv%',
            description: 'columns.shSavePct',
        }),
        shSaves: defineMessage({
            defaultMessage: 'SH Svs',
            description: 'columns.shSaves',
        }),
        shSecondaryAssists: defineMessage({
            defaultMessage: 'SHA2',
            description: 'columns.shSecondaryAssists',
        }),
        shSecondaryAssistsPer60: defineMessage({
            defaultMessage: 'SHA2/60',
            description: 'columns.shSecondaryAssistsPer60',
        }),
        shShootingPct: defineMessage({
            defaultMessage: 'SH S%',
            description: 'columns.shShootingPct',
        }),
        shShots: defineMessage({
            defaultMessage: 'SH Shots',
            description: 'columns.shShots',
        }),
        shShotsAgainst: defineMessage({
            defaultMessage: 'SH SA',
            description: 'columns.shShotsAgainst',
        }),
        shShotsPer60: defineMessage({
            defaultMessage: 'SH S/60',
            description: 'columns.shShotsPer60',
        }),
        shTimeOnIce: defineMessage({
            defaultMessage: 'SH TOI',
            description: 'columns.shTimeOnIce',
        }),
        shTimeOnIcePctPerGame: defineMessage({
            defaultMessage: 'SH TOI%',
            description: 'columns.shTimeOnIcePctPerGame',
        }),
        shTimeOnIcePerGame: defineMessage({
            defaultMessage: 'SH TOI/GP',
            description: 'columns.shTimeOnIcePerGame',
        }),
        shifts: defineMessage({
            defaultMessage: 'Shifts',
            description: 'columns.shifts',
        }),
        shiftsPerGame: defineMessage({
            defaultMessage: 'Shifts/GP',
            description: 'columns.shiftsPerGame',
        }),
        shootingPct: defineMessage({
            defaultMessage: 'S%',
            description: 'columns.shootingPct',
        }),
        shootingPct5v5: defineMessage({
            defaultMessage: '5v5 S%',
            description: 'columns.shootingPct5v5',
        }),
        shootingPctBackhand: defineMessage({
            defaultMessage: 'S% Back',
            description: 'columns.shootingPctBackhand',
        }),
        shootingPctBat: defineMessage({
            defaultMessage: 'S% Bat',
            description: 'An abbreviation that describes a players batted in shooting percentage',
        }),
        shootingPctBetweenLegs: defineMessage({
            defaultMessage: 'S% Legs',
            description:
                'An abbreviation that describes a players shooting percentage when the shot is between their legs',
        }),
        shootingPctCradle: defineMessage({
            defaultMessage: 'S% Cradle',
            description: 'An abbreviation that describes a players shooting percentage when the shot is cradled',
        }),
        shootingPctDeflected: defineMessage({
            defaultMessage: 'S% Dflct',
            description: 'columns.shootingPctDeflected',
        }),
        shootingPctPoke: defineMessage({
            defaultMessage: 'S% Poke',
            description: 'An abbreviation that describes a players shooting percentage when the shot is poked',
        }),
        shootingPctSlap: defineMessage({
            defaultMessage: 'S% Slap',
            description: 'columns.shootingPctSlap',
        }),
        shootingPctSnap: defineMessage({
            defaultMessage: 'S% Snap',
            description: 'columns.shootingPctSnap',
        }),
        shootingPctTipIn: defineMessage({
            defaultMessage: 'S% Tip',
            description: 'columns.shootingPctTipIn',
        }),
        shootingPctWrapAround: defineMessage({
            defaultMessage: 'S% Wrap',
            description: 'columns.shootingPctWrapAround',
        }),
        shootingPctWrist: defineMessage({
            defaultMessage: 'S% Wrist',
            description: 'columns.shootingPctWrist',
        }),
        shootingPctg: defineMessage({
            defaultMessage: 'S%',
            description: 'columns.shootingPctg',
        }),
        shootingPlusSavePct5v5: defineMessage({
            defaultMessage: '5v5 S%+Sv%',
            description: 'columns.shootingPlusSavePct5v5',
        }),
        shootoutGameDecidingGoals: defineMessage({
            defaultMessage: 'GDG',
            description: 'columns.shootoutGameDecidingGoals',
        }),
        shootoutGamesPlayed: defineMessage({
            defaultMessage: 'S/O GP',
            description: 'columns.shootoutGamesPlayed',
        }),
        shootoutGoals: defineMessage({
            defaultMessage: 'S/O Goals',
            description: 'columns.shootoutGoals',
        }),
        shootoutGoalsAgainst: defineMessage({
            defaultMessage: 'S/O GA',
            description: 'columns.shootoutGoalsAgainst',
        }),
        shootoutLosses: defineMessage({
            defaultMessage: 'S/O Losses',
            description: 'columns.shootoutLosses',
        }),
        shootoutPoints: defineMessage({
            defaultMessage: 'S/O Points',
            description: 'columns.shootoutPoints',
        }),
        shootoutSavePct: defineMessage({
            defaultMessage: 'S/O Sv%',
            description: 'columns.shootoutSavePct',
        }),
        shootoutSaves: defineMessage({
            defaultMessage: 'S/O Saves',
            description: 'columns.shootoutSaves',
        }),
        shootoutShootingPct: defineMessage({
            defaultMessage: 'S/O S%',
            description: 'columns.shootoutShootingPct',
        }),
        shootoutShootingPlusSavePct: defineMessage({
            defaultMessage: 'S/O S%+Sv%',
            description: 'columns.shootoutShootingPlusSavePct',
        }),
        shootoutShots: defineMessage({
            defaultMessage: 'S/O Shots',
            description: 'columns.shootoutShots',
        }),
        shootoutShotsAgainst: defineMessage({
            defaultMessage: 'S/O SA',
            description: 'columns.shootoutShotsAgainst',
        }),
        shootoutWinPct: defineMessage({
            defaultMessage: 'S/O W%',
            description: 'columns.shootoutWinPct',
        }),
        shootoutWins: defineMessage({
            defaultMessage: 'S/O Wins',
            description: 'columns.shootoutWins',
        }),
        shootsCatches: defineMessage({
            defaultMessage: 'S/C',
            description: 'columns.shootsCatches',
        }),
        shortHandedGoalsAgainst: defineMessage({
            defaultMessage: 'On-Ice SH GA',
            description: 'columns.shortHandedGoalsAgainst',
        }),
        shortHandedGoalsFor: defineMessage({
            defaultMessage: 'On-Ice SH GF',
            description: 'columns.shortHandedGoalsFor',
        }),
        shortHandedTimeOnIcePerGame: defineMessage({
            defaultMessage: 'SH TOI/GP',
            description: 'columns.shortHandedTimeOnIcePerGame',
        }),
        shorthandedGoalsAgainst: defineMessage({
            defaultMessage: 'SH GA',
            description: 'columns.shorthandedGoalsAgainst',
        }),
        shotAttemptsBlocked: defineMessage({
            defaultMessage: 'A/B',
            description:
                'An abbreviation for Attempts blocked. An attempt blocked is recorded for a player taking a shot attempt when the shot attempt deemed blocked',
        }),
        shotDifferentialPerGame: defineMessage({
            defaultMessage: 'SD/GP',
            description: 'columns.shotDifferentialPerGame',
        }),
        shots: defineMessage({
            defaultMessage: 'S',
            description: 'columns.shots',
        }),
        shots5v5: defineMessage({
            defaultMessage: 'Shots',
            description: 'columns.shots5v5',
        }),
        shotsAgainst: defineMessage({
            defaultMessage: 'SA',
            description: 'columns.shotsAgainst',
        }),
        shotsAgainstPer60: defineMessage({
            defaultMessage: 'SA/60',
            description: 'columns.shotsAgainstPer60',
        }),
        shotsAgainstPerGame: defineMessage({
            defaultMessage: 'SA/GP',
            description: 'columns.shotsAgainstPerGame',
        }),
        shotsFor: defineMessage({
            defaultMessage: 'SF',
            description: 'columns.shotsFor',
        }),
        shotsForPerGame: defineMessage({
            defaultMessage: 'Shots/GP',
            description: 'columns.shotsForPerGame',
        }),
        shotsOnNet: defineMessage({
            defaultMessage: 'S',
            description: 'columns.shotsOnNet',
        }),
        shotsOnNetBackhand: defineMessage({
            defaultMessage: 'S Back',
            description: 'columns.shotsOnNetBackhand',
        }),
        shotsOnNetBat: defineMessage({
            defaultMessage: 'S Bat',
            description: 'An abbreviation that describes how many shots a player batted in on net',
        }),
        shotsOnNetBetweenLegs: defineMessage({
            defaultMessage: 'S Legs',
            description: 'An abbreviation that describes how many shots a player has between their legs',
        }),
        shotsOnNetCradle: defineMessage({
            defaultMessage: 'S Cradle',
            description: 'An abbreviation that describes how many shots a player cradled in on net',
        }),
        shotsOnNetDeflected: defineMessage({
            defaultMessage: 'S Dflct',
            description: 'columns.shotsOnNetDeflected',
        }),
        shotsOnNetPoke: defineMessage({
            defaultMessage: 'S Poke',
            description: 'An abbreviation that describes how many shots a player pokes toward the net',
        }),
        shotsOnNetSlap: defineMessage({
            defaultMessage: 'S Slap',
            description: 'columns.shotsOnNetSlap',
        }),
        shotsOnNetSnap: defineMessage({
            defaultMessage: 'S Snap',
            description: 'columns.shotsOnNetSnap',
        }),
        shotsOnNetTipIn: defineMessage({
            defaultMessage: 'S Tip',
            description: 'columns.shotsOnNetTipIn',
        }),
        shotsOnNetWrapAround: defineMessage({
            defaultMessage: 'S Wrap',
            description: 'columns.shotsOnNetWrapAround',
        }),
        shotsOnNetWrist: defineMessage({
            defaultMessage: 'S Wrist',
            description: 'columns.shotsOnNetWrist',
        }),
        shotsPerGame: defineMessage({
            defaultMessage: 'S/GP',
            description: 'columns.shotsPerGame',
        }),
        shutouts: defineMessage({
            defaultMessage: 'SO',
            description: 'columns.shutouts',
        }),
        skaterFullName: defineMessage({
            defaultMessage: 'Player',
            description: 'columns.skaterFullName',
        }),
        skaterSavePct5v5: defineMessage({
            defaultMessage: 'On-Ice Sv%',
            description: 'columns.skaterSavePct5v5',
        }),
        skaterShootingPlusSavePct5v5: defineMessage({
            defaultMessage: 'On-Ice S%+Sv%',
            description: 'columns.skaterShootingPlusSavePct5v5',
        }),
        takeaways: defineMessage({
            defaultMessage: 'TkA',
            description: 'columns.takeaways',
        }),
        takeawaysPer60: defineMessage({
            defaultMessage: 'TkA/60',
            description: 'columns.takeawaysPer60',
        }),
        teamAbbrev: defineMessage({
            defaultMessage: 'Team',
            description: 'columns.teamAbbrev',
        }),
        teamAbbrevs: defineMessage({
            defaultMessage: 'Team',
            description: 'columns.teamAbbrevs',
        }),
        teamFullName: defineMessage({
            defaultMessage: 'Team',
            description: 'columns.teamFullName',
        }),
        teamShutouts: defineMessage({
            defaultMessage: 'SO',
            description: 'Short for Team Shutouts: the number of games in which a team did not concede any goals to their opponent',
        }),
        ties: defineMessage({
            defaultMessage: 'T',
            description: 'columns.ties',
        }),
        tiesEvenShots: defineMessage({
            defaultMessage: 'Ties Even Shots',
            description: 'columns.tiesEvenShots',
        }),
        tiesLeadPeriod1: defineMessage({
            defaultMessage: 'Ties Lead 1P',
            description: 'columns.tiesLeadPeriod1',
        }),
        tiesLeadPeriod2: defineMessage({
            defaultMessage: 'Ties Lead 2P',
            description: 'columns.tiesLeadPeriod2',
        }),
        tiesOutshootOpponent: defineMessage({
            defaultMessage: 'Ties Outshoot Opp',
            description: 'columns.tiesOutshootOpponent',
        }),
        tiesOutshotByOpponent: defineMessage({
            defaultMessage: 'Ties Outshot by Opp',
            description: 'columns.tiesOutshotByOpponent',
        }),
        tiesScoringFirst: defineMessage({
            defaultMessage: 'T SF',
            description: 'columns.tiesScoringFirst',
        }),
        tiesTrailPeriod1: defineMessage({
            defaultMessage: 'Ties Trail 1P',
            description: 'columns.tiesTrailPeriod1',
        }),
        tiesTrailPeriod2: defineMessage({
            defaultMessage: 'Ties Trail 2P',
            description: 'columns.tiesTrailPeriod2',
        }),
        tiesTrailingFirst: defineMessage({
            defaultMessage: 'T TF',
            description: 'columns.tiesTrailingFirst',
        }),
        timeOnIce: defineMessage({
            defaultMessage: 'TOI',
            description: 'columns.timeOnIce',
        }),
        timeOnIce3v4: defineMessage({
            defaultMessage: 'TOI 3v4',
            description: 'columns.timeOnIce3v4',
        }),
        timeOnIce3v5: defineMessage({
            defaultMessage: 'TOI 3v5',
            description: 'columns.timeOnIce3v5',
        }),
        timeOnIce4v3: defineMessage({
            defaultMessage: '4v3 TOI',
            description: 'columns.timeOnIce4v3',
        }),
        timeOnIce4v5: defineMessage({
            defaultMessage: 'TOI 4v5',
            description: 'columns.timeOnIce4v5',
        }),
        timeOnIce5v3: defineMessage({
            defaultMessage: '5v3 TOI',
            description: 'columns.timeOnIce5v3',
        }),
        timeOnIce5v4: defineMessage({
            defaultMessage: '5v4 TOI',
            description: 'columns.timeOnIce5v4',
        }),
        timeOnIcePerGame: defineMessage({
            defaultMessage: 'TOI/GP',
            description: 'columns.timeOnIcePerGame',
        }),
        timeOnIcePerGame5v5: defineMessage({
            defaultMessage: 'TOI/GP',
            description: 'columns.timeOnIcePerGame5v5',
        }),
        timeOnIcePerShift: defineMessage({
            defaultMessage: 'TOI/Shift',
            description: 'columns.timeOnIcePerShift',
        }),
        timeOnIcePp: defineMessage({
            defaultMessage: 'PP TOI',
            description: 'columns.timeOnIcePp',
        }),
        timeOnIceShorthanded: defineMessage({
            defaultMessage: 'SH TOI',
            description: 'columns.timeOnIceShorthanded',
        }),
        timesShorthanded: defineMessage({
            defaultMessage: 'TS',
            description: 'columns.timesShorthanded',
        }),
        timesShorthanded3v4: defineMessage({
            defaultMessage: 'TS 3v4',
            description: 'columns.timesShorthanded3v4',
        }),
        timesShorthanded3v5: defineMessage({
            defaultMessage: 'TS 3v5',
            description: 'columns.timesShorthanded3v5',
        }),
        timesShorthanded4v5: defineMessage({
            defaultMessage: 'TS 4v5',
            description: 'columns.timesShorthanded4v5',
        }),
        timesShorthandedPerGame: defineMessage({
            defaultMessage: 'TS/GP',
            description: 'columns.timesShorthandedPerGame',
        }),
        totalFaceoffLosses: defineMessage({
            defaultMessage: 'FOL',
            description: 'columns.totalFaceoffLosses',
        }),
        totalFaceoffWins: defineMessage({
            defaultMessage: 'FOW',
            description: 'columns.totalFaceoffWins',
        }),
        totalFaceoffs: defineMessage({
            defaultMessage: 'FO',
            description: 'columns.totalFaceoffs',
        }),
        totalPenaltiesDrawn: defineMessage({
            defaultMessage: 'Pen Drawn',
            description: 'columns.totalPenaltiesDrawn',
        }),
        totalPrimaryAssists: defineMessage({
            defaultMessage: 'A1',
            description: 'columns.totalPrimaryAssists',
        }),
        totalSecondaryAssists: defineMessage({
            defaultMessage: 'A2',
            description: 'columns.totalSecondaryAssists',
        }),
        trailingFirstGamesPlayed: defineMessage({
            defaultMessage: 'TF GP',
            description: 'columns.trailingFirstGamesPlayed',
        }),
        usatAgainst: defineMessage({
            defaultMessage: 'USAT Agst',
            description: 'columns.usatAgainst',
        }),
        usatAhead: defineMessage({
            defaultMessage: 'USAT Ahead',
            description: 'columns.usatAhead',
        }),
        usatBehind: defineMessage({
            defaultMessage: 'USAT Behind',
            description: 'columns.usatBehind',
        }),
        usatClose: defineMessage({
            defaultMessage: 'USAT Close',
            description: 'columns.usatClose',
        }),
        usatFor: defineMessage({
            defaultMessage: 'USAT For',
            description: 'columns.usatFor',
        }),
        usatPct: defineMessage({
            defaultMessage: 'USAT %',
            description: 'columns.usatPct',
        }),
        usatPctAhead: defineMessage({
            defaultMessage: 'USAT% Ahead',
            description: 'columns.usatPctAhead',
        }),
        usatPctBehind: defineMessage({
            defaultMessage: 'USAT% Behind',
            description: 'columns.usatPctBehind',
        }),
        usatPctClose: defineMessage({
            defaultMessage: 'USAT% Close',
            description: 'columns.usatPctClose',
        }),
        usatPctTied: defineMessage({
            defaultMessage: 'USAT% Tied',
            description: 'columns.usatPctTied',
        }),
        usatPercentage: defineMessage({
            defaultMessage: 'USAT%',
            description: 'columns.usatPercentage',
        }),
        usatPercentageAhead: defineMessage({
            defaultMessage: 'USAT% Ahead',
            description: 'columns.usatPercentageAhead',
        }),
        usatPercentageBehind: defineMessage({
            defaultMessage: 'USAT% Behind',
            description: 'columns.usatPercentageBehind',
        }),
        usatPercentageTied: defineMessage({
            defaultMessage: 'USAT% Tied',
            description: 'columns.usatPercentageTied',
        }),
        usatPrecentageClose: defineMessage({
            defaultMessage: 'USAT% Close',
            description: 'columns.usatPrecentageClose',
        }),
        usatRelative: defineMessage({
            defaultMessage: 'USAT% Relative',
            description: 'columns.usatRelative',
        }),
        usatTied: defineMessage({
            defaultMessage: 'USAT Tied',
            description: 'columns.usatTied',
        }),
        usatTotal: defineMessage({
            defaultMessage: 'USAT',
            description: 'columns.usatTotal',
        }),
        weight: defineMessage({
            defaultMessage: 'Wt',
            description: 'columns.weight',
        }),
        winPctLeadPeriod1: defineMessage({
            defaultMessage: 'Win% Lead 1P',
            description: 'columns.winPctLeadPeriod1',
        }),
        winPctLeadPeriod2: defineMessage({
            defaultMessage: 'Win% Lead 2P',
            description: 'columns.winPctLeadPeriod2',
        }),
        winPctOneGoalGames: defineMessage({
            defaultMessage: 'Win% 1 Goal Game',
            description: 'columns.winPctOneGoalGames',
        }),
        winPctScoringFirst: defineMessage({
            defaultMessage: 'W% SF',
            description: 'columns.winPctScoringFirst',
        }),
        winPctThreeGoalGames: defineMessage({
            defaultMessage: 'Win% 3 Goal Game',
            description: 'columns.winPctThreeGoalGames',
        }),
        winPctTrailPeriod1: defineMessage({
            defaultMessage: 'Win% Trail 1P',
            description: 'columns.winPctTrailPeriod1',
        }),
        winPctTrailPeriod2: defineMessage({
            defaultMessage: 'Win% Trail 2P',
            description: 'columns.winPctTrailPeriod2',
        }),
        winPctTrailingFirst: defineMessage({
            defaultMessage: 'W% TF',
            description: 'columns.winPctTrailingFirst',
        }),
        winPctTwoGoalGames: defineMessage({
            defaultMessage: 'Win% 2 Goal Game',
            description: 'columns.winPctTwoGoalGames',
        }),
        wins: defineMessage({
            defaultMessage: 'W',
            description: 'columns.wins',
        }),
        winsEvenShots: defineMessage({
            defaultMessage: 'Wins Even Shots',
            description: 'columns.winsEvenShots',
        }),
        winsInRegulation: defineMessage({
            defaultMessage: 'RW',
            description: 'columns.winsInRegulation',
        }),
        winsInShootout: defineMessage({
            defaultMessage: 'S/O Win',
            description: 'columns.winsInShootout',
        }),
        winsLeadPeriod1: defineMessage({
            defaultMessage: 'Wins Lead 1P',
            description: 'columns.winsLeadPeriod1',
        }),
        winsLeadPeriod2: defineMessage({
            defaultMessage: 'Wins Lead 2P',
            description: 'columns.winsLeadPeriod2',
        }),
        winsOneGoalGames: defineMessage({
            defaultMessage: 'Wins 1 Goal Game',
            description: 'columns.winsOneGoalGames',
        }),
        winsOutshootOpponent: defineMessage({
            defaultMessage: 'Wins Outshoot Opp',
            description: 'columns.winsOutshootOpponent',
        }),
        winsOutshotByOpponent: defineMessage({
            defaultMessage: 'Wins Outshot by Opp',
            description: 'columns.winsOutshotByOpponent',
        }),
        winsScoringFirst: defineMessage({
            defaultMessage: 'W SF',
            description: 'columns.winsScoringFirst',
        }),
        winsThreeGoalGames: defineMessage({
            defaultMessage: 'Wins 3 Goal Game',
            description: 'columns.winsThreeGoalGames',
        }),
        winsTrailPeriod1: defineMessage({
            defaultMessage: 'Wins Trail 1P',
            description: 'columns.winsTrailPeriod1',
        }),
        winsTrailPeriod2: defineMessage({
            defaultMessage: 'Wins Trail 2P',
            description: 'columns.winsTrailPeriod2',
        }),
        winsTrailingFirst: defineMessage({
            defaultMessage: 'W TF',
            description: 'columns.winsTrailingFirst',
        }),
        winsTwoGoalGames: defineMessage({
            defaultMessage: 'Wins 2 Goal Game',
            description: 'columns.winsTwoGoalGames',
        }),
        zoneStartPct5v5: defineMessage({
            defaultMessage: '5v5 OZ%',
            description: 'columns.zoneStartPct5v5',
        }),
    },
    filters: {
        birthStateProvinceCode: defineMessage({
            defaultMessage: 'State/Province',
            description: 'FilterTitles.birthStateProvinceCode',
        }),
        catches: defineMessage({
            defaultMessage: 'Catches',
            description: 'A word describing which hand a goalie catches the puck with. (Left or Right hand)',
        }),
        custom: defineMessage({
            defaultMessage: 'Add Custom Filters',
            description: 'A phrase describing a section where the user can create a custom filter for the report',
        }),
        decision: defineMessage({
            defaultMessage: 'Decision',
            description: 'FilterTitles.decision',
        }),
        draftPick: defineMessage({
            defaultMessage: 'Draft Overall Picks',
            description: 'FilterTitles.draftPick',
        }),
        draftPickFrom: defineMessage({
            defaultMessage: 'Draft Pick from',
            description: 'FilterTitles.draftPickFrom',
        }),
        draftPickTo: defineMessage({
            defaultMessage: 'Draft Pick to',
            description: 'FilterTitles.draftPickTo',
        }),
        draftRound: defineMessage({
            defaultMessage: 'Draft Round',
            description: 'FilterTitles.draftRound',
        }),
        draftYear: defineMessage({
            defaultMessage: 'Draft Year',
            description: 'FilterTitles.draftYear',
        }),
        expandSeason: defineMessage({
            defaultMessage: 'Expand Season Options',
            description: 'Label for select element button, prompting user to expand season options in a dropdown menu',
        }),
        gameDecidedIn: defineMessage({
            defaultMessage: 'Game Decided In',
            description: 'FilterTitles.gameDecidedIn',
        }),
        gameResult: defineMessage({
            defaultMessage: 'Decision',
            description: 'FilterTitles.gameResult',
        }),
        gameType: defineMessage({
            defaultMessage: 'Game Type',
            description: 'FilterTitles.gameType',
        }),
        height: defineMessage({
            defaultMessage: 'Height (in)',
            description: 'FilterTitles.height',
        }),
        heightFrom: defineMessage({
            defaultMessage: 'Height from',
            description: 'FilterTitles.heightFrom',
        }),
        heightTo: defineMessage({
            defaultMessage: 'Height to',
            description: 'FilterTitles.heightTo',
        }),
        homeRoad: defineMessage({
            defaultMessage: 'Game Location',
            description: 'FilterTitles.homeRoad',
        }),
        isRookie: defineMessage({
            defaultMessage: 'Experience',
            description: 'FilterTitles.isRookie',
        }),
        leftyOrRighty: defineMessage({
            defaultMessage: 'Left/Right',
            description: 'FilterTitles.leftyOrRighty',
        }),
        nationalityCode: defineMessage({
            defaultMessage: 'Country',
            description: 'FilterTitles.nationalityCode',
        }),
        opponent: defineMessage({
            defaultMessage: 'Opponent',
            description: 'FilterTitles.opponent',
        }),
        playerSearch: defineMessage({
            defaultMessage: 'Player',
            description: `A word which indicates we are filtering results based on a player's name`,
        }),
        playerPlayedFor: defineMessage({
            defaultMessage: 'Team',
            description: 'FilterTitles.playerPlayedFor',
        }),
        positionCode: defineMessage({
            defaultMessage: 'Position',
            description: 'FilterTitles.positionCode',
        }),
        seasons: defineMessage({
            defaultMessage: 'Seasons',
            description: 'FilterTitles.seasons',
        }),
        seasonFrom: defineMessage({
            defaultMessage: 'Season From',
            description:
                'A phrase describing a select with seasons as options. Allowing users to select a specific from season and providing values starting from that season onward',
        }),
        seasonTo: defineMessage({
            defaultMessage: 'Season To',
            description:
                'A phrase describing a select with seasons as options. Allowing users to select a specific to season and providing values from that season and earlier',
        }),
        shoots: defineMessage({
            defaultMessage: 'Shoots',
            description: 'A word describing which hand a skater shoots with. (Left or Right hand)',
        }),
        status: defineMessage({
            defaultMessage: 'Status',
            description: 'FilterTitles.status',
        }),
        team: defineMessage({
            defaultMessage: 'Team',
            description: 'FilterTitles.team',
        }),
        weight: defineMessage({
            defaultMessage: 'Weight (lbs)',
            description: 'FilterTitles.weight',
        }),
        weightFrom: defineMessage({
            defaultMessage: 'Weight from',
            description: 'FilterTitles.weightFrom',
        }),
        weightTo: defineMessage({
            defaultMessage: 'Weight to',
            description: 'FilterTitles.weightTo',
        }),
    },
    fullReportName: {
        advanced: defineMessage({
            defaultMessage: 'Advanced',
            description: 'reportsFull.advanced',
        }),
        bios: defineMessage({
            defaultMessage: 'Bio Info',
            description: 'reportsFull.bios',
        }),
        bystrength: defineMessage({
            defaultMessage: 'Saves By Strength (since 1997-98)',
            description: 'reportsFull.bystrength',
        }),
        daysbetweengames: defineMessage({
            defaultMessage: 'Days between Games',
            description: 'reportsFull.daysbetweengames',
        }),
        daysrest: defineMessage({
            defaultMessage: 'Days Rest',
            description: 'reportsFull.daysrest',
        }),
        faceoffpercentages: defineMessage({
            defaultMessage: 'Face-off Percentages (since 1997-98)',
            description: 'reportsFull.faceoffpercentages',
        }),
        faceoffsbystrength: defineMessage({
            defaultMessage: 'Face-offs (since 1997-98)',
            description: 'reportsFull.faceoffsbystrength',
        }),
        faceoffsbyzone: defineMessage({
            defaultMessage: 'Face-offs By Zone',
            description: 'reportsFull.faceoffsbyzone',
        }),
        faceoffwins: defineMessage({
            defaultMessage: 'Face-off Wins and Losses (since 1997-98)',
            description: 'reportsFull.faceoffwins',
        }),
        franchisesummary: defineMessage({
            defaultMessage: 'Franchise Summary',
            description: 'reportsFull.franchisesummary',
        }),
        goalgames: defineMessage({
            defaultMessage: 'Team Goal-Games',
            description: 'reportsFull.goalgames',
        }),
        goaliebios: defineMessage({
            defaultMessage: 'Bio Info',
            description: 'reportsFull.goaliebios',
        }),
        goaliepenaltyshots: defineMessage({
            defaultMessage: 'Penalty Shots',
            description: 'reportsFull.goaliepenaltyshots',
        }),
        goaliesummary: defineMessage({
            defaultMessage: 'Goalie Summary',
            description: 'reportsFull.goaliesummary',
        }),
        goalsForAgainst: defineMessage({
            defaultMessage: 'Goals For and Against (since 2009-10)',
            description: 'reportsFull.goalsForAgainst',
        }),
        goalsagainstbystrength: defineMessage({
            defaultMessage: 'Goals Against by Strength (since 2009-10)',
            description: 'reportsFull.goalsagainstbystrength',
        }),
        goalsagainstbystrengthgoaliepull: defineMessage({
            defaultMessage: 'Goals Against by Strength, Goalie Pulls (since 2009-10)',
            description: 'A title of a report which describes how many goals were scored against a team when either goalie is pulled',
        }),
        goalsbyperiod: defineMessage({
            defaultMessage: 'Goals by Period',
            description: 'reportsFull.goalsbyperiod',
        }),
        goalsforbystrength: defineMessage({
            defaultMessage: 'Goals For by Strength (since 2009-10)',
            description: 'reportsFull.goalsforbystrength',
        }),
        goalsforbystrengthgoaliepull: defineMessage({
            defaultMessage: 'Goals For by Strength, Goalie Pulls (since 2009-10)',
            description: 'A title of a report which describes how many goals a team scored when either goalie is pulled',
        }),
        leadingtrailing: defineMessage({
            defaultMessage: 'Leading/Trailing',
            description: 'reportsFull.leadingtrailing',
        }),
        outshootoutshotby: defineMessage({
            defaultMessage: 'Outshoot/Outshot By',
            description: 'reportsFull.outshootoutshotby',
        }),
        penalties: defineMessage({
            defaultMessage: 'Penalties',
            description: 'reportsFull.penalties',
        }),
        penaltyShots: defineMessage({
            defaultMessage: 'Penalty Shots',
            description: 'reportsFull.penaltyShots',
        }),
        penaltykill: defineMessage({
            defaultMessage: 'Penalty Kill (since 1997-98)',
            description: 'reportsFull.penaltykill',
        }),
        penaltykilltime: defineMessage({
            defaultMessage: 'Penalty Kill Time (since 2009-10)',
            description: 'reportsFull.penaltykilltime',
        }),
        percentages: defineMessage({
            defaultMessage: 'SAT Percentages (5v5, since 2009-10)',
            description: 'reportsFull.percentages',
        }),
        plusminus: defineMessage({
            defaultMessage: 'Plus-Minus',
            description: 'reportsFull.plusminus',
        }),
        powerplay: defineMessage({
            defaultMessage: 'Power Play (since 1997-98)',
            description: 'reportsFull.powerplay',
        }),
        powerplaytime: defineMessage({
            defaultMessage: 'Power Play Time (since 2009-10)',
            description: 'reportsFull.powerplaytime',
        }),
        puckPossessions: defineMessage({
            defaultMessage: 'Puck Possession (5v5, since 2009-10)',
            description: 'reportsFull.puckPossessions',
        }),
        realtime: defineMessage({
            defaultMessage: 'Miscellaneous',
            description: 'reportsFull.realtime',
        }),
        savesByStrength: defineMessage({
            defaultMessage: 'Saves by Strength (since 1997-98)',
            description: 'reportsFull.savesByStrength',
        }),
        scoretrailfirst: defineMessage({
            defaultMessage: 'Scoring First/Trailing First',
            description: 'reportsFull.scoretrailfirst',
        }),
        scoringRates: defineMessage({
            defaultMessage: 'Scoring per 60 (5v5, since 2009-10)',
            description: 'reportsFull.scoringRates',
        }),
        scoringpergame: defineMessage({
            defaultMessage: 'Scoring per Game',
            description: 'reportsFull.scoringpergame',
        }),
        shootout: defineMessage({
            defaultMessage: 'Shootout (since 2005-06)',
            description: 'reportsFull.shootout',
        }),
        shottype: defineMessage({
            defaultMessage: 'Shots by Type (since 2009-10)',
            description: 'reportsFull.shottype',
        }),
        skaterfranchisesummary: defineMessage({
            defaultMessage: 'Franchise Totals',
            description: 'reportsFull.skaterfranchisesummary',
        }),
        skatergoals: defineMessage({
            defaultMessage: 'Goals by Type (since 1933-34)',
            description: 'reportsFull.skatergoals',
        }),
        skaterpenaltykill: defineMessage({
            defaultMessage: 'Penalty Kill Real Time Stats (since 1997-98)',
            description: 'reportsFull.skaterpenaltykill',
        }),
        skaterpoints: defineMessage({
            defaultMessage: 'Points by Type (since 1933-34)',
            description: 'reportsFull.skaterpoints',
        }),
        skaterpowerplay: defineMessage({
            defaultMessage: 'Power Play Real Time Stats (since 1997-98)',
            description: 'reportsFull.skaterpowerplay',
        }),
        skaterscoring: defineMessage({
            defaultMessage: 'Points/Penalties per 60 Min.',
            description: 'reportsFull.skaterscoring',
        }),
        skatershootout: defineMessage({
            defaultMessage: 'Shootout (since 2005-06)',
            description: 'reportsFull.skatershootout',
        }),
        skatersummary: defineMessage({
            defaultMessage: 'Skater Summary',
            description: 'reportsFull.skatersummary',
        }),
        startedVsRelieved: defineMessage({
            defaultMessage: 'Started vs Relieved',
            description: 'reportsFull.startedVsRelieved',
        }),
        summary: defineMessage({
            defaultMessage: 'Summary',
            description: 'reportsFull.summary',
        }),
        summaryshooting: defineMessage({
            defaultMessage: 'SAT Counts (5v5, since 2009-10)',
            description: 'reportsFull.summaryshooting',
        }),
        teamdaysbetweengames: defineMessage({
            defaultMessage: 'Days between Games',
            description: 'reportsFull.teamdaysbetweengames',
        }),
        teamgoalsbytype: defineMessage({
            defaultMessage: 'Goals by Type (since 1933-34)',
            description: 'reportsFull.teamgoalsbytype',
        }),
        teampercentages: defineMessage({
            defaultMessage: 'SAT Percentages (5v5)',
            description: 'reportsFull.teampercentages',
        }),
        teamscoring: defineMessage({
            defaultMessage: 'Points/Penalties per 60 Min.',
            description: 'reportsFull.teamscoring',
        }),
        teamsummary: defineMessage({
            defaultMessage: 'Team Summary',
            description: 'reportsFull.teamsummary',
        }),
        timeonice: defineMessage({
            defaultMessage: 'Time on Ice (since 1997-98)',
            description: 'reportsFull.timeonice',
        }),
    },
    labels: {
        advanced: defineMessage({
            defaultMessage: 'More Filters',
            description: 'A phrase describing a button which will show more filters when pressed',
        }),
        allDecisions: defineMessage({
            defaultMessage: 'All Decisions',
            description: 'Labels.allDecisions',
        }),
        allFranchises: defineMessage({
            defaultMessage: 'All Franchises',
            description: 'Labels.allFranchises',
        }),
        allGoalies: defineMessage({
            defaultMessage: 'All Goalies',
            description: 'Labels.allGoalies',
        }),
        allLeaders: defineMessage({
            defaultMessage: 'All Leaders',
            description: 'Labels.allLeaders',
        }),
        allOpponents: defineMessage({
            defaultMessage: 'All Opponents',
            description: 'Labels.allOpponents',
        }),
        allSkaters: defineMessage({
            defaultMessage: 'All Skaters',
            description: 'A phrase describing an option that will include all skater positions',
        }),
        allTime: defineMessage({
            defaultMessage: 'All-Time',
            description: 'Labels.allTime',
        }),
        applyFilters: defineMessage({
            defaultMessage: 'Apply Filters',
            description: 'A phrase describing a button which will apply the selected filters to a report',
        }),
        assists: defineMessage({
            defaultMessage: 'Assists',
            description: 'Labels.assists',
        }),
        beyondTheNumbers: defineMessage({
            defaultMessage: 'Beyond The Numbers',
            description: 'Labels.beyondTheNumbers',
        }),
        byGame: defineMessage({
            defaultMessage: 'By Game',
            description: 'Labels.byGame',
        }),
        bySeason: defineMessage({
            defaultMessage: 'By Season',
            description: 'Labels.bySeason',
        }),
        changeFilters: defineMessage({
            defaultMessage: 'Change filters to enable',
            description: 'Labels.changeFilters',
        }),
        clearFilters: defineMessage({
            defaultMessage: 'Clear Filters',
            description: 'A phrase describing a button which will clear all selected filters when pressed',
        }),
        dateRange: defineMessage({
            defaultMessage: 'Date Range',
            description: 'Labels.dateRange',
        }),
        defensemen: defineMessage({
            defaultMessage: 'Defensemen',
            description: 'Labels.defensemen',
        }),
        draftDetails: defineMessage({
            defaultMessage: 'Draft',
            description:
                'A word describing a group of information related to a players draft class (The round and year)',
        }),
        experience: defineMessage({
            defaultMessage: 'Experience',
            description: 'Labels.experience',
        }),
        exportStats: defineMessage({
            defaultMessage: 'Export',
            description: 'A phrase describing a link which will export the current stats report to a CSV',
        }),
        fantasyStats: defineMessage({
            defaultMessage: 'NHL.com Fantasy Stats',
            description: 'Labels.fantasyStats',
        }),
        filterResultsBy: defineMessage({
            defaultMessage: 'Filter Results By',
            description: 'Labels.filterResultsBy',
        }),
        franchise: defineMessage({
            defaultMessage: 'Franchise',
            description: 'Labels.franchise',
        }),
        gaa: defineMessage({
            defaultMessage: 'GAA',
            description: 'Labels.gaa',
        }),
        gameDetails: defineMessage({
            defaultMessage: 'Game/Opponent',
            description: 'Labels.gameDetails',
        }),
        gameType: defineMessage({
            defaultMessage: 'Game Type',
            description: 'Labels.gameType',
        }),
        glossary: defineMessage({
            defaultMessage: 'Glossary',
            description: 'A word to describe a list of hockey terms with their definitions',
        }),
        go: defineMessage({
            defaultMessage: 'Get Stats',
            description: 'A phrase describing a button which will get stats for the filters the user has selected',
        }),
        goalie: defineMessage({
            defaultMessage: 'Goalies',
            description: 'Labels.goalie',
        }),
        goals: defineMessage({
            defaultMessage: 'Goals',
            description: 'A phrase that describes how many goals a player has',
        }),
        goalsAgainstPerGame: defineMessage({
            defaultMessage: 'Goals Against/Game',
            description: 'Labels.goalsAgainstPerGame',
        }),
        goalsPerGame: defineMessage({
            defaultMessage: 'Goals/Game',
            description: 'Labels.goalsPerGame',
        }),
        home: defineMessage({
            defaultMessage: 'Home',
            description: 'Labels.home',
        }),
        homeMenu: defineMessage({
            defaultMessage: 'Home',
            description: 'navigation.home',
        }),
        leagueAverage: defineMessage({
            defaultMessage: 'League Average:',
            description: 'Labels.leagueAverage',
        }),
        legend: defineMessage({
            defaultMessage: 'Legend',
            description: 'A phrase describing a button which will toggle a legend dialog',
        }),
        loadReport: defineMessage({
            defaultMessage: 'Press to load report with current filters',
            description: 'Labels.loadReport',
        }),
        minimumPlayoffMinutesForGoalieStatsLeaders: defineMessage({
            defaultMessage: '(played for {val} or more minutes)',
            description: 'A hint that only players who have played for X or more minutes will be displayed',
        }),
        minimumRegularGamesForGoalieStatsLeaders: defineMessage({
            defaultMessage: '(played for {val} or more games)',
            description: 'A hint that only players who have played for X or more games will be displayed',
        }),
        noDataToDisplay: defineMessage({
            defaultMessage: 'There is no data to display.',
            description: 'Labels.noDataToDisplay',
        }),
        noQualifyingData: defineMessage({
            defaultMessage: 'There are no players that meet the requirements.',
            description: 'Labels.noQualifyingData',
        }),
        opponent: defineMessage({
            defaultMessage: 'Opponent',
            description: 'Labels.opponent',
        }),
        origin: defineMessage({
            defaultMessage: 'Place of Origin',
            description:
                'A phrase describing a players nationality and the state of province they were born in (USA and Canada only)',
        }),
        page: defineMessage({
            defaultMessage: 'Page',
            description: 'Labels.page',
        }),
        penaltyKillPct: defineMessage({
            defaultMessage: 'Penalty Kill %',
            description: 'Labels.penaltyKillPct',
        }),
        physicalDetails: defineMessage({
            defaultMessage: 'Shoots/Catches',
            description: 'Labels.physicalDetails',
        }),
        playerPositionCode: defineMessage({
            defaultMessage: 'Position',
            description: 'Labels.playerPositionCode',
        }),
        playerStatus: defineMessage({
            defaultMessage: 'Status',
            description: 'Labels.playerStatus',
        }),
        playoffs: defineMessage({
            defaultMessage: 'Playoffs',
            description: 'Labels.playoffs',
        }),
        plusMinus: defineMessage({
            defaultMessage: 'Plus-Minus',
            description: 'Labels.plusMinus',
        }),
        points: defineMessage({
            defaultMessage: 'Points',
            description: 'Labels.points',
        }),
        positionCode: defineMessage({
            defaultMessage: 'Position',
            description: 'Labels.positionCode',
        }),
        powerPlayPct: defineMessage({
            defaultMessage: 'Power Play %',
            description: 'Labels.powerPlayPct',
        }),
        print: defineMessage({
            defaultMessage: 'Print',
            description: 'A phrase describing a button which will print the stats report',
        }),
        recordsReturned: defineMessage({
            defaultMessage: 'records returned',
            description: 'Labels.recordsReturned',
        }),
        regularSeason: defineMessage({
            defaultMessage: 'Regular Season',
            description: 'Labels.regularSeason',
        }),
        report: defineMessage({
            defaultMessage: 'Report',
            description: 'Labels.report',
        }),
        road: defineMessage({
            defaultMessage: 'Road',
            description: 'Labels.road',
        }),
        rookie: defineMessage({
            defaultMessage: 'Rookies',
            description: 'Labels.rookie',
        }),
        rows: defineMessage({
            defaultMessage: 'rows',
            description: 'Labels.rows',
        }),
        savePctg: defineMessage({
            defaultMessage: 'SV %',
            description: 'Labels.savePctg',
        }),
        saves: defineMessage({
            defaultMessage: 'Saves',
            description: 'Labels.saves',
        }),
        scoring: defineMessage({
            defaultMessage: 'Scoring',
            description: 'Labels.scoring',
        }),
        search: defineMessage({
            defaultMessage: 'Search Players',
            description: 'Labels.search',
        }),
        seasonRange: defineMessage({
            defaultMessage: 'Season Range',
            description: 'Labels.seasonRange',
        }),
        selectReport: defineMessage({
            defaultMessage: 'Select Report',
            description: 'Labels.selectReport',
        }),
        shootingPctg: defineMessage({
            defaultMessage: 'Shooting %',
            description: 'Labels.shootingPctg',
        }),
        shotsAgainst: defineMessage({
            defaultMessage: 'Shots Against',
            description: 'Labels.shotsAgainst',
        }),
        shutouts: defineMessage({
            defaultMessage: 'Shutouts',
            description: 'Labels.shutouts',
        }),
        skater: defineMessage({
            defaultMessage: 'Skaters',
            description: 'Labels.skater',
        }),
        sumResults: defineMessage({
            defaultMessage: 'Sum Results',
            description: 'Labels.sumResults',
        }),
        team: defineMessage({
            defaultMessage: 'Team',
            description: 'Labels.team',
        }),
        teams: defineMessage({
            defaultMessage: 'Teams',
            description: 'A word to describe a list of different teams',
        }),
        ties: defineMessage({
            defaultMessage: 'T',
            description: 'Labels.ties',
        }),
        to: defineMessage({
            defaultMessage: 'To',
            description: 'Labels.to',
        }),
        veteran: defineMessage({
            defaultMessage: 'Veteran',
            description: 'Labels.veteran',
        }),
        vs: defineMessage({
            defaultMessage: 'vs',
            description: 'Labels.vs',
        }),
        wins: defineMessage({
            defaultMessage: 'Wins',
            description: 'Labels.wins',
        }),
    },
    misc: {
        final: defineMessage({
            defaultMessage: 'Final',
            description: 'Describes a game which is over',
        }),
        noData: defineMessage({
            defaultMessage: 'No Data Available',
            description: 'A message which describes that no data is available for the current selection',
        }),
        noInfo: defineMessage({
            description:
                "An indicator for when a statistic is impossible to quantify - i.e. a player's goals when they have played no games yet could be denoted as --, rather than 0, to indicate that they can't have scored any goals.",
            defaultMessage: '--',
        }),
        overtime: defineMessage({
            defaultMessage: 'OT',
            description: 'Abbreviation for overtime losses',
        }),
        period: defineMessage({
            defaultMessage: 'Period',
            description: 'A word that describes a single period of play in a game',
        }),
        shootout: defineMessage({
            defaultMessage: 'SO',
            description: 'Abbreviation for Shootout',
        }),
        unknown: defineMessage({
            defaultMessage: "We're having some trouble on our end. Please try again later.",
            description: 'Errors.unknown',
        }),
    },
    reportName: {
        advanced: defineMessage({
            defaultMessage: 'Advanced',
            description: 'reports.advanced',
        }),
        bios: defineMessage({
            defaultMessage: 'Bio Info',
            description: 'reports.bios',
        }),
        bystrength: defineMessage({
            defaultMessage: 'Saves By Strength',
            description: 'reports.bystrength',
        }),
        daysbetweengames: defineMessage({
            defaultMessage: 'Days between Games',
            description: 'reports.daysbetweengames',
        }),
        daysrest: defineMessage({
            defaultMessage: 'Days Rest',
            description: 'reports.daysrest',
        }),
        faceoffpercentages: defineMessage({
            defaultMessage: 'Face-off Percentages',
            description: 'reports.faceoffpercentages',
        }),
        faceoffsbystrength: defineMessage({
            defaultMessage: 'Face-offs',
            description: 'reports.faceoffsbystrength',
        }),
        faceoffsbyzone: defineMessage({
            defaultMessage: 'Face-offs By Zone',
            description: 'reports.faceoffsbyzone',
        }),
        faceoffwins: defineMessage({
            defaultMessage: 'Face-off Wins and Losses',
            description: 'reports.faceoffwins',
        }),
        franchisesummary: defineMessage({
            defaultMessage: 'Franchise Summary',
            description: 'reports.franchisesummary',
        }),
        goalgames: defineMessage({
            defaultMessage: 'Team Goal-Games',
            description: 'reports.goalgames',
        }),
        goaliebios: defineMessage({
            defaultMessage: 'Bio Info',
            description: 'reports.goaliebios',
        }),
        goaliepenaltyshots: defineMessage({
            defaultMessage: 'Penalty Shots',
            description: 'reports.goaliepenaltyshots',
        }),
        goaliesummary: defineMessage({
            defaultMessage: 'Goalie Summary',
            description: 'reports.goaliesummary',
        }),
        goalsForAgainst: defineMessage({
            defaultMessage: 'Goals For and Against',
            description: 'reports.goalsForAgainst',
        }),
        goalsagainstbystrength: defineMessage({
            defaultMessage: 'Goals Against by Strength',
            description: 'reports.goalsagainstbystrength',
        }),
        goalsagainstbystrengthgoaliepull: defineMessage({
            defaultMessage: 'Goals Against by Strength, Goalie Pulls',
            description: 'A title of a report which describes how many goals were scored against a team when either goalie is pulled',
        }),
        goalsbyperiod: defineMessage({
            defaultMessage: 'Goals by Period',
            description: 'reports.goalsbyperiod',
        }),
        goalsforbystrength: defineMessage({
            defaultMessage: 'Goals For by Strength',
            description: 'reports.goalsforbystrength',
        }),
        goalsforbystrengthgoaliepull: defineMessage({
            defaultMessage: 'Goals For by Strength, Goalie Pulls',
            description: 'A title of a report which describes how many goals a team scored when either goalie is pulled',
        }),
        leadingtrailing: defineMessage({
            defaultMessage: 'Leading/Trailing',
            description: 'reports.leadingtrailing',
        }),
        outshootoutshotby: defineMessage({
            defaultMessage: 'OutShoot/OutShot By',
            description: 'reports.outshootoutshotby',
        }),
        penalties: defineMessage({
            defaultMessage: 'Penalties',
            description: 'reports.penalties',
        }),
        penaltyShots: defineMessage({
            defaultMessage: 'Penalty Shots',
            description: 'reports.penaltyShots',
        }),
        penaltykill: defineMessage({
            defaultMessage: 'Penalty Kill',
            description: 'reports.penaltykill',
        }),
        penaltykilltime: defineMessage({
            defaultMessage: 'Penalty Kill Time',
            description: 'reports.penaltykilltime',
        }),
        percentages: defineMessage({
            defaultMessage: 'SAT Percentages',
            description: 'reports.percentages',
        }),
        plusminus: defineMessage({
            defaultMessage: 'Plus-Minus',
            description: 'reports.plusminus',
        }),
        powerplay: defineMessage({
            defaultMessage: 'Power Play',
            description: 'reports.powerplay',
        }),
        powerplaytime: defineMessage({
            defaultMessage: 'Power Play Time',
            description: 'reports.powerplaytime',
        }),
        puckPossessions: defineMessage({
            defaultMessage: 'Puck Possession',
            description: 'reports.puckPossessions',
        }),
        realtime: defineMessage({
            defaultMessage: 'Miscellaneous',
            description: 'reports.realtime',
        }),
        savePercentage: defineMessage({
            defaultMessage: 'Save Percentage',
            description: 'tooltips.savePct',
        }),
        savesByStrength: defineMessage({
            defaultMessage: 'Saves by Strength',
            description: 'reports.savesByStrength',
        }),
        scoretrailfirst: defineMessage({
            defaultMessage: 'Scoring First/Trailing First',
            description: 'reports.scoretrailfirst',
        }),
        scoringRates: defineMessage({
            defaultMessage: 'Scoring per 60',
            description: 'reports.scoringRates',
        }),
        scoringpergame: defineMessage({
            defaultMessage: 'Scoring per Game',
            description: 'reports.scoringpergame',
        }),
        shootout: defineMessage({
            defaultMessage: 'Shootout',
            description: 'reports.shootout',
        }),
        shottype: defineMessage({
            defaultMessage: 'Shots by Type',
            description: 'reports.shottype',
        }),
        skaterfranchisesummary: defineMessage({
            defaultMessage: 'Franchise Totals',
            description: 'reports.skaterfranchisesummary',
        }),
        skatergoals: defineMessage({
            defaultMessage: 'Goals by Type',
            description: 'reports.skatergoals',
        }),
        skaterpenaltykill: defineMessage({
            defaultMessage: 'Penalty Kill Real Time Stats',
            description: 'reports.skaterpenaltykill',
        }),
        skaterpoints: defineMessage({
            defaultMessage: 'Points by Type',
            description: 'reports.skaterpoints',
        }),
        skaterpowerplay: defineMessage({
            defaultMessage: 'Power Play Real Time Stats',
            description: 'reports.skaterpowerplay',
        }),
        skaterscoring: defineMessage({
            defaultMessage: 'Points/Penalties per 60 Min.',
            description: 'reports.skaterscoring',
        }),
        skatershootout: defineMessage({
            defaultMessage: 'Shootout',
            description: 'reports.skatershootout',
        }),
        skatersummary: defineMessage({
            defaultMessage: 'Skater Summary',
            description: 'reports.skatersummary',
        }),
        startedVsRelieved: defineMessage({
            defaultMessage: 'Started vs Relieved',
            description: 'reports.startedVsRelieved',
        }),
        summary: defineMessage({
            defaultMessage: 'Summary',
            description: 'reports.summary',
        }),
        summaryshooting: defineMessage({
            defaultMessage: 'SAT Counts',
            description: 'reports.summaryshooting',
        }),
        teamdaysbetweengames: defineMessage({
            defaultMessage: 'Days between Games',
            description: 'reports.teamdaysbetweengames',
        }),
        teamgoalsbytype: defineMessage({
            defaultMessage: 'Goals by Type',
            description: 'reports.teamgoalsbytype',
        }),
        teampercentages: defineMessage({
            defaultMessage: 'SAT Percentages',
            description: 'reports.teampercentages',
        }),
        teamscoring: defineMessage({
            defaultMessage: 'Points/Penalties per 60 Min.',
            description: 'reports.teamscoring',
        }),
        teamsummary: defineMessage({
            defaultMessage: 'Team Summary',
            description: 'reports.teamsummary',
        }),
        timeonice: defineMessage({
            defaultMessage: 'Time on Ice',
            description: 'reports.timeonice',
        }),
    },
    resultFilterValues: {
        assists: defineMessage({
            defaultMessage: 'Assists',
            description: 'resultFiltersValues.assists',
        }),
        assists5v5: defineMessage({
            defaultMessage: 'Assists 5v5',
            description: 'resultFiltersValues.assists5v5',
        }),
        assistsPer605v5: defineMessage({
            defaultMessage: 'Assists 5v5 Per 60 Minutes',
            description: 'resultFiltersValues.assistsPer605v5',
        }),
        assistsPerGame: defineMessage({
            defaultMessage: 'Assists per Game',
            description: 'resultFiltersValues.assistsPerGame',
        }),
        benchMinorPenalties: defineMessage({
            defaultMessage: 'Bench Penalties',
            description: 'resultFiltersValues.benchMinorPenalties',
        }),
        birthCity: defineMessage({
            defaultMessage: 'Player Birth City',
            description: 'resultFiltersValues.birthCity',
        }),
        birthCountryCode: defineMessage({
            defaultMessage: 'Player Birth Country',
            description: 'resultFiltersValues.birthCountryCode',
        }),
        birthDate: defineMessage({
            defaultMessage: 'Player Birth Date',
            description: 'resultFiltersValues.birthDate',
        }),
        birthStateProvinceCode: defineMessage({
            defaultMessage: 'Player Birth State or Province',
            description: 'resultFiltersValues.birthStateProvinceCode',
        }),
        blockedShots: defineMessage({
            defaultMessage: 'Blocked Shots',
            description: 'resultFiltersValues.blockedShots',
        }),
        blockedShotsPer60: defineMessage({
            defaultMessage: 'Blocked Shots per 60',
            description: 'resultFiltersValues.blockedShotsPer60',
        }),
        blocksPerGame: defineMessage({
            defaultMessage: 'Blocked Shots per Game',
            description: 'resultFiltersValues.blocksPerGame',
        }),
        careerShootoutGameDecidingGoals: defineMessage({
            defaultMessage: 'Career Shootout Game-Deciding Goals',
            description: 'resultFiltersValues.careerShootoutGameDecidingGoals',
        }),
        careerShootoutGamesPlayed: defineMessage({
            defaultMessage: 'Career Shootout Games Played',
            description: 'resultFiltersValues.careerShootoutGamesPlayed',
        }),
        careerShootoutGoals: defineMessage({
            defaultMessage: 'Career Shootout Goals',
            description: 'resultFiltersValues.careerShootoutGoals',
        }),
        careerShootoutGoalsAllowed: defineMessage({
            defaultMessage: 'Career Shootout Goals Allowed',
            description: 'resultFiltersValues.careerShootoutGoalsAllowed',
        }),
        careerShootoutLosses: defineMessage({
            defaultMessage: 'Career Shootout Losses',
            description: 'resultFiltersValues.careerShootoutLosses',
        }),
        careerShootoutSavePct: defineMessage({
            defaultMessage: 'Career Shootout Save %',
            description: 'resultFiltersValues.careerShootoutSavePct',
        }),
        careerShootoutSaves: defineMessage({
            defaultMessage: 'Career Shootout Saves',
            description: 'resultFiltersValues.careerShootoutSaves',
        }),
        careerShootoutShootingPct: defineMessage({
            defaultMessage: 'Career Shootout Shooting Pct',
            description: 'resultFiltersValues.careerShootoutShootingPct',
        }),
        careerShootoutShots: defineMessage({
            defaultMessage: 'Career Shootout Shots',
            description: 'resultFiltersValues.careerShootoutShots',
        }),
        careerShootoutShotsAgainst: defineMessage({
            defaultMessage: 'Career Shootout Shots Against',
            description: 'resultFiltersValues.careerShootoutShotsAgainst',
        }),
        careerShootoutWins: defineMessage({
            defaultMessage: 'Career Shootout Wins',
            description: 'resultFiltersValues.careerShootoutWins',
        }),
        completeGamePct: defineMessage({
            defaultMessage: 'Complete Game Pct',
            description: 'resultFiltersValues.completeGamePct',
        }),
        completeGames: defineMessage({
            defaultMessage: 'Complete Games When Starter',
            description: 'resultFiltersValues.completeGames',
        }),
        currentTeamAbbrev: defineMessage({
            defaultMessage: 'Current Team',
            description: 'resultFiltersValues.currentTeamAbbrev',
        }),
        daysRest: defineMessage({
            defaultMessage: "Days Between Games ('0' = Back-to-Back Games, '4' = 4 or more days)",
            description: 'resultFiltersValues.daysRest',
        }),
        defensiveZoneFaceoffLosses: defineMessage({
            defaultMessage: 'Defensive Zone Face-off Losses (since 2009-10)',
            description: 'resultFiltersValues.defensiveZoneFaceoffLosses',
        }),
        defensiveZoneFaceoffPct: defineMessage({
            defaultMessage: 'Defensive Zone Face-off %',
            description: 'resultFiltersValues.defensiveZoneFaceoffPct',
        }),
        defensiveZoneStartPct: defineMessage({
            defaultMessage: 'Percentage of Zone Starts, Defensive Zone',
            description: 'A tooltip for a column showing what percentage of zone starts came in the defensive zone',
        }),
        defensiveZoneFaceoffWins: defineMessage({
            defaultMessage: 'Defensive Zone Face-off Wins (since 2009-10)',
            description: 'resultFiltersValues.defensiveZoneFaceoffWins',
        }),
        defensiveZoneFaceoffs: defineMessage({
            defaultMessage: 'Defensive Zone Face-offs (since 2009-10)',
            description: 'resultFiltersValues.defensiveZoneFaceoffs',
        }),
        draftOverall: defineMessage({
            defaultMessage: 'Draft Overall Pick',
            description: 'resultFiltersValues.draftOverall',
        }),
        draftRound: defineMessage({
            defaultMessage: 'Draft Round',
            description: 'resultFiltersValues.draftRound',
        }),
        draftYear: defineMessage({
            defaultMessage: 'Draft Year',
            description: 'resultFiltersValues.draftYear',
        }),
        emptyNetAssists: defineMessage({
            defaultMessage: 'Empty Net Assists',
            description: 'resultFiltersValues.emptyNetAssists',
        }),
        emptyNetGoals: defineMessage({
            defaultMessage: 'Empty Net Goals',
            description: 'resultFiltersValues.emptyNetGoals',
        }),
        emptyNetGoalsAgainst: defineMessage({
            defaultMessage: 'Empty Net Goals Against',
            description: 'A phrase describing how many goals were scored against a team when the goalie was pulled',
        }),
        emptyNetPoints: defineMessage({
            defaultMessage: 'Empty Net Points',
            description: 'resultFiltersValues.emptyNetPoints',
        }),
        evFaceoffLosses: defineMessage({
            defaultMessage: 'Even Strength Face-off Losses (since 1997-98)',
            description: 'resultFiltersValues.evFaceoffLosses',
        }),
        evFaceoffPct: defineMessage({
            defaultMessage: 'Even Strength Face-off Win %',
            description: 'resultFiltersValues.evFaceoffPct',
        }),
        evFaceoffWins: defineMessage({
            defaultMessage: 'Even Strength Face-offs Won (since 1997-98)',
            description: 'resultFiltersValues.evFaceoffWins',
        }),
        evFaceoffs: defineMessage({
            defaultMessage: 'Even Strength Face-offs',
            description: 'resultFiltersValues.evFaceoffs',
        }),
        evFaceoffsLost: defineMessage({
            defaultMessage: 'Even Strength Face-off Losses',
            description: 'resultFiltersValues.evFaceoffsLost',
        }),
        evFaceoffsWon: defineMessage({
            defaultMessage: 'Even Strength Face-off Wins',
            description: 'resultFiltersValues.evFaceoffsWon',
        }),
        evGoals: defineMessage({
            defaultMessage: 'Even Strength Goals',
            description: 'resultFiltersValues.evGoals',
        }),
        evGoalsAgainst: defineMessage({
            defaultMessage: 'Even Strength Goals Against',
            description: 'resultFiltersValues.evGoalsAgainst',
        }),
        evGoalsFor: defineMessage({
            defaultMessage: 'Even Strength Goals For',
            description: 'resultFiltersValues.evGoalsFor',
        }),
        evPoints: defineMessage({
            defaultMessage: 'Even Strength Points',
            description: 'resultFiltersValues.evPoints',
        }),
        evSavePct: defineMessage({
            defaultMessage: 'Even Strength Save %',
            description: 'resultFiltersValues.evSavePct',
        }),
        evSaves: defineMessage({
            defaultMessage: 'Even Strength Saves',
            description: 'resultFiltersValues.evSaves',
        }),
        evShotsAgainst: defineMessage({
            defaultMessage: 'Even Strength Shots Against',
            description: 'resultFiltersValues.evShotsAgainst',
        }),
        evTimeOnIce: defineMessage({
            defaultMessage: 'EV Time on Ice (minutes)',
            description: 'resultFiltersValues.evTimeOnIce',
        }),
        evTimeOnIcePerGame: defineMessage({
            defaultMessage: 'EV TOI per Game (minutes)',
            description: 'resultFiltersValues.evTimeOnIcePerGame',
        }),
        evenStrengthGoalDifference: defineMessage({
            defaultMessage: 'On-Ice Even-Strength Goal Differential',
            description: 'resultFiltersValues.evenStrengthGoalDifference',
        }),
        evenStrengthGoalsAgainst: defineMessage({
            defaultMessage: 'On-Ice Even Strength Goals Against',
            description: 'resultFiltersValues.evenStrengthGoalsAgainst',
        }),
        evenStrengthGoalsFor: defineMessage({
            defaultMessage: 'On-Ice Even Strength Goals For',
            description: 'resultFiltersValues.evenStrengthGoalsFor',
        }),
        evenStrengthGoalsForPct: defineMessage({
            defaultMessage: 'Even Strength Goals For Pct',
            description: 'resultFiltersValues.evenStrengthGoalsForPct',
        }),
        evenStrengthTimeOnIcePerGame: defineMessage({
            defaultMessage: 'Even Strength Time On Ice per Game',
            description: 'resultFiltersValues.evenStrengthTimeOnIcePerGame',
        }),
        faceoffLosses: defineMessage({
            defaultMessage: 'Face-offs Lost (since 1997-98)',
            description: 'resultFiltersValues.faceoffLosses',
        }),
        faceoffPct5v5: defineMessage({
            defaultMessage: 'Face-off Win % 5v5',
            description: 'resultFiltersValues.faceoffPct5v5',
        }),
        faceoffWinPct: defineMessage({
            defaultMessage: 'Face-off Win % (since 1997-98)',
            description: 'resultFiltersValues.faceoffWinPct',
        }),
        faceoffWins: defineMessage({
            defaultMessage: 'Face-offs Won (since 1997-98)',
            description: 'resultFiltersValues.faceoffWins',
        }),
        faceoffsLost: defineMessage({
            defaultMessage: 'Face-offs Lost (since 1997-98)',
            description: 'resultFiltersValues.faceoffsLost',
        }),
        faceoffsWon: defineMessage({
            defaultMessage: 'Face-offs Won (since 1997-98)',
            description: 'resultFiltersValues.faceoffsWon',
        }),
        firstGoals: defineMessage({
            defaultMessage: 'Times Scored First Goal of Game',
            description: 'resultFiltersValues.firstGoals',
        }),
        firstSeasonForGameType: defineMessage({
            defaultMessage: 'First Season For Game Type',
            description: 'resultFiltersValues.firstSeasonForGameType',
        }),
        franchiseName: defineMessage({
            defaultMessage: 'Team',
            description: 'resultFiltersValues.franchiseName',
        }),
        gameDate: defineMessage({
            defaultMessage: 'Game Date',
            description: 'resultFiltersValues.gameDate',
        }),
        gameId: defineMessage({
            defaultMessage: 'Game',
            description: 'resultFiltersValues.gameId',
        }),
        gameMisconductPenalties: defineMessage({
            defaultMessage: 'Game Misconduct',
            description: 'resultFiltersValues.gameMisconductPenalties',
        }),
        gameMisconducts: defineMessage({
            defaultMessage: 'Game Misconducts',
            description: 'resultFiltersValues.gameMisconducts',
        }),
        gameWinningGoals: defineMessage({
            defaultMessage: 'Game Winning Goals',
            description: 'resultFiltersValues.gameWinningGoals',
        }),
        gamesPlayed: defineMessage({
            defaultMessage: 'Games Played',
            description: 'resultFiltersValues.gamesPlayed',
        }),
        gamesPlayedDaysRest0: defineMessage({
            defaultMessage: 'Games Played 0 Days Rest',
            description: 'resultFiltersValues.gamesPlayedDaysRest0',
        }),
        gamesPlayedDaysRest1: defineMessage({
            defaultMessage: 'Games Played 1 Day Rest',
            description: 'resultFiltersValues.gamesPlayedDaysRest1',
        }),
        gamesPlayedDaysRest2: defineMessage({
            defaultMessage: 'Games Played 2 Days Rest',
            description: 'resultFiltersValues.gamesPlayedDaysRest2',
        }),
        gamesPlayedDaysRest3: defineMessage({
            defaultMessage: 'Games Played 3 Days Rest',
            description: 'resultFiltersValues.gamesPlayedDaysRest3',
        }),
        gamesPlayedDaysRest4Plus: defineMessage({
            defaultMessage: 'Games Played 4 or More Days Rest',
            description: 'resultFiltersValues.gamesPlayedDaysRest4Plus',
        }),
        gamesRelieved: defineMessage({
            defaultMessage: 'Games Relieved',
            description: 'resultFiltersValues.gamesRelieved',
        }),
        gamesRelievedGoalsAgainst: defineMessage({
            defaultMessage: 'Games Relieved Goals Against',
            description: 'resultFiltersValues.gamesRelievedGoalsAgainst',
        }),
        gamesRelievedLosses: defineMessage({
            defaultMessage: 'Games Relieved Losses',
            description: 'resultFiltersValues.gamesRelievedLosses',
        }),
        gamesRelievedOtLosses: defineMessage({
            defaultMessage: 'Games Relieved OT Losses',
            description: 'resultFiltersValues.gamesRelievedOtLosses',
        }),
        gamesRelievedSavePct: defineMessage({
            defaultMessage: 'Games Relieved Save %',
            description: 'resultFiltersValues.gamesRelievedSavePct',
        }),
        gamesRelievedSaves: defineMessage({
            defaultMessage: 'Games Relieved Saves',
            description: 'resultFiltersValues.gamesRelievedSaves',
        }),
        gamesRelievedShotsAgainst: defineMessage({
            defaultMessage: 'Games Relieved Shots Against',
            description: 'resultFiltersValues.gamesRelievedShotsAgainst',
        }),
        gamesRelievedTies: defineMessage({
            defaultMessage: 'Games Relieved Ties',
            description: 'resultFiltersValues.gamesRelievedTies',
        }),
        gamesRelievedWins: defineMessage({
            defaultMessage: 'Games Relieved Wins',
            description: 'resultFiltersValues.gamesRelievedWins',
        }),
        gamesStarted: defineMessage({
            defaultMessage: 'Games Started',
            description: 'resultFiltersValues.gamesStarted',
        }),
        gamesStartedGoalsAgainst: defineMessage({
            defaultMessage: 'Games Started Goals Against',
            description: 'resultFiltersValues.gamesStartedGoalsAgainst',
        }),
        gamesStartedLosses: defineMessage({
            defaultMessage: 'Games Started Losses',
            description: 'resultFiltersValues.gamesStartedLosses',
        }),
        gamesStartedOtLosses: defineMessage({
            defaultMessage: 'Games Started OT Losses',
            description: 'resultFiltersValues.gamesStartedOtLosses',
        }),
        gamesStartedSavePct: defineMessage({
            defaultMessage: 'Games Started Save %',
            description: 'resultFiltersValues.gamesStartedSavePct',
        }),
        gamesStartedSaves: defineMessage({
            defaultMessage: 'Games Started Saves',
            description: 'resultFiltersValues.gamesStartedSaves',
        }),
        gamesStartedShotsAgainst: defineMessage({
            defaultMessage: 'Games Started Shots Against',
            description: 'resultFiltersValues.gamesStartedShotsAgainst',
        }),
        gamesStartedTies: defineMessage({
            defaultMessage: 'Games Started Ties',
            description: 'resultFiltersValues.gamesStartedTies',
        }),
        gamesStartedWins: defineMessage({
            defaultMessage: 'Games Started Wins',
            description: 'resultFiltersValues.gamesStartedWins',
        }),
        giveaways: defineMessage({
            defaultMessage: 'Giveaways',
            description: 'resultFiltersValues.giveaways',
        }),
        giveawaysPer60: defineMessage({
            defaultMessage: 'Giveaways per 60',
            description: 'resultFiltersValues.giveawaysPer60',
        }),
        goalieFullName: defineMessage({
            defaultMessage: 'Player Name',
            description: 'resultFiltersValues.goalieFullName',
        }),
        goalieGoalsAgainst: defineMessage({
            defaultMessage: 'Goalie Goals Against',
            description: 'A phrase describing how many goals were scored against a team when the goalie was in the net',
        }),
        teamSavePct: defineMessage({
            defaultMessage: 'Team Save Percentage',
            description: "A phrase describing the team's overall save percentage",
        }),
        goals: defineMessage({
            defaultMessage: 'Goals',
            description: 'resultFiltersValues.goals',
        }),
        goals4v3: defineMessage({
            defaultMessage: 'Goals Four-vs-Three',
            description: 'resultFiltersValues.goals4v3',
        }),
        goals5v3: defineMessage({
            defaultMessage: 'Goals Five-vs-Three',
            description: 'resultFiltersValues.goals5v3',
        }),
        goals5v4: defineMessage({
            defaultMessage: 'Goals Five-vs-Four',
            description: 'resultFiltersValues.goals5v4',
        }),
        goals5v5: defineMessage({
            defaultMessage: 'Goals 5v5',
            description: 'resultFiltersValues.goals5v5',
        }),
        goalsAgainst: defineMessage({
            defaultMessage: 'Goals Against',
            description: 'resultFiltersValues.goalsAgainst',
        }),
        goalsAgainst3On3: defineMessage({
            defaultMessage: 'Goals Against 3v3',
            description: 'resultFiltersValues.goalsAgainst3On3',
        }),
        goalsAgainst3On4: defineMessage({
            defaultMessage: 'Goals Against 3v4',
            description: 'resultFiltersValues.goalsAgainst3On4',
        }),
        goalsAgainst3On5: defineMessage({
            defaultMessage: 'Goals Against 3v5',
            description: 'resultFiltersValues.goalsAgainst3On5',
        }),
        goalsAgainst3On6: defineMessage({
            defaultMessage: 'Goals Against 3v6',
            description: 'resultFiltersValues.goalsAgainst3On6',
        }),
        goalsAgainst3v4: defineMessage({
            defaultMessage: 'Goals Against 3v4',
            description: 'resultFiltersValues.goalsAgainst3v4',
        }),
        goalsAgainst3v5: defineMessage({
            defaultMessage: 'Goals Against 3v5',
            description: 'resultFiltersValues.goalsAgainst3v5',
        }),
        goalsAgainst4On3: defineMessage({
            defaultMessage: 'Goals Against 4v3',
            description: 'resultFiltersValues.goalsAgainst4On3',
        }),
        goalsAgainst4On4: defineMessage({
            defaultMessage: 'Goals Against 4v4',
            description: 'resultFiltersValues.goalsAgainst4On4',
        }),
        goalsAgainst4On5: defineMessage({
            defaultMessage: 'Goals Against 4v5',
            description: 'resultFiltersValues.goalsAgainst4On5',
        }),
        goalsAgainst4On6: defineMessage({
            defaultMessage: 'Goals Against 4v6',
            description: 'resultFiltersValues.goalsAgainst4On6',
        }),
        goalsAgainst4v5: defineMessage({
            defaultMessage: 'Goals Against 4v5',
            description: 'resultFiltersValues.goalsAgainst4v5',
        }),
        goalsAgainst5On3: defineMessage({
            defaultMessage: 'Goals Against 5v3',
            description: 'resultFiltersValues.goalsAgainst5On3',
        }),
        goalsAgainst5On4: defineMessage({
            defaultMessage: 'Goals Against 5v4',
            description: 'resultFiltersValues.goalsAgainst5On4',
        }),
        goalsAgainst5On5: defineMessage({
            defaultMessage: 'Goals Against 5v5',
            description: 'resultFiltersValues.goalsAgainst5On5',
        }),
        goalsAgainst5On6: defineMessage({
            defaultMessage: 'Goals Against 5v6',
            description: 'resultFiltersValues.goalsAgainst5On6',
        }),
        goalsAgainst6On3: defineMessage({
            defaultMessage: 'Goals Against 6v3',
            description: 'resultFiltersValues.goalsAgainst6On3',
        }),
        goalsAgainst6On4: defineMessage({
            defaultMessage: 'Goals Against 6v4',
            description: 'resultFiltersValues.goalsAgainst6On4',
        }),
        goalsAgainst6On5: defineMessage({
            defaultMessage: 'Goals Against 6v5',
            description: 'resultFiltersValues.goalsAgainst6On5',
        }),
        goalsAgainst6On6: defineMessage({
            defaultMessage: 'Goals Against 6v6',
            description: 'resultFiltersValues.goalsAgainst6On6',
        }),
        goalsAgainstAverage: defineMessage({
            defaultMessage: 'Goals Against Average',
            description: 'resultFiltersValues.goalsAgainstAverage',
        }),
        goalsAgainstEmptyNet: defineMessage({
            defaultMessage: 'Goals Against Empty Net',
            description: 'A phrase for the amount of goals a team has scored against them when their goalie is pulled',
        }),
        goalsAgainstExtraAttacker: defineMessage({
            defaultMessage: 'Goals Against Extra Attacker',
            description: 'A phrase for the amount of goals a team has scored against them when facing an extra attacker',
        }),
        goalsAgainstPenaltyShots: defineMessage({
            defaultMessage: 'Penalty Shot Goals Against',
            description: 'resultFiltersValues.goalsAgainstPenaltyShots',
        }),
        goalsAgainstPerGame: defineMessage({
            defaultMessage: 'Goals Against Per Game',
            description: 'resultFiltersValues.goalsAgainstPerGame',
        }),
        goalsAgainstPerRegulationLoss: defineMessage({
            defaultMessage: 'Goals Against per Regulation + OT Losses',
            description: 'resultFiltersValues.goalsAgainstPerRegulationLoss',
        }),
        goalsBackhand: defineMessage({
            defaultMessage: 'Backhand Shot Goals',
            description: 'resultFiltersValues.goalsBackhand',
        }),
        goalsBat: defineMessage({
            defaultMessage: 'Batted in Goals',
            description: 'A phrase that describes how many goals a player batted in',
        }),
        goalsBetweenLegs: defineMessage({
            defaultMessage: 'Between the Legs Goals',
            description: 'A phrase that describes how many goals a player scored between their legs',
        }),
        goalsCradle: defineMessage({
            defaultMessage: 'Cradle Goals',
            description: 'A phrase that describes how many cradle goals a player has',
        }),
        goalsDeflected: defineMessage({
            defaultMessage: 'Deflection Goals',
            description: 'resultFiltersValues.goalsDeflected',
        }),
        goalsFor: defineMessage({
            defaultMessage: 'Goals For',
            description: 'resultFiltersValues.goalsFor',
        }),
        goalsFor3On3: defineMessage({
            defaultMessage: 'Goals For 3v3',
            description: 'resultFiltersValues.goalsFor3On3',
        }),
        goalsFor3On4: defineMessage({
            defaultMessage: 'Goals For 3v4',
            description: 'resultFiltersValues.goalsFor3On4',
        }),
        goalsFor3On5: defineMessage({
            defaultMessage: 'Goals For 3v5',
            description: 'resultFiltersValues.goalsFor3On5',
        }),
        goalsFor3On6: defineMessage({
            defaultMessage: 'Goals For 3v6',
            description: 'resultFiltersValues.goalsFor3On6',
        }),
        goalsFor4On3: defineMessage({
            defaultMessage: 'Goals For 4v3',
            description: 'resultFiltersValues.goalsFor4On3',
        }),
        goalsFor4On4: defineMessage({
            defaultMessage: 'Goals For 4v4',
            description: 'resultFiltersValues.goalsFor4On4',
        }),
        goalsFor4On5: defineMessage({
            defaultMessage: 'Goals For 4v5',
            description: 'resultFiltersValues.goalsFor4On5',
        }),
        goalsFor4On6: defineMessage({
            defaultMessage: 'Goals For 4v6',
            description: 'resultFiltersValues.goalsFor4On6',
        }),
        goalsFor5On3: defineMessage({
            defaultMessage: 'Goals For 5v3',
            description: 'resultFiltersValues.goalsFor5On3',
        }),
        goalsFor5On4: defineMessage({
            defaultMessage: 'Goals For 5v4',
            description: 'resultFiltersValues.goalsFor5On4',
        }),
        goalsFor5On5: defineMessage({
            defaultMessage: 'Goals For 5v5',
            description: 'resultFiltersValues.goalsFor5On5',
        }),
        goalsFor5On6: defineMessage({
            defaultMessage: 'Goals For 5v6',
            description: 'resultFiltersValues.goalsFor5On6',
        }),
        goalsFor6On3: defineMessage({
            defaultMessage: 'Goals For 6v3',
            description: 'resultFiltersValues.goalsFor6On3',
        }),
        goalsFor6On4: defineMessage({
            defaultMessage: 'Goals For 6v4',
            description: 'resultFiltersValues.goalsFor6On4',
        }),
        goalsFor6On5: defineMessage({
            defaultMessage: 'Goals For 6v5',
            description: 'resultFiltersValues.goalsFor6On5',
        }),
        goalsFor6On6: defineMessage({
            defaultMessage: 'Goals For 6v6',
            description: 'A phrase for the amount of goals a team scored when both teams have 6 skaters on the ice',
        }),
        goalsAgainstAllPulls: defineMessage({
            defaultMessage: 'Goals Against All Pulls',
            description: 'A phrase for the amount of goals scored against a team when either goalie is pulled',
        }),
        goalsForAllPulls: defineMessage({
            defaultMessage: 'Goals For All Pulls',
            description: 'A phrase for the amount of goals a team scored when either goalie is pulled',
        }),
        goalsForAverage: defineMessage({
            defaultMessage: 'Goals For Average',
            description: 'resultFiltersValues.goalsForAverage',
        }),
        goalsForEmptyNet: defineMessage({
            defaultMessage: 'Empty Net Goals For',
            description: 'A phrase for empty net goals a team scored',
        }),
        goalsForExtraAttacker: defineMessage({
            defaultMessage: 'Extra Attacker Goals For',
            description: 'A phrase for the amount of goals your team scored when you have an extra attacker',
        }),
        goalsForPct: defineMessage({
            defaultMessage: 'Goals For %',
            description: 'resultFiltersValues.goalsForPct',
        }),
        goalsForPenaltyShots: defineMessage({
            defaultMessage: 'Penalty Shot Goals For',
            description: 'resultFiltersValues.goalsForPenaltyShots',
        }),
        goalsForPerGame: defineMessage({
            defaultMessage: 'Goals For Per Game',
            description: 'resultFiltersValues.goalsForPerGame',
        }),
        goalsPct: defineMessage({
            defaultMessage: 'On-Ice GF %',
            description: 'resultFiltersValues.goalsPct',
        }),
        goalsPer605v5: defineMessage({
            defaultMessage: 'Goals 5v5 Per 60 Minutes',
            description: 'resultFiltersValues.goalsPer605v5',
        }),
        goalsPerGame: defineMessage({
            defaultMessage: 'Goals Per Game',
            description: 'resultFiltersValues.goalsPerGame',
        }),
        goalsPoke: defineMessage({
            defaultMessage: 'Poke Goals',
            description: 'A phrase that describes how many goals a player poked in',
        }),
        goalsSlap: defineMessage({
            defaultMessage: 'Slap Shot Goals',
            description: 'resultFiltersValues.goalsSlap',
        }),
        goalsSnap: defineMessage({
            defaultMessage: 'Snap Shot Goals',
            description: 'resultFiltersValues.goalsSnap',
        }),
        goalsTipIn: defineMessage({
            defaultMessage: 'Tipped Shot Goals',
            description: 'resultFiltersValues.goalsTipIn',
        }),
        goalsWrapAround: defineMessage({
            defaultMessage: 'Wraparound Goals',
            description: 'resultFiltersValues.goalsWrapAround',
        }),
        goalsWrist: defineMessage({
            defaultMessage: 'Wrist Shot Goals',
            description: 'resultFiltersValues.goalsWrist',
        }),
        height: defineMessage({
            defaultMessage: 'Height (in.)',
            description: 'resultFiltersValues.height',
        }),
        hits: defineMessage({
            defaultMessage: 'Hits',
            description: 'resultFiltersValues.hits',
        }),
        hitsPer60: defineMessage({
            defaultMessage: 'Hits per 60',
            description: 'resultFiltersValues.hitsPer60',
        }),
        hitsPerGame: defineMessage({
            defaultMessage: 'Hits per Game',
            description: 'resultFiltersValues.hitsPerGame',
        }),
        homeRoad: defineMessage({
            defaultMessage: 'Home or Road',
            description: 'resultFiltersValues.homeRoad',
        }),
        incompleteGames: defineMessage({
            defaultMessage: 'Incomplete Games When Starter',
            description: 'resultFiltersValues.incompleteGames',
        }),
        individualSatForPer60: defineMessage({
            defaultMessage: 'Individual SAT For per 60',
            description: 'resultFiltersValues.individualSatForPer60',
        }),
        individualShotsForPer60: defineMessage({
            defaultMessage: 'Individual 5v5 Shots For per 60',
            description: 'resultFiltersValues.individualShotsForPer60',
        }),
        isInHallOfFameYn: defineMessage({
            defaultMessage: 'In Hall of Fame',
            description: 'resultFiltersValues.isInHallOfFameYn',
        }),
        lossLeadPeriod1: defineMessage({
            defaultMessage: 'Losses After Lead Period 1',
            description: 'resultFiltersValues.lossLeadPeriod1',
        }),
        lossLeadPeriod2: defineMessage({
            defaultMessage: 'Losses After Lead Period 2',
            description: 'resultFiltersValues.lossLeadPeriod2',
        }),
        lossTrailPeriod1: defineMessage({
            defaultMessage: 'Losses After Trail Period 1',
            description: 'resultFiltersValues.lossTrailPeriod1',
        }),
        lossTrailPeriod2: defineMessage({
            defaultMessage: 'Losses After Trail Period 2',
            description: 'resultFiltersValues.lossTrailPeriod2',
        }),
        losses: defineMessage({
            defaultMessage: 'Losses',
            description: 'resultFiltersValues.losses',
        }),
        lossesEvenShots: defineMessage({
            defaultMessage: 'Losses Even Shots',
            description: 'resultFiltersValues.lossesEvenShots',
        }),
        lossesOneGoalGames: defineMessage({
            defaultMessage: 'Losses 1-Goal Games',
            description: 'resultFiltersValues.lossesOneGoalGames',
        }),
        lossesOutshootOpponent: defineMessage({
            defaultMessage: 'Losses Outshot Opponent',
            description: 'resultFiltersValues.lossesOutshootOpponent',
        }),
        lossesOutshotByOpponent: defineMessage({
            defaultMessage: 'Losses Outshot by Opponent',
            description: 'resultFiltersValues.lossesOutshotByOpponent',
        }),
        lossesScoringFirst: defineMessage({
            defaultMessage: 'Losses When Scoring First',
            description: 'resultFiltersValues.lossesScoringFirst',
        }),
        lossesThreeGoalGames: defineMessage({
            defaultMessage: 'Losses 3-Goal Games',
            description: 'resultFiltersValues.lossesThreeGoalGames',
        }),
        lossesTrailingFirst: defineMessage({
            defaultMessage: 'Losses When Trailing First',
            description: 'resultFiltersValues.lossesTrailingFirst',
        }),
        lossesTwoGoalGames: defineMessage({
            defaultMessage: 'Losses 2-Goal Games',
            description: 'resultFiltersValues.lossesTwoGoalGames',
        }),
        majorPenalties: defineMessage({
            defaultMessage: 'Major',
            description: 'resultFiltersValues.majorPenalties',
        }),
        majors: defineMessage({
            defaultMessage: 'Majors',
            description: 'resultFiltersValues.majors',
        }),
        matchPenalties: defineMessage({
            defaultMessage: 'Match Penalties',
            description: 'resultFiltersValues.matchPenalties',
        }),
        minorPenalties: defineMessage({
            defaultMessage: 'Minor',
            description: 'resultFiltersValues.minorPenalties',
        }),
        minors: defineMessage({
            defaultMessage: 'Minors',
            description: 'resultFiltersValues.minors',
        }),
        misconductPenalties: defineMessage({
            defaultMessage: 'Misconduct',
            description: 'resultFiltersValues.misconductPenalties',
        }),
        misconducts: defineMessage({
            defaultMessage: 'Misconducts',
            description: 'resultFiltersValues.misconducts',
        }),
        missedShotCrossbar: defineMessage({
            defaultMessage: 'Missed Shots - Hit Crossbar',
            description: 'resultFiltersValues.missedShotCrossbar',
        }),
        missedShotGoalpost: defineMessage({
            defaultMessage: 'Missed Shots - Hit Post',
            description: 'resultFiltersValues.missedShotGoalpost',
        }),
        missedShotOverNet: defineMessage({
            defaultMessage: 'Missed Shots - Over Net',
            description: 'resultFiltersValues.missedShotOverNet',
        }),
        missedShotShort: defineMessage({
            defaultMessage: 'Missed Shots - Short',
            description: 'resultFiltersValues.missedShotShort',
        }),
        missedShotWideOfNet: defineMessage({
            defaultMessage: 'Missed Shots - Wide Of Net',
            description: 'resultFiltersValues.missedShotWideOfNet',
        }),
        missedShots: defineMessage({
            defaultMessage: 'Missed Shots',
            description: 'resultFiltersValues.missedShots',
        }),
        nationalityCode: defineMessage({
            defaultMessage: 'Player Nationality',
            description: 'resultFiltersValues.nationalityCode',
        }),
        netGoalsPerGame: defineMessage({
            defaultMessage: 'Net Goals per Game',
            description: 'resultFiltersValues.netGoalsPerGame',
        }),
        netMinorPenaltiesPer60: defineMessage({
            defaultMessage: 'Net Minor Penalties 5v5 per 60',
            description: 'resultFiltersValues.netMinorPenaltiesPer60',
        }),
        netPenalties: defineMessage({
            defaultMessage: 'Net Penalties',
            description: 'resultFiltersValues.netPenalties',
        }),
        netPenaltiesPer60: defineMessage({
            defaultMessage: 'Net Penalties per 60',
            description: 'resultFiltersValues.netPenaltiesPer60',
        }),
        netShotsPerGame: defineMessage({
            defaultMessage: 'Net Shots per Game',
            description: 'resultFiltersValues.netShotsPerGame',
        }),
        neutralZoneFaceoffLosses: defineMessage({
            defaultMessage: 'Neutral Zone Face-off Losses (since 2009-10)',
            description: 'resultFiltersValues.neutralZoneFaceoffLosses',
        }),
        neutralZoneFaceoffPct: defineMessage({
            defaultMessage: 'Neutral Zone Face-off Win % (since 2009-10)',
            description: 'resultFiltersValues.neutralZoneFaceoffPct',
        }),
        neutralZoneStartPct: defineMessage({
            defaultMessage: 'Percentage of Zone Starts, Neutral Zone',
            description: 'A tooltip for a column showing what percentage of zone starts came in the neutral zone',
        }),
        neutralZoneFaceoffWins: defineMessage({
            defaultMessage: 'Neutral Zone Face-off Wins (since 2009-10)',
            description: 'resultFiltersValues.neutralZoneFaceoffWins',
        }),
        neutralZoneFaceoffs: defineMessage({
            defaultMessage: 'Neutral Zone Face-offs (since 2009-10)',
            description: 'resultFiltersValues.neutralZoneFaceoffs',
        }),
        offensiveZoneFaceoffLosses: defineMessage({
            defaultMessage: 'Offensive Zone Face-off Losses (since 2009-10)',
            description: 'resultFiltersValues.offensiveZoneFaceoffLosses',
        }),
        offensiveZoneFaceoffPct: defineMessage({
            defaultMessage: 'Offensive Zone Face-off Win % (since 2009-10)',
            description: 'resultFiltersValues.offensiveZoneFaceoffPct',
        }),
        offensiveZoneStartRatio: defineMessage({
            defaultMessage: 'Offensive Zone Start Ratio (excludes neutral zone starts)',
            description: 'A phrase that describes what ratio of face-offs start in the team\'s offensive zone, excluding the neutral zone',
        }),
        offensiveZoneStartPct: defineMessage({
            defaultMessage: 'Percentage of Zone Starts, Offensive Zone',
            description: 'A tooltip for a column showing what percentage of zone starts came in the offensive zone',
        }),
        offensiveZoneFaceoffWins: defineMessage({
            defaultMessage: 'Offensive Zone Face-off Wins (since 2009-10)',
            description: 'resultFiltersValues.offensiveZoneFaceoffWins',
        }),
        offensiveZoneFaceoffs: defineMessage({
            defaultMessage: 'Offensive Zone Face-offs (since 2009-10)',
            description: 'resultFiltersValues.offensiveZoneFaceoffs',
        }),
        offensiveZoneStartPct5v5: defineMessage({
            defaultMessage: 'Offensive Zone Face-off % 5v5',
            description: 'resultFiltersValues.offensiveZoneStartPct5v5',
        }),
        onIceGoalsAgainst: defineMessage({
            defaultMessage: 'Goals Against',
            description: 'resultFiltersValues.onIceGoalsAgainst',
        }),
        onIceGoalsFor: defineMessage({
            defaultMessage: 'Goals For',
            description: 'resultFiltersValues.onIceGoalsFor',
        }),
        onIceShootingPct: defineMessage({
            defaultMessage: '5v5 On-Ice Shooting %',
            description: 'resultFiltersValues.onIceShootingPct',
        }),
        onIceShootingPct5v5: defineMessage({
            defaultMessage: 'On-Ice Shooting % 5v5',
            description: 'resultFiltersValues.onIceShootingPct5v5',
        }),
        opponentTeamAbbrev: defineMessage({
            defaultMessage: 'Opponent Team',
            description: 'resultFiltersValues.opponentTeamAbbrev',
        }),
        opportunities4v3: defineMessage({
            defaultMessage: 'Opportunities Four-vs-Three',
            description: 'resultFiltersValues.opportunities4v3',
        }),
        opportunities5v3: defineMessage({
            defaultMessage: 'Opportunities Five-vs-Three',
            description: 'resultFiltersValues.opportunities5v3',
        }),
        opportunities5v4: defineMessage({
            defaultMessage: 'Opportunities Five-vs-Four',
            description: 'resultFiltersValues.opportunities5v4',
        }),
        otGoals: defineMessage({
            defaultMessage: 'Overtime Goals',
            description: 'resultFiltersValues.otGoals',
        }),
        otLossLeadPeriod1: defineMessage({
            defaultMessage: 'OT Loss After Lead Period 1',
            description: 'resultFiltersValues.otLossLeadPeriod1',
        }),
        otLossLeadPeriod2: defineMessage({
            defaultMessage: 'OT Loss After Lead Period 2',
            description: 'resultFiltersValues.otLossLeadPeriod2',
        }),
        otLossTrailPeriod1: defineMessage({
            defaultMessage: 'OT Loss After Trail Period 1',
            description: 'resultFiltersValues.otLossTrailPeriod1',
        }),
        otLossTrailPeriod2: defineMessage({
            defaultMessage: 'OT Loss After Trail Period 2',
            description: 'resultFiltersValues.otLossTrailPeriod2',
        }),
        otLosses: defineMessage({
            defaultMessage: 'Overtime Losses',
            description: 'resultFiltersValues.otLosses',
        }),
        otLossesEvenShots: defineMessage({
            defaultMessage: 'Overtime Loss Even Shots',
            description: 'resultFiltersValues.otLossesEvenShots',
        }),
        otLossesOneGoalGames: defineMessage({
            defaultMessage: 'Overtime Loss 1 Goal Game',
            description: 'resultFiltersValues.otLossesOneGoalGames',
        }),
        otLossesOutshootOpponent: defineMessage({
            defaultMessage: 'Overtime Loss Outshot Opponent',
            description: 'resultFiltersValues.otLossesOutshootOpponent',
        }),
        otLossesOutshotByOpponent: defineMessage({
            defaultMessage: 'Overtime Loss Outshot by Opponent',
            description: 'resultFiltersValues.otLossesOutshotByOpponent',
        }),
        otLossesScoringFirst: defineMessage({
            defaultMessage: 'Overtime Losses When Scoring First',
            description: 'resultFiltersValues.otLossesScoringFirst',
        }),
        otLossesTrailingFirst: defineMessage({
            defaultMessage: 'Overtime Losses When Trailing First',
            description: 'resultFiltersValues.otLossesTrailingFirst',
        }),
        otPoints: defineMessage({
            defaultMessage: 'Overtime Points',
            description: 'resultFiltersValues.otPoints',
        }),
        otTimeOnIce: defineMessage({
            defaultMessage: 'Overtime Time on Ice',
            description: 'resultFiltersValues.otTimeOnIce',
        }),
        otTimeOnIcePerOtGame: defineMessage({
            defaultMessage: 'Overtime Time on Ice Per Overtime Game',
            description: 'resultFiltersValues.otTimeOnIcePerOtGame',
        }),
        overallPenaltyKillPct: defineMessage({
            defaultMessage: 'Penalty Kill %',
            description: 'resultFiltersValues.overallPenaltyKillPct',
        }),
        overallPowerPlayPct: defineMessage({
            defaultMessage: 'Power Play %',
            description: 'resultFiltersValues.overallPowerPlayPct',
        }),
        penalties: defineMessage({
            defaultMessage: 'Penalties Taken',
            description: 'resultFiltersValues.penalties',
        }),
        penaltiesDrawn: defineMessage({
            defaultMessage: 'Penalties Drawn',
            description: 'resultFiltersValues.penaltiesDrawn',
        }),
        penaltiesDrawnPer60: defineMessage({
            defaultMessage: 'Penalties Drawn per 60',
            description: 'resultFiltersValues.penaltiesDrawnPer60',
        }),
        penaltiesTakenPer60: defineMessage({
            defaultMessage: 'Penalties Taken per 60',
            description: 'resultFiltersValues.penaltiesTakenPer60',
        }),
        penaltyKillNetPct: defineMessage({
            defaultMessage: 'Penalty Kill Net %',
            description: 'resultFiltersValues.penaltyKillNetPct',
        }),
        penaltyKillPct: defineMessage({
            defaultMessage: 'Penalty Kill % (since 1977-78)',
            description: 'resultFiltersValues.penaltyKillPct',
        }),
        penaltyKillPct3v4: defineMessage({
            defaultMessage: 'Three-vs-Four Penalty Kill %',
            description: 'resultFiltersValues.penaltyKillPct3v4',
        }),
        penaltyKillPct3v5: defineMessage({
            defaultMessage: 'Three-vs-Five Penalty Kill %',
            description: 'resultFiltersValues.penaltyKillPct3v5',
        }),
        penaltyKillPct4v5: defineMessage({
            defaultMessage: 'Four-vs-Five Penalty Kill %',
            description: 'resultFiltersValues.penaltyKillPct4v5',
        }),
        penaltyMinutes: defineMessage({
            defaultMessage: 'Penalty Minutes',
            description: 'resultFiltersValues.penaltyMinutes',
        }),
        penaltyMinutesPerGame: defineMessage({
            defaultMessage: 'PIM Per Game',
            description: 'resultFiltersValues.penaltyMinutesPerGame',
        }),
        penaltyMinutesPerTimeOnIce: defineMessage({
            defaultMessage: 'Penalty Minutes per Time on Ice',
            description: 'resultFiltersValues.penaltyMinutesPerTimeOnIce',
        }),
        penaltySecondsPerGame: defineMessage({
            defaultMessage: 'Penalty Minutes per Game',
            description: 'resultFiltersValues.penaltySecondsPerGame',
        }),
        penaltyShotAttempts: defineMessage({
            defaultMessage: 'Penalty Shot Attempts',
            description: 'resultFiltersValues.penaltyShotAttempts',
        }),
        penaltyShotSavePct: defineMessage({
            defaultMessage: 'Penalty Shot Save %',
            description: 'resultFiltersValues.penaltyShotSavePct',
        }),
        penaltyShotShootingPct: defineMessage({
            defaultMessage: 'Penalty Shot Shooting Pct',
            description: 'resultFiltersValues.penaltyShotShootingPct',
        }),
        penaltyShotsAgainst: defineMessage({
            defaultMessage: 'Penalty Shot Shots Against',
            description: 'resultFiltersValues.penaltyShotsAgainst',
        }),
        penaltyShotsFailed: defineMessage({
            defaultMessage: 'Penalty Shots Failed',
            description: 'resultFiltersValues.penaltyShotsFailed',
        }),
        penaltyShotsGoals: defineMessage({
            defaultMessage: 'Penalty Shot Goals',
            description: 'resultFiltersValues.penaltyShotsGoals',
        }),
        penaltyShotsGoalsAgainst: defineMessage({
            defaultMessage: 'Penalty Shot Goals Against',
            description: 'resultFiltersValues.penaltyShotsGoalsAgainst',
        }),
        penaltyShotsSaves: defineMessage({
            defaultMessage: 'Penalty Shot Saves',
            description: 'resultFiltersValues.penaltyShotsSaves',
        }),
        period1GoalsAgainst: defineMessage({
            defaultMessage: 'Goals Against In Period 1',
            description: 'resultFiltersValues.period1GoalsAgainst',
        }),
        period1GoalsFor: defineMessage({
            defaultMessage: 'Goals For In Period 1',
            description: 'resultFiltersValues.period1GoalsFor',
        }),
        period2GoalsAgainst: defineMessage({
            defaultMessage: 'Goals Against In Period 2',
            description: 'resultFiltersValues.period2GoalsAgainst',
        }),
        period2GoalsFor: defineMessage({
            defaultMessage: 'Goals For In Period 2',
            description: 'resultFiltersValues.period2GoalsFor',
        }),
        period3GoalsAgainst: defineMessage({
            defaultMessage: 'Goals Against In Period 3',
            description: 'resultFiltersValues.period3GoalsAgainst',
        }),
        period3GoalsFor: defineMessage({
            defaultMessage: 'Goals For In Period 3',
            description: 'resultFiltersValues.period3GoalsFor',
        }),
        periodOtGoalsAgainst: defineMessage({
            defaultMessage: 'Goals Against In Overtime',
            description: 'resultFiltersValues.periodOtGoalsAgainst',
        }),
        periodOtGoalsFor: defineMessage({
            defaultMessage: 'Goals For In OT',
            description: 'resultFiltersValues.periodOtGoalsFor',
        }),
        pkNetGoals: defineMessage({
            defaultMessage: 'Short Handed Net Goals',
            description: 'resultFiltersValues.pkNetGoals',
        }),
        pkNetGoalsPerGame: defineMessage({
            defaultMessage: 'Short Handed Net Goals per Game',
            description: 'resultFiltersValues.pkNetGoalsPerGame',
        }),
        pkPctg: defineMessage({
            defaultMessage: 'Penalty Kill Percentage (since 1977-78)',
            description: 'resultFiltersValues.pkPctg',
        }),
        pkTimeOnIcePerGame: defineMessage({
            defaultMessage: 'PK Time on Ice per Game (since 1997-98)',
            description: 'resultFiltersValues.pkTimeOnIcePerGame',
        }),
        playerTeamsPlayedFor: defineMessage({
            defaultMessage: 'Player Teams Played For',
            description: 'resultFiltersValues.playerTeamsPlayedFor',
        }),
        plusMinus: defineMessage({
            defaultMessage: 'Plus-Minus (since 1959-60)',
            description: 'resultFiltersValues.plusMinus',
        }),
        pointPct: defineMessage({
            defaultMessage: 'Point %',
            description: 'resultFiltersValues.pointPct',
        }),
        points: defineMessage({
            defaultMessage: 'Points',
            description: 'resultFiltersValues.points',
        }),
        points5v5: defineMessage({
            defaultMessage: 'Points 5v5',
            description: 'resultFiltersValues.points5v5',
        }),
        pointsPct: defineMessage({
            defaultMessage: 'Point %',
            description: 'resultFiltersValues.pointsPct',
        }),
        pointsPer605v5: defineMessage({
            defaultMessage: 'Points 5v5 Per 60 Minutes',
            description: 'resultFiltersValues.pointsPer605v5',
        }),
        pointsPerGame: defineMessage({
            defaultMessage: 'Points per Game Played',
            description: 'resultFiltersValues.pointsPerGame',
        }),
        positionCode: defineMessage({
            defaultMessage: 'Player Position',
            description: 'resultFiltersValues.positionCode',
        }),
        powerPlayGoalFor: defineMessage({
            defaultMessage: 'On-Ice Power Play Goals For',
            description: 'resultFiltersValues.powerPlayGoalFor',
        }),
        powerPlayGoalsAgainst: defineMessage({
            defaultMessage: 'On-Ice Power Play Goals Against',
            description: 'resultFiltersValues.powerPlayGoalsAgainst',
        }),
        powerPlayGoalsFor: defineMessage({
            defaultMessage: 'Power Play Goals For',
            description: 'resultFiltersValues.powerPlayGoalsFor',
        }),
        powerPlayNetPct: defineMessage({
            defaultMessage: 'Power Play Net Pct',
            description: 'resultFiltersValues.powerPlayNetPct',
        }),
        powerPlayPct: defineMessage({
            defaultMessage: 'Power Play Percentage (since 1977-78)',
            description: 'resultFiltersValues.powerPlayPct',
        }),
        powerPlayPct4v3: defineMessage({
            defaultMessage: 'Four-vs-Three Power Play %',
            description: 'resultFiltersValues.powerPlayPct4v3',
        }),
        powerPlayPct5v3: defineMessage({
            defaultMessage: 'Five-vs-Three Power Play %',
            description: 'resultFiltersValues.powerPlayPct5v3',
        }),
        powerPlayPct5v4: defineMessage({
            defaultMessage: 'Five-vs-Four Power Play %',
            description: 'resultFiltersValues.powerPlayPct5v4',
        }),
        powerPlayTimeOnIcePerGame: defineMessage({
            defaultMessage: 'Power Play Time On Ice per Game',
            description: 'resultFiltersValues.powerPlayTimeOnIcePerGame',
        }),
        ppAssists: defineMessage({
            defaultMessage: 'Power Play Assists',
            description: 'resultFiltersValues.ppAssists',
        }),
        ppFaceoffLosses: defineMessage({
            defaultMessage: 'Power Play Face-offs Lost (since 1997-98)',
            description: 'resultFiltersValues.ppFaceoffLosses',
        }),
        ppFaceoffPct: defineMessage({
            defaultMessage: 'Power Play Face-off Win % (since 1997-98)',
            description: 'resultFiltersValues.ppFaceoffPct',
        }),
        ppFaceoffWins: defineMessage({
            defaultMessage: 'Power Play Face-offs Won (since 1997-98)',
            description: 'resultFiltersValues.ppFaceoffWins',
        }),
        ppFaceoffs: defineMessage({
            defaultMessage: 'Power Play Face-offs (since 1997-98)',
            description: 'resultFiltersValues.ppFaceoffs',
        }),
        ppFaceoffsLost: defineMessage({
            defaultMessage: 'Power Play Face-offs Lost (since 1997-98)',
            description: 'resultFiltersValues.ppFaceoffsLost',
        }),
        ppFaceoffsWon: defineMessage({
            defaultMessage: 'Power Play Face-offs Won (since 1997-98)',
            description: 'resultFiltersValues.ppFaceoffsWon',
        }),
        ppGoals: defineMessage({
            defaultMessage: 'Power Play Goals (since 1933-34)',
            description: 'resultFiltersValues.ppGoals',
        }),
        ppGoalsAgainst: defineMessage({
            defaultMessage: 'Power Play Goals Against (since 1933-34)',
            description: 'resultFiltersValues.ppGoalsAgainst',
        }),
        ppGoalsAgainstPer60: defineMessage({
            defaultMessage: 'Power Play Goals Against per 60',
            description: 'resultFiltersValues.ppGoalsAgainstPer60',
        }),
        ppGoalsAgainstPerGame: defineMessage({
            defaultMessage: 'Power Play Goals Against per Game',
            description: 'resultFiltersValues.ppGoalsAgainstPerGame',
        }),
        ppGoalsFor: defineMessage({
            defaultMessage: 'PP Goals For',
            description: 'resultFiltersValues.ppGoalsFor',
        }),
        ppGoalsForPer60: defineMessage({
            defaultMessage: 'Power Play Goals For per 60',
            description: 'resultFiltersValues.ppGoalsForPer60',
        }),
        ppGoalsPer60: defineMessage({
            defaultMessage: 'Power Play Goals per 60',
            description: 'resultFiltersValues.ppGoalsPer60',
        }),
        ppGoalsPerGame: defineMessage({
            defaultMessage: 'Power Play Goals per Game',
            description: 'resultFiltersValues.ppGoalsPerGame',
        }),
        ppIndividualSatFor: defineMessage({
            defaultMessage: 'Power Play Individual SAT For (since 2009-10)',
            description: 'resultFiltersValues.ppIndividualSatFor',
        }),
        ppIndividualSatForPer60: defineMessage({
            defaultMessage: 'Power Play Individual SAT For per 60 (since 2009-10)',
            description: 'resultFiltersValues.ppIndividualSatForPer60',
        }),
        ppNetGoals: defineMessage({
            defaultMessage: 'Power Play Net Goals',
            description: 'resultFiltersValues.ppNetGoals',
        }),
        ppNetGoalsPerGame: defineMessage({
            defaultMessage: 'Power Play Net Goals per Game',
            description: 'resultFiltersValues.ppNetGoalsPerGame',
        }),
        ppOpportunities: defineMessage({
            defaultMessage: 'Power Play Opportunities (since 1977-78)',
            description: 'resultFiltersValues.ppOpportunities',
        }),
        ppOpportunitiesPerGame: defineMessage({
            defaultMessage: 'Power Play Opportunities per Game (since 1977-78)',
            description: 'resultFiltersValues.ppOpportunitiesPerGame',
        }),
        ppPctg: defineMessage({
            defaultMessage: 'Power Play Percentage (since 1977-78)',
            description: 'resultFiltersValues.ppPctg',
        }),
        ppPoints: defineMessage({
            defaultMessage: 'Power Play Points (since 1933-34)',
            description: 'resultFiltersValues.ppPoints',
        }),
        ppPointsPer60: defineMessage({
            defaultMessage: 'Power Play Points per 60',
            description: 'resultFiltersValues.ppPointsPer60',
        }),
        ppPrimaryAssists: defineMessage({
            defaultMessage: 'Power Play Primary Assists',
            description: 'resultFiltersValues.ppPrimaryAssists',
        }),
        ppPrimaryAssistsPer60: defineMessage({
            defaultMessage: 'Power Play Primary Assists per 60',
            description: 'resultFiltersValues.ppPrimaryAssistsPer60',
        }),
        ppSavePct: defineMessage({
            defaultMessage: 'Power Play Save %',
            description: 'resultFiltersValues.ppSavePct',
        }),
        ppSaves: defineMessage({
            defaultMessage: 'Power Play Saves',
            description: 'resultFiltersValues.ppSaves',
        }),
        ppSecondaryAssists: defineMessage({
            defaultMessage: 'Power Play Secondary Assists',
            description: 'resultFiltersValues.ppSecondaryAssists',
        }),
        ppSecondaryAssistsPer60: defineMessage({
            defaultMessage: 'Power Play Secondary Assists per 60',
            description: 'resultFiltersValues.ppSecondaryAssistsPer60',
        }),
        ppShootingPct: defineMessage({
            defaultMessage: 'Power Play Shooting Pct',
            description: 'resultFiltersValues.ppShootingPct',
        }),
        ppShots: defineMessage({
            defaultMessage: 'Power Play Shots',
            description: 'resultFiltersValues.ppShots',
        }),
        ppShotsAgainst: defineMessage({
            defaultMessage: 'Power Play Shots Against',
            description: 'resultFiltersValues.ppShotsAgainst',
        }),
        ppShotsPer60: defineMessage({
            defaultMessage: 'Power Play Shots per 60',
            description: 'resultFiltersValues.ppShotsPer60',
        }),
        ppTimeOnIce: defineMessage({
            defaultMessage: 'Power Play Time on Ice (minutes)',
            description: 'resultFiltersValues.ppTimeOnIce',
        }),
        ppTimeOnIcePctPerGame: defineMessage({
            defaultMessage: 'Power Play Time on Ice % per Game',
            description: 'resultFiltersValues.ppTimeOnIcePctPerGame',
        }),
        ppTimeOnIcePerGame: defineMessage({
            defaultMessage: 'Power Play TOI per Game (minutes)',
            description: 'resultFiltersValues.ppTimeOnIcePerGame',
        }),
        primaryAssists5v5: defineMessage({
            defaultMessage: 'Primary Assists 5v5',
            description: 'resultFiltersValues.primaryAssists5v5',
        }),
        primaryAssistsPer605v5: defineMessage({
            defaultMessage: 'Primary Assists 5v5 per 60',
            description: 'resultFiltersValues.primaryAssistsPer605v5',
        }),
        primaryAssistsPerGame: defineMessage({
            defaultMessage: 'Primary Assists per Game',
            description: 'resultFiltersValues.primaryAssistsPerGame',
        }),
        qualityStart: defineMessage({
            defaultMessage: 'Games Started > .900',
            description: 'resultFiltersValues.qualityStart',
        }),
        qualityStartsPct: defineMessage({
            defaultMessage: 'Pct of Games Started > .900',
            description: 'resultFiltersValues.qualityStartsPct',
        }),
        regulationAndOtWins: defineMessage({
            defaultMessage: 'Regulation Plus Overtime Wins',
            description: 'resultFiltersValues.regulationAndOtWins',
        }),
        regulationLosses: defineMessage({
            defaultMessage: 'Regulation + OT Losses',
            description: 'resultFiltersValues.regulationLosses',
        }),
        regulationWins: defineMessage({
            defaultMessage: 'Regulation + OT Wins',
            description: 'resultFiltersValues.regulationWins',
        }),
        satAgainst: defineMessage({
            defaultMessage: 'Shot Attempts Against',
            description: 'resultFiltersValues.satAgainst',
        }),
        satAhead: defineMessage({
            defaultMessage: 'Shot Attempts Ahead',
            description: 'resultFiltersValues.satAhead',
        }),
        satBehind: defineMessage({
            defaultMessage: 'Shot Attempts Behind',
            description: 'resultFiltersValues.satBehind',
        }),
        satClose: defineMessage({
            defaultMessage: 'Shot Attempts Close',
            description: 'resultFiltersValues.satClose',
        }),
        satFor: defineMessage({
            defaultMessage: 'Shot Attempts For',
            description: 'resultFiltersValues.satFor',
        }),
        satPct: defineMessage({
            defaultMessage: 'SAT %',
            description: 'resultFiltersValues.satPct',
        }),
        satPctAhead: defineMessage({
            defaultMessage: 'SAT % - Ahead',
            description: 'resultFiltersValues.satPctAhead',
        }),
        satPctBehind: defineMessage({
            defaultMessage: 'SAT % - Behind',
            description: 'resultFiltersValues.satPctBehind',
        }),
        satPctClose: defineMessage({
            defaultMessage: 'SAT % - Close',
            description: 'resultFiltersValues.satPctClose',
        }),
        satPctTied: defineMessage({
            defaultMessage: 'SAT % - Tied',
            description: 'resultFiltersValues.satPctTied',
        }),
        satPercentage: defineMessage({
            defaultMessage: 'SAT %',
            description: 'resultFiltersValues.satPercentage',
        }),
        satPercentageAhead: defineMessage({
            defaultMessage: 'SAT % Ahead',
            description: 'resultFiltersValues.satPercentageAhead',
        }),
        satPercentageBehind: defineMessage({
            defaultMessage: 'SAT % Behind',
            description: 'resultFiltersValues.satPercentageBehind',
        }),
        satPercentageClose: defineMessage({
            defaultMessage: 'SAT % Close',
            description: 'resultFiltersValues.satPercentageClose',
        }),
        satPercentageTied: defineMessage({
            defaultMessage: 'SAT % Tied',
            description: 'resultFiltersValues.satPercentageTied',
        }),
        satRelative: defineMessage({
            defaultMessage: 'SAT % Relative',
            description: 'resultFiltersValues.satRelative',
        }),
        satRelative5v5: defineMessage({
            defaultMessage: 'Shot Attempts Rel. %',
            description: 'resultFiltersValues.satRelative5v5',
        }),
        satTied: defineMessage({
            defaultMessage: 'Shot Attempts Tied',
            description: 'resultFiltersValues.satTied',
        }),
        satTotal: defineMessage({
            defaultMessage: 'Shot Attempts',
            description: 'resultFiltersValues.satTotal',
        }),
        savePct: defineMessage({
            defaultMessage: 'Save %',
            description: 'resultFiltersValues.savePct',
        }),
        savePct5v5: defineMessage({
            defaultMessage: '5v5 Save %',
            description: 'resultFiltersValues.savePct5v5',
        }),
        savePctDaysRest0: defineMessage({
            defaultMessage: 'Save % 0 Days Rest',
            description: 'resultFiltersValues.savePctDaysRest0',
        }),
        savePctDaysRest1: defineMessage({
            defaultMessage: 'Save % 1 Day Rest',
            description: 'resultFiltersValues.savePctDaysRest1',
        }),
        savePctDaysRest2: defineMessage({
            defaultMessage: 'Save % 2 Days Rest',
            description: 'resultFiltersValues.savePctDaysRest2',
        }),
        savePctDaysRest3: defineMessage({
            defaultMessage: 'Save % 3 Days Rest',
            description: 'resultFiltersValues.savePctDaysRest3',
        }),
        savePctDaysRest4Plus: defineMessage({
            defaultMessage: 'Save % 4 or More Days Rest',
            description: 'resultFiltersValues.savePctDaysRest4Plus',
        }),
        saves: defineMessage({
            defaultMessage: 'Saves',
            description: 'resultFiltersValues.saves',
        }),
        scoringFirstGamesPlayed: defineMessage({
            defaultMessage: 'Scoring First Games Played',
            description: 'resultFiltersValues.scoringFirstGamesPlayed',
        }),
        seasonId: defineMessage({
            defaultMessage: 'Season',
            description: 'resultFiltersValues.seasonId',
        }),
        secondaryAssists5v5: defineMessage({
            defaultMessage: 'Secondary Assists 5v5',
            description: 'resultFiltersValues.secondaryAssists5v5',
        }),
        secondaryAssistsPer605v5: defineMessage({
            defaultMessage: 'Secondary Assists 5v5 per 60',
            description: 'resultFiltersValues.secondaryAssistsPer605v5',
        }),
        secondaryAssistsPerGame: defineMessage({
            defaultMessage: 'Secondary Assists per Game',
            description: 'resultFiltersValues.secondaryAssistsPerGame',
        }),
        shAssists: defineMessage({
            defaultMessage: 'SH Assists',
            description: 'resultFiltersValues.shAssists',
        }),
        shFaceoffLosses: defineMessage({
            defaultMessage: 'Shorthanded Face-offs Lost (since 1997-98)',
            description: 'resultFiltersValues.shFaceoffLosses',
        }),
        shFaceoffPct: defineMessage({
            defaultMessage: 'Shorthanded Face-off Win % (since 1997-98)',
            description: 'resultFiltersValues.shFaceoffPct',
        }),
        shFaceoffWins: defineMessage({
            defaultMessage: 'Shorthanded Face-offs Won (since 1997-98)',
            description: 'resultFiltersValues.shFaceoffWins',
        }),
        shFaceoffs: defineMessage({
            defaultMessage: 'Shorthanded Face-offs (since 1997-98)',
            description: 'resultFiltersValues.shFaceoffs',
        }),
        shFaceoffsLost: defineMessage({
            defaultMessage: 'Shorthanded Face-offs Lost (since 1997-98)',
            description: 'resultFiltersValues.shFaceoffsLost',
        }),
        shFaceoffsWon: defineMessage({
            defaultMessage: 'Shorthanded Face-offs Won (since 1997-98)',
            description: 'resultFiltersValues.shFaceoffsWon',
        }),
        shGoals: defineMessage({
            defaultMessage: 'Shorthanded Goals (since 1933-34)',
            description: 'resultFiltersValues.shGoals',
        }),
        shGoalsAgainst: defineMessage({
            defaultMessage: 'Shorthanded Goals Against',
            description: 'resultFiltersValues.shGoalsAgainst',
        }),
        shGoalsAgainstPerGame: defineMessage({
            defaultMessage: 'Shorthanded Goals Against per Game',
            description: 'resultFiltersValues.shGoalsAgainstPerGame',
        }),
        shGoalsFor: defineMessage({
            defaultMessage: 'Shorthanded Goals For',
            description: 'resultFiltersValues.shGoalsFor',
        }),
        shGoalsForPerGame: defineMessage({
            defaultMessage: 'Shorthanded Goals For per Game',
            description: 'resultFiltersValues.shGoalsForPerGame',
        }),
        shGoalsPer60: defineMessage({
            defaultMessage: 'Shorthanded Goals per 60',
            description: 'resultFiltersValues.shGoalsPer60',
        }),
        shIndividualSatFor: defineMessage({
            defaultMessage: 'Shorthanded Individual SAT For (since 2009-10)',
            description: 'resultFiltersValues.shIndividualSatFor',
        }),
        shIndividualSatForPer60: defineMessage({
            defaultMessage: 'Shorthanded Individual SAT For per 60 (since 2009-10)',
            description: 'resultFiltersValues.shIndividualSatForPer60',
        }),
        shNumTimes: defineMessage({
            defaultMessage: 'Times Shorthanded (since 1977-78)',
            description: 'resultFiltersValues.shNumTimes',
        }),
        shPoints: defineMessage({
            defaultMessage: 'Shorthanded Points (since 1933-34)',
            description: 'resultFiltersValues.shPoints',
        }),
        shPointsPer60: defineMessage({
            defaultMessage: 'Shorthanded Points per 60',
            description: 'resultFiltersValues.shPointsPer60',
        }),
        shPrimaryAssists: defineMessage({
            defaultMessage: 'Shorthanded Primary Assists',
            description: 'resultFiltersValues.shPrimaryAssists',
        }),
        shPrimaryAssistsPer60: defineMessage({
            defaultMessage: 'Shorthanded Primary Assists per 60',
            description: 'resultFiltersValues.shPrimaryAssistsPer60',
        }),
        shSavePct: defineMessage({
            defaultMessage: 'Shorthanded Save %',
            description: 'resultFiltersValues.shSavePct',
        }),
        shSaves: defineMessage({
            defaultMessage: 'Shorthanded Saves',
            description: 'resultFiltersValues.shSaves',
        }),
        shSecondaryAssists: defineMessage({
            defaultMessage: 'Shorthanded Secondary Assists',
            description: 'resultFiltersValues.shSecondaryAssists',
        }),
        shSecondaryAssistsPer60: defineMessage({
            defaultMessage: 'Shorthanded Secondary Assists per 60',
            description: 'resultFiltersValues.shSecondaryAssistsPer60',
        }),
        shShootingPct: defineMessage({
            defaultMessage: 'Shorthanded Shooting Pct',
            description: 'resultFiltersValues.shShootingPct',
        }),
        shShots: defineMessage({
            defaultMessage: 'Shorthanded Shots',
            description: 'resultFiltersValues.shShots',
        }),
        shShotsAgainst: defineMessage({
            defaultMessage: 'Shorthanded Shots Against',
            description: 'resultFiltersValues.shShotsAgainst',
        }),
        shShotsPer60: defineMessage({
            defaultMessage: 'Shorthanded Shots per 60',
            description: 'resultFiltersValues.shShotsPer60',
        }),
        shTimeOnIce: defineMessage({
            defaultMessage: 'SH Time on Ice (minutes)',
            description: 'resultFiltersValues.shTimeOnIce',
        }),
        shTimeOnIcePctPerGame: defineMessage({
            defaultMessage: 'Shorthanded Time on Ice % per Game',
            description: 'resultFiltersValues.shTimeOnIcePctPerGame',
        }),
        shTimeOnIcePerGame: defineMessage({
            defaultMessage: 'Shorthanded Time on Ice per Game (minutes)',
            description: 'resultFiltersValues.shTimeOnIcePerGame',
        }),
        shifts: defineMessage({
            defaultMessage: 'Shifts',
            description: 'resultFiltersValues.shifts',
        }),
        shiftsPerGame: defineMessage({
            defaultMessage: 'Shifts Per Game (since 1997-98)',
            description: 'resultFiltersValues.shiftsPerGame',
        }),
        shootingPct: defineMessage({
            defaultMessage: 'Shooting Percentage (since 1959-60)',
            description: 'resultFiltersValues.shootingPct',
        }),
        shootingPct5v5: defineMessage({
            defaultMessage: '5v5 Shooting %',
            description: 'resultFiltersValues.shootingPct5v5',
        }),
        shootingPctBackhand: defineMessage({
            defaultMessage: 'Shooting % Backhand',
            description: 'resultFiltersValues.shootingPctBackhand',
        }),
        shootingPctBat: defineMessage({
            defaultMessage: 'Shooting Pct Batted in',
            description: 'A phrase that describes a players batted in shooting percentage',
        }),
        shootingPctBetweenLegs: defineMessage({
            defaultMessage: 'Shooting Pct Between the Legs',
            description: 'A phrase that describes a players shooting percentage when the shot is between their legs',
        }),
        shootingPctCradle: defineMessage({
            defaultMessage: 'Shooting Pct Cradle',
            description: 'A phrase that describes a players shooting percentage when the shot is cradled',
        }),
        shootingPctDeflected: defineMessage({
            defaultMessage: 'Shooting % Deflected',
            description: 'resultFiltersValues.shootingPctDeflected',
        }),
        shootingPctPoke: defineMessage({
            defaultMessage: 'Shooting Pct Poke',
            description: 'A phrase that describes a players shooting percentage when the shot is poked',
        }),
        shootingPctSlap: defineMessage({
            defaultMessage: 'Shooting % Slap',
            description: 'resultFiltersValues.shootingPctSlap',
        }),
        shootingPctSnap: defineMessage({
            defaultMessage: 'Shooting % Snap',
            description: 'resultFiltersValues.shootingPctSnap',
        }),
        shootingPctTipIn: defineMessage({
            defaultMessage: 'Shooting % Tip-In',
            description: 'resultFiltersValues.shootingPctTipIn',
        }),
        shootingPctWrapAround: defineMessage({
            defaultMessage: 'Shooting % WrapAround',
            description: 'resultFiltersValues.shootingPctWrapAround',
        }),
        shootingPctWrist: defineMessage({
            defaultMessage: 'Shooting % Wrist',
            description: 'resultFiltersValues.shootingPctWrist',
        }),
        shootingPctg: defineMessage({
            defaultMessage: 'Shooting Percentage (since 1959-60)',
            description: 'resultFiltersValues.shootingPctg',
        }),
        shootingPlusSavePct5v5: defineMessage({
            defaultMessage: '5v5 Shooting + Save %',
            description: 'resultFiltersValues.shootingPlusSavePct5v5',
        }),
        shootoutGameDecidingGoals: defineMessage({
            defaultMessage: 'Game Deciding Goals',
            description: 'resultFiltersValues.shootoutGameDecidingGoals',
        }),
        shootoutGamesPlayed: defineMessage({
            defaultMessage: 'Shootout Games Played',
            description: 'resultFiltersValues.shootoutGamesPlayed',
        }),
        shootoutGoals: defineMessage({
            defaultMessage: 'Shootout Goals',
            description: 'resultFiltersValues.shootoutGoals',
        }),
        shootoutGoalsAgainst: defineMessage({
            defaultMessage: 'Shootout Goals Against',
            description: 'resultFiltersValues.shootoutGoalsAgainst',
        }),
        shootoutLosses: defineMessage({
            defaultMessage: 'Shootout Losses',
            description: 'resultFiltersValues.shootoutLosses',
        }),
        shootoutPoints: defineMessage({
            defaultMessage: 'Shootout Points',
            description: 'resultFiltersValues.shootoutPoints',
        }),
        shootoutSavePct: defineMessage({
            defaultMessage: 'Shootout Save %',
            description: 'resultFiltersValues.shootoutSavePct',
        }),
        shootoutSaves: defineMessage({
            defaultMessage: 'Shootout Saves',
            description: 'resultFiltersValues.shootoutSaves',
        }),
        shootoutShootingPct: defineMessage({
            defaultMessage: 'Shootout Shooting %',
            description: 'resultFiltersValues.shootoutShootingPct',
        }),
        shootoutShootingPlusSavePct: defineMessage({
            defaultMessage: 'Shootout Shooting + Save %',
            description: 'resultFiltersValues.shootoutShootingPlusSavePct',
        }),
        shootoutShots: defineMessage({
            defaultMessage: 'Shootout Shots',
            description: 'resultFiltersValues.shootoutShots',
        }),
        shootoutShotsAgainst: defineMessage({
            defaultMessage: 'Shootout Shots Against',
            description: 'resultFiltersValues.shootoutShotsAgainst',
        }),
        shootoutWinPct: defineMessage({
            defaultMessage: 'Shootout Win %',
            description: 'resultFiltersValues.shootoutWinPct',
        }),
        shootoutWins: defineMessage({
            defaultMessage: 'Shootout Wins',
            description: 'resultFiltersValues.shootoutWins',
        }),
        shootsCatches: defineMessage({
            defaultMessage: 'Player Shoots/Catches',
            description: 'resultFiltersValues.shootsCatches',
        }),
        shotAttemptsBlocked: defineMessage({
            defaultMessage: 'Attempts blocked',
            description:
                'A phrase that describes shot attempts blocked. This is recorded for the player taking a shot not the blocker of the shot',
        }),
        shortHandedGoalsAgainst: defineMessage({
            defaultMessage: 'On-Ice Shorthanded Goals Against',
            description: 'resultFiltersValues.shortHandedGoalsAgainst',
        }),
        shortHandedGoalsFor: defineMessage({
            defaultMessage: 'On-Ice Shorthanded Goals For',
            description: 'resultFiltersValues.shortHandedGoalsFor',
        }),
        shortHandedTimeOnIcePerGame: defineMessage({
            defaultMessage: 'Shorthanded Time On Ice per Game',
            description: 'resultFiltersValues.shortHandedTimeOnIcePerGame',
        }),
        shorthandedGoalsAgainst: defineMessage({
            defaultMessage: 'Shorthanded Goals Against',
            description: 'resultFiltersValues.shorthandedGoalsAgainst',
        }),
        shotDifferentialPerGame: defineMessage({
            defaultMessage: 'Shot Differential per Game',
            description: 'resultFiltersValues.shotDifferentialPerGame',
        }),
        shots: defineMessage({
            defaultMessage: 'Shots (since 1959-60)',
            description: 'resultFiltersValues.shots',
        }),
        shots5v5: defineMessage({
            defaultMessage: 'Shots 5v5',
            description: 'resultFiltersValues.shots5v5',
        }),
        shotsAgainst: defineMessage({
            defaultMessage: 'Shots Against',
            description: 'resultFiltersValues.shotsAgainst',
        }),
        shotsAgainstPer60: defineMessage({
            defaultMessage: 'Shots Against Per 60',
            description: 'resultFiltersValues.shotsAgainstPer60',
        }),
        shotsAgainstPerGame: defineMessage({
            defaultMessage: 'Shots Against per Game (since 1959-60)',
            description: 'resultFiltersValues.shotsAgainstPerGame',
        }),
        shotsFor: defineMessage({
            defaultMessage: 'Shots For',
            description: 'resultFiltersValues.shotsFor',
        }),
        shotsForPerGame: defineMessage({
            defaultMessage: 'Shots For per Game (since 1959-60)',
            description: 'resultFiltersValues.shotsForPerGame',
        }),
        shotsOnNet: defineMessage({
            defaultMessage: 'Shots',
            description: 'resultFiltersValues.shotsOnNet',
        }),
        shotsOnNetBackhand: defineMessage({
            defaultMessage: 'Backhand Shots',
            description: 'resultFiltersValues.shotsOnNetBackhand',
        }),
        shotsOnNetBat: defineMessage({
            defaultMessage: 'Batted in Shots',
            description: 'A phrase that describes how many shots a player batted in on net',
        }),
        shotsOnNetBetweenLegs: defineMessage({
            defaultMessage: 'Between the Legs Shots',
            description: 'A phrase that describes how many shots a player has between their legs',
        }),
        shotsOnNetCradle: defineMessage({
            defaultMessage: 'Cradle Shots',
            description: 'A phrase that describes how many shots a player cradled in on net',
        }),
        shotsOnNetDeflected: defineMessage({
            defaultMessage: 'Deflected Shots',
            description: 'resultFiltersValues.shotsOnNetDeflected',
        }),
        shotsOnNetPoke: defineMessage({
            defaultMessage: 'Poke Shots',
            description: 'A phrase that describes how many shots a player pokes toward the net',
        }),
        shotsOnNetSlap: defineMessage({
            defaultMessage: 'Slap Shots',
            description: 'resultFiltersValues.shotsOnNetSlap',
        }),
        shotsOnNetSnap: defineMessage({
            defaultMessage: 'Snap Shots',
            description: 'resultFiltersValues.shotsOnNetSnap',
        }),
        shotsOnNetTipIn: defineMessage({
            defaultMessage: 'Tipped Shots',
            description: 'resultFiltersValues.shotsOnNetTipIn',
        }),
        shotsOnNetWrapAround: defineMessage({
            defaultMessage: 'Wraparound Shots',
            description: 'resultFiltersValues.shotsOnNetWrapAround',
        }),
        shotsOnNetWrist: defineMessage({
            defaultMessage: 'Wrist Shots',
            description: 'resultFiltersValues.shotsOnNetWrist',
        }),
        shotsPerGame: defineMessage({
            defaultMessage: 'Shots per Game',
            description: 'resultFiltersValues.shotsPerGame',
        }),
        shutouts: defineMessage({
            defaultMessage: 'Shutouts',
            description: 'resultFiltersValues.shutouts',
        }),
        skaterFullName: defineMessage({
            defaultMessage: 'Player Name',
            description: 'resultFiltersValues.skaterFullName',
        }),
        skaterSavePct5v5: defineMessage({
            defaultMessage: 'On-Ice Save %',
            description: 'resultFiltersValues.skaterSavePct5v5',
        }),
        skaterShootingPlusSavePct5v5: defineMessage({
            defaultMessage: 'Shooting Plus Save %',
            description: 'resultFiltersValues.skaterShootingPlusSavePct5v5',
        }),
        takeaways: defineMessage({
            defaultMessage: 'Takeaways',
            description: 'resultFiltersValues.takeaways',
        }),
        takeawaysPer60: defineMessage({
            defaultMessage: 'Takeaways per 60',
            description: 'resultFiltersValues.takeawaysPer60',
        }),
        teamAbbrev: defineMessage({
            defaultMessage: 'Team',
            description: 'resultFiltersValues.teamAbbrev',
        }),
        teamAbbrevs: defineMessage({
            defaultMessage: 'Teams Played For',
            description: 'resultFiltersValues.teamAbbrevs',
        }),
        teamFullName: defineMessage({
            defaultMessage: 'Team',
            description: 'resultFiltersValues.teamFullName',
        }),
        teamShutouts: defineMessage({
            defaultMessage: 'Team Shutouts',
            description: 'A term for the number of games in which a team did not concede any goals to their opponent',
        }),
        ties: defineMessage({
            defaultMessage: 'Ties',
            description: 'resultFiltersValues.ties',
        }),
        tiesEvenShots: defineMessage({
            defaultMessage: 'Overtime Loss Even Shots',
            description: 'resultFiltersValues.tiesEvenShots',
        }),
        tiesLeadPeriod1: defineMessage({
            defaultMessage: 'Ties Leading After Period 1',
            description: 'resultFiltersValues.tiesLeadPeriod1',
        }),
        tiesLeadPeriod2: defineMessage({
            defaultMessage: 'Ties Leading After Period 2',
            description: 'resultFiltersValues.tiesLeadPeriod2',
        }),
        tiesOutshootOpponent: defineMessage({
            defaultMessage: 'Overtime Loss Outshot Opponent',
            description: 'resultFiltersValues.tiesOutshootOpponent',
        }),
        tiesOutshotByOpponent: defineMessage({
            defaultMessage: 'Overtime Loss Outshot by Opponent',
            description: 'resultFiltersValues.tiesOutshotByOpponent',
        }),
        tiesScoringFirst: defineMessage({
            defaultMessage: 'Ties When Scoring First',
            description: 'resultFiltersValues.tiesScoringFirst',
        }),
        tiesTrailPeriod1: defineMessage({
            defaultMessage: 'Ties Trailing After Period 1',
            description: 'resultFiltersValues.tiesTrailPeriod1',
        }),
        tiesTrailPeriod2: defineMessage({
            defaultMessage: 'Ties Trailing After Period 2',
            description: 'resultFiltersValues.tiesTrailPeriod2',
        }),
        tiesTrailingFirst: defineMessage({
            defaultMessage: 'Ties When Trailing First',
            description: 'resultFiltersValues.tiesTrailingFirst',
        }),
        timeOnIce: defineMessage({
            defaultMessage: 'Time on Ice (minutes)',
            description: 'resultFiltersValues.timeOnIce',
        }),
        timeOnIce3v4: defineMessage({
            defaultMessage: 'Time on Ice Three-vs-Four',
            description: 'resultFiltersValues.timeOnIce3v4',
        }),
        timeOnIce3v5: defineMessage({
            defaultMessage: 'Time on Ice Three-vs-Five',
            description: 'resultFiltersValues.timeOnIce3v5',
        }),
        timeOnIce4v3: defineMessage({
            defaultMessage: 'Time on Ice Four-vs-Three',
            description: 'resultFiltersValues.timeOnIce4v3',
        }),
        timeOnIce4v5: defineMessage({
            defaultMessage: 'Time on Ice Four-vs-Five',
            description: 'resultFiltersValues.timeOnIce4v5',
        }),
        timeOnIce5v3: defineMessage({
            defaultMessage: 'Time on Ice Five-vs-Three',
            description: 'resultFiltersValues.timeOnIce5v3',
        }),
        timeOnIce5v4: defineMessage({
            defaultMessage: 'Time on Ice  Five-vs-Four',
            description: 'resultFiltersValues.timeOnIce5v4',
        }),
        timeOnIcePerGame: defineMessage({
            defaultMessage: 'Time On Ice per Game Played (since 1997-98)',
            description: 'resultFiltersValues.timeOnIcePerGame',
        }),
        timeOnIcePerGame5v5: defineMessage({
            defaultMessage: 'TOI 5v5/GP',
            description: 'resultFiltersValues.timeOnIcePerGame5v5',
        }),
        timeOnIcePerShift: defineMessage({
            defaultMessage: 'Time on Ice per Shift (seconds)',
            description: 'resultFiltersValues.timeOnIcePerShift',
        }),
        timeOnIcePp: defineMessage({
            defaultMessage: 'PP Time on Ice (minutes)',
            description: 'resultFiltersValues.timeOnIcePp',
        }),
        timeOnIceShorthanded: defineMessage({
            defaultMessage: 'SH Time on Ice (minutes)',
            description: 'resultFiltersValues.timeOnIceShorthanded',
        }),
        timesShorthanded: defineMessage({
            defaultMessage: 'Times Shorthanded (since 1977-78)',
            description: 'resultFiltersValues.timesShorthanded',
        }),
        timesShorthanded3v4: defineMessage({
            defaultMessage: 'Times Shorthanded Three-vs-Four',
            description: 'resultFiltersValues.timesShorthanded3v4',
        }),
        timesShorthanded3v5: defineMessage({
            defaultMessage: 'Times Shorthanded Three-vs-Five',
            description: 'resultFiltersValues.timesShorthanded3v5',
        }),
        timesShorthanded4v5: defineMessage({
            defaultMessage: 'Times Shorthanded Four-vs-Five',
            description: 'resultFiltersValues.timesShorthanded4v5',
        }),
        timesShorthandedPerGame: defineMessage({
            defaultMessage: 'Times Shorthanded per Game (since 1977-78)',
            description: 'resultFiltersValues.timesShorthandedPerGame',
        }),
        totalFaceoffLosses: defineMessage({
            defaultMessage: 'Face-offs Lost (since 1997-98)',
            description: 'resultFiltersValues.totalFaceoffLosses',
        }),
        totalFaceoffWins: defineMessage({
            defaultMessage: 'Face-offs Won (since 1997-98)',
            description: 'resultFiltersValues.totalFaceoffWins',
        }),
        totalFaceoffs: defineMessage({
            defaultMessage: 'Total Face-offs',
            description: 'resultFiltersValues.totalFaceoffs',
        }),
        totalPenaltiesDrawn: defineMessage({
            defaultMessage: 'Total Penalties Drawn',
            description: 'resultFiltersValues.totalPenaltiesDrawn',
        }),
        totalPrimaryAssists: defineMessage({
            defaultMessage: 'Primary Assists',
            description: 'resultFiltersValues.totalPrimaryAssists',
        }),
        totalSecondaryAssists: defineMessage({
            defaultMessage: 'Secondary Assists',
            description: 'resultFiltersValues.totalSecondaryAssists',
        }),
        trailingFirstGamesPlayed: defineMessage({
            defaultMessage: 'Trailing First Games Played',
            description: 'resultFiltersValues.trailingFirstGamesPlayed',
        }),
        usatAgainst: defineMessage({
            defaultMessage: 'Unblocked Shot Attempts Against',
            description: 'resultFiltersValues.usatAgainst',
        }),
        usatAhead: defineMessage({
            defaultMessage: 'Unblocked Shot Attempts Ahead',
            description: 'resultFiltersValues.usatAhead',
        }),
        usatBehind: defineMessage({
            defaultMessage: 'Unblocked Shot Attempts Behind',
            description: 'resultFiltersValues.usatBehind',
        }),
        usatClose: defineMessage({
            defaultMessage: 'Unblocked Shot Attempts Close',
            description: 'resultFiltersValues.usatClose',
        }),
        usatFor: defineMessage({
            defaultMessage: 'Unblocked Shot Attempts For',
            description: 'resultFiltersValues.usatFor',
        }),
        usatPct: defineMessage({
            defaultMessage: 'USAT %',
            description: 'resultFiltersValues.usatPct',
        }),
        usatPctAhead: defineMessage({
            defaultMessage: 'USAT % - Ahead',
            description: 'resultFiltersValues.usatPctAhead',
        }),
        usatPctBehind: defineMessage({
            defaultMessage: 'USAT % - Behind',
            description: 'resultFiltersValues.usatPctBehind',
        }),
        usatPctClose: defineMessage({
            defaultMessage: 'USAT % - Close',
            description: 'resultFiltersValues.usatPctClose',
        }),
        usatPctTied: defineMessage({
            defaultMessage: 'USAT % - Tied',
            description: 'resultFiltersValues.usatPctTied',
        }),
        usatPercentage: defineMessage({
            defaultMessage: 'USAT %',
            description: 'resultFiltersValues.usatPercentage',
        }),
        usatPercentageAhead: defineMessage({
            defaultMessage: 'USAT % Ahead',
            description: 'resultFiltersValues.usatPercentageAhead',
        }),
        usatPercentageBehind: defineMessage({
            defaultMessage: 'USAT % Behind',
            description: 'resultFiltersValues.usatPercentageBehind',
        }),
        usatPercentageTied: defineMessage({
            defaultMessage: 'USAT % Tied',
            description: 'resultFiltersValues.usatPercentageTied',
        }),
        usatPrecentageClose: defineMessage({
            defaultMessage: 'USAT % Close',
            description: 'resultFiltersValues.usatPrecentageClose',
        }),
        usatRelative: defineMessage({
            defaultMessage: 'Unblocked Shot Attempts Relative',
            description: 'resultFiltersValues.usatRelative',
        }),
        usatTied: defineMessage({
            defaultMessage: 'Unblocked Shot Attempts Tied',
            description: 'resultFiltersValues.usatTied',
        }),
        usatTotal: defineMessage({
            defaultMessage: 'Unblocked Shot Attempts',
            description: 'resultFiltersValues.usatTotal',
        }),
        weight: defineMessage({
            defaultMessage: 'Weight (lbs.)',
            description: 'resultFiltersValues.weight',
        }),
        winPctLeadPeriod1: defineMessage({
            defaultMessage: 'Win % After Lead Period 1',
            description: 'resultFiltersValues.winPctLeadPeriod1',
        }),
        winPctLeadPeriod2: defineMessage({
            defaultMessage: 'Win % After Lead Period 2',
            description: 'resultFiltersValues.winPctLeadPeriod2',
        }),
        winPctOneGoalGames: defineMessage({
            defaultMessage: 'Win % 1-Goal Games',
            description: 'resultFiltersValues.winPctOneGoalGames',
        }),
        winPctScoringFirst: defineMessage({
            defaultMessage: 'Win % When Scoring First',
            description: 'resultFiltersValues.winPctScoringFirst',
        }),
        winPctThreeGoalGames: defineMessage({
            defaultMessage: 'Win % 3-Goal Games',
            description: 'resultFiltersValues.winPctThreeGoalGames',
        }),
        winPctTrailPeriod1: defineMessage({
            defaultMessage: 'Win % After Trail Period 1',
            description: 'resultFiltersValues.winPctTrailPeriod1',
        }),
        winPctTrailPeriod2: defineMessage({
            defaultMessage: 'Win % After Trail Period 2',
            description: 'resultFiltersValues.winPctTrailPeriod2',
        }),
        winPctTrailingFirst: defineMessage({
            defaultMessage: 'Win % When Trailing First',
            description: 'resultFiltersValues.winPctTrailingFirst',
        }),
        winPctTwoGoalGames: defineMessage({
            defaultMessage: 'Win % 2-Goal Games',
            description: 'resultFiltersValues.winPctTwoGoalGames',
        }),
        wins: defineMessage({
            defaultMessage: 'Wins',
            description: 'resultFiltersValues.wins',
        }),
        winsEvenShots: defineMessage({
            defaultMessage: 'Wins Even Shots',
            description: 'resultFiltersValues.winsEvenShots',
        }),
        winsInRegulation: defineMessage({
            defaultMessage: 'Regulation Wins',
            description: 'resultFiltersValues.winsInRegulation',
        }),
        winsInShootout: defineMessage({
            defaultMessage: 'Shootout Games Won (since 2005-06)',
            description: 'resultFiltersValues.winsInShootout',
        }),
        winsLeadPeriod1: defineMessage({
            defaultMessage: 'Wins After Lead Period 1',
            description: 'resultFiltersValues.winsLeadPeriod1',
        }),
        winsLeadPeriod2: defineMessage({
            defaultMessage: 'Wins After Lead Period 2',
            description: 'resultFiltersValues.winsLeadPeriod2',
        }),
        winsOneGoalGames: defineMessage({
            defaultMessage: 'Wins 1-Goal Games',
            description: 'resultFiltersValues.winsOneGoalGames',
        }),
        winsOutshootOpponent: defineMessage({
            defaultMessage: 'Wins Outshot Opponent',
            description: 'resultFiltersValues.winsOutshootOpponent',
        }),
        winsOutshotByOpponent: defineMessage({
            defaultMessage: 'Wins Outshot by Opponent',
            description: 'resultFiltersValues.winsOutshotByOpponent',
        }),
        winsScoringFirst: defineMessage({
            defaultMessage: 'Wins When Scoring First',
            description: 'resultFiltersValues.winsScoringFirst',
        }),
        winsThreeGoalGames: defineMessage({
            defaultMessage: 'Wins 3-Goal Games',
            description: 'resultFiltersValues.winsThreeGoalGames',
        }),
        winsTrailPeriod1: defineMessage({
            defaultMessage: 'Wins After Trail Period 1',
            description: 'resultFiltersValues.winsTrailPeriod1',
        }),
        winsTrailPeriod2: defineMessage({
            defaultMessage: 'Wins After Trail Period 2',
            description: 'resultFiltersValues.winsTrailPeriod2',
        }),
        winsTrailingFirst: defineMessage({
            defaultMessage: 'Wins When Trailing First',
            description: 'resultFiltersValues.winsTrailingFirst',
        }),
        winsTwoGoalGames: defineMessage({
            defaultMessage: 'Wins 2-Goal Games',
            description: 'resultFiltersValues.winsTwoGoalGames',
        }),
        zoneStartPct: defineMessage({
            defaultMessage: 'Percentage of Face-Offs-Offensive Zone',
            description: 'resultFiltersValues.zoneStartPct',
        }),
        zoneStartPct5v5: defineMessage({
            defaultMessage: 'Offensive Zone Face-off %',
            description: 'resultFiltersValues.zoneStartPct5v5',
        }),
    },
    tooltips: {
        assists: defineMessage({
            defaultMessage: 'Assists',
            description: 'tooltips.assists',
        }),
        assists5v5: defineMessage({
            defaultMessage: 'Assists 5v5',
            description: 'tooltips.assists5v5',
        }),
        assistsPer605v5: defineMessage({
            defaultMessage: 'Assists Per 60 Minutes 5v5',
            description: 'tooltips.assistsPer605v5',
        }),
        assistsPerGame: defineMessage({
            defaultMessage: 'Assists per Game Played',
            description: 'tooltips.assistsPerGame',
        }),
        benchMinorPenalties: defineMessage({
            defaultMessage: 'Bench Minor Penalties',
            description: 'tooltips.benchMinorPenalties',
        }),
        birthCity: defineMessage({
            defaultMessage: 'Player Birth City',
            description: 'tooltips.birthCity',
        }),
        birthCountryCode: defineMessage({
            defaultMessage: 'Player Birth Country',
            description: 'tooltips.birthCountryCode',
        }),
        birthDate: defineMessage({
            defaultMessage: 'Player Birth Date',
            description: 'tooltips.birthDate',
        }),
        birthStateProvinceCode: defineMessage({
            defaultMessage: 'Player Birth State (USA) or Province (CAN)',
            description: 'tooltips.birthStateProvinceCode',
        }),
        blockedShots: defineMessage({
            defaultMessage: 'Blocked Shots by Player (since 2005-06)',
            description: 'tooltips.blockedShots',
        }),
        blockedShotsPer60: defineMessage({
            defaultMessage: 'Blocked Shots per 60 (since 2005-06)',
            description: 'tooltips.blockedShotsPer60',
        }),
        blocksPerGame: defineMessage({
            defaultMessage: 'Blocked Shots per Game Played',
            description: 'tooltips.blocksPerGame',
        }),
        careerShootoutGameDecidingGoals: defineMessage({
            defaultMessage: 'Career Shootout Game-Deciding Goals',
            description: 'tooltips.careerShootoutGameDecidingGoals',
        }),
        careerShootoutGamesPlayed: defineMessage({
            defaultMessage: 'Career Shootout Games Played',
            description: 'tooltips.careerShootoutGamesPlayed',
        }),
        careerShootoutGoals: defineMessage({
            defaultMessage: 'Career Shootout Goals',
            description: 'tooltips.careerShootoutGoals',
        }),
        careerShootoutGoalsAllowed: defineMessage({
            defaultMessage: 'Career Shootout Goals Allowed',
            description: 'tooltips.careerShootoutGoalsAllowed',
        }),
        careerShootoutLosses: defineMessage({
            defaultMessage: 'Career Shootout Losses',
            description: 'tooltips.careerShootoutLosses',
        }),
        careerShootoutSavePct: defineMessage({
            defaultMessage: 'Career Shootout Save Percentage',
            description: 'tooltips.careerShootoutSavePct',
        }),
        careerShootoutSaves: defineMessage({
            defaultMessage: 'Career Shootout Saves',
            description: 'tooltips.careerShootoutSaves',
        }),
        careerShootoutShootingPct: defineMessage({
            defaultMessage: 'Career Shootout Shooting Pct',
            description: 'tooltips.careerShootoutShootingPct',
        }),
        careerShootoutShots: defineMessage({
            defaultMessage: 'Career Shootout Shots',
            description: 'tooltips.careerShootoutShots',
        }),
        careerShootoutShotsAgainst: defineMessage({
            defaultMessage: 'Career Shootout Shots Against',
            description: 'tooltips.careerShootoutShotsAgainst',
        }),
        careerShootoutWins: defineMessage({
            defaultMessage: 'Career Shootout Wins',
            description: 'tooltips.careerShootoutWins',
        }),
        completeGamePct: defineMessage({
            defaultMessage: 'Complete Game Percentage',
            description: 'tooltips.completeGamePct',
        }),
        completeGames: defineMessage({
            defaultMessage: 'Complete Games When Starter',
            description: 'tooltips.completeGames',
        }),
        currentTeamAbbrev: defineMessage({
            defaultMessage: 'Current Team',
            description: 'tooltips.currentTeamAbbrev',
        }),
        daysRest: defineMessage({
            defaultMessage: "Days Between Games ('0' = Back-to-Back Games, '4' = 4 or more days)",
            description: 'tooltips.daysRest',
        }),
        defensiveZoneFaceoffLosses: defineMessage({
            defaultMessage: 'Defensive Zone Face-off Losses (since 2009-10)',
            description: 'tooltips.defensiveZoneFaceoffLosses',
        }),
        defensiveZoneFaceoffPct: defineMessage({
            defaultMessage: 'Defensive Zone Face-off Win Percentage (since 2009-10)',
            description: 'tooltips.defensiveZoneFaceoffPct',
        }),
        defensiveZoneStartPct: defineMessage({
            defaultMessage: 'Percentage of Zone Starts, Defensive Zone',
            description: 'A tooltip for a column showing what percentage of zone starts came in the defensive zone',
        }),
        defensiveZoneFaceoffWins: defineMessage({
            defaultMessage: 'Defensive Zone Face-off Wins (since 2009-10)',
            description: 'tooltips.defensiveZoneFaceoffWins',
        }),
        defensiveZoneFaceoffs: defineMessage({
            defaultMessage: 'Defensive Zone Face-offs (since 2009-10)',
            description: 'tooltips.defensiveZoneFaceoffs',
        }),
        draftOverall: defineMessage({
            defaultMessage: 'Player Draft Overall Pick No',
            description: 'tooltips.draftOverall',
        }),
        draftRound: defineMessage({
            defaultMessage: 'Player Draft Round Number',
            description: 'tooltips.draftRound',
        }),
        draftYear: defineMessage({
            defaultMessage: 'Player Draft Year',
            description: 'tooltips.draftYear',
        }),
        emptyNetAssists: defineMessage({
            defaultMessage: 'Empty Net Assists',
            description: 'tooltips.emptyNetAssists',
        }),
        emptyNetGoals: defineMessage({
            defaultMessage: 'Empty Net Goals',
            description: 'tooltips.emptyNetGoals',
        }),
        emptyNetPoints: defineMessage({
            defaultMessage: 'Empty Net Points',
            description: 'tooltips.emptyNetPoints',
        }),
        evFaceoffLosses: defineMessage({
            defaultMessage: 'Even Strength Face-offs Lost (since 1997-98)',
            description: 'tooltips.evFaceoffLosses',
        }),
        emptyNetGoalsAgainst: defineMessage({
            defaultMessage: 'Empty Net Goals Against',
            description: 'A phrase describing how many goals were scored against a team when the goalie was pulled',
        }),
        evFaceoffPct: defineMessage({
            defaultMessage: 'Even Strength Face-off Win Percentage (since 1997-98)',
            description: 'tooltips.evFaceoffPct',
        }),
        evFaceoffWins: defineMessage({
            defaultMessage: 'Even Strength Face-offs Won (since 1997-98)',
            description: 'tooltips.evFaceoffWins',
        }),
        evFaceoffs: defineMessage({
            defaultMessage: 'Even Strength Face-offs (since 1997-98)',
            description: 'tooltips.evFaceoffs',
        }),
        evFaceoffsLost: defineMessage({
            defaultMessage: 'Even Strength Face-offs Lost (since 1997-98)',
            description: 'tooltips.evFaceoffsLost',
        }),
        evFaceoffsWon: defineMessage({
            defaultMessage: 'Even Strength Face-offs Won (since 1997-98)',
            description: 'tooltips.evFaceoffsWon',
        }),
        evGoals: defineMessage({
            defaultMessage: 'Even Strength Goals (since 1933-34)',
            description: 'tooltips.evGoals',
        }),
        evGoalsAgainst: defineMessage({
            defaultMessage: 'Even Strength Goals Against',
            description: 'tooltips.evGoalsAgainst',
        }),
        evGoalsFor: defineMessage({
            defaultMessage: 'Even Strength Goals For',
            description: 'tooltips.evGoalsFor',
        }),
        evPoints: defineMessage({
            defaultMessage: 'Even Strength Points (since 1933-34)',
            description: 'tooltips.evPoints',
        }),
        evSavePct: defineMessage({
            defaultMessage: 'Even Strength Save Percentage',
            description: 'tooltips.evSavePct',
        }),
        evSaves: defineMessage({
            defaultMessage: 'Even Strength Saves',
            description: 'tooltips.evSaves',
        }),
        evShotsAgainst: defineMessage({
            defaultMessage: 'Even Strength Shots Against',
            description: 'tooltips.evShotsAgainst',
        }),
        evTimeOnIce: defineMessage({
            defaultMessage: 'Even Strength Time On Ice',
            description: 'tooltips.evTimeOnIce',
        }),
        evTimeOnIcePerGame: defineMessage({
            defaultMessage: 'Even Strength Time On Ice Per Game Played',
            description: 'tooltips.evTimeOnIcePerGame',
        }),
        evenStrengthGoalDifference: defineMessage({
            defaultMessage: 'On-Ice Even-Strength Goal Differential',
            description: 'tooltips.evenStrengthGoalDifference',
        }),
        evenStrengthGoalsAgainst: defineMessage({
            defaultMessage: 'On-Ice Even Strength Goals Against',
            description: 'tooltips.evenStrengthGoalsAgainst',
        }),
        evenStrengthGoalsFor: defineMessage({
            defaultMessage: 'On-Ice Even Strength Goals For',
            description: 'tooltips.evenStrengthGoalsFor',
        }),
        evenStrengthGoalsForPct: defineMessage({
            defaultMessage: 'Even Strength Goals For Pct',
            description: 'tooltips.evenStrengthGoalsForPct',
        }),
        evenStrengthTimeOnIcePerGame: defineMessage({
            defaultMessage: 'Even Strength Time On Ice Per Game',
            description: 'tooltips.evenStrengthTimeOnIcePerGame',
        }),
        faceoffLosses: defineMessage({
            defaultMessage: 'Face-offs Lost (since 1997-98)',
            description: 'tooltips.faceoffLosses',
        }),
        faceoffPct5v5: defineMessage({
            defaultMessage: 'Face-off Win Percentage 5v5',
            description: 'tooltips.faceoffPct5v5',
        }),
        faceoffWinPct: defineMessage({
            defaultMessage: 'Face-off Win Percentage (since 1997-98)',
            description: 'tooltips.faceoffWinPct',
        }),
        faceoffWins: defineMessage({
            defaultMessage: 'Face-offs Won (since 1997-98)',
            description: 'tooltips.faceoffWins',
        }),
        faceoffsLost: defineMessage({
            defaultMessage: 'Face-offs Lost (since 1997-98)',
            description: 'tooltips.faceoffsLost',
        }),
        faceoffsWon: defineMessage({
            defaultMessage: 'Face-offs Won (since 1997-98)',
            description: 'tooltips.faceoffsWon',
        }),
        firstGoals: defineMessage({
            defaultMessage: 'Times Scored First Goal of Game',
            description: 'tooltips.firstGoals',
        }),
        firstSeasonForGameType: defineMessage({
            defaultMessage: 'First Season For Game Type',
            description: 'tooltips.firstSeasonForGameType',
        }),
        franchiseName: defineMessage({
            defaultMessage: 'Team',
            description: 'tooltips.franchiseName',
        }),
        gameDate: defineMessage({
            defaultMessage: 'Game Date',
            description: 'tooltips.gameDate',
        }),
        gameId: defineMessage({
            defaultMessage: 'Game',
            description: 'tooltips.gameId',
        }),
        gameMisconductPenalties: defineMessage({
            defaultMessage: 'Penalties Game Misconduct',
            description: 'tooltips.gameMisconductPenalties',
        }),
        gameMisconducts: defineMessage({
            defaultMessage: 'Game Misconducts',
            description: 'tooltips.gameMisconducts',
        }),
        gameWinningGoals: defineMessage({
            defaultMessage: 'Game Winning Goals',
            description: 'tooltips.gameWinningGoals',
        }),
        gamesPlayed: defineMessage({
            defaultMessage: 'Games Played',
            description: 'tooltips.gamesPlayed',
        }),
        gamesPlayedDaysRest0: defineMessage({
            defaultMessage: 'Games Played 0 Days Rest',
            description: 'tooltips.gamesPlayedDaysRest0',
        }),
        gamesPlayedDaysRest1: defineMessage({
            defaultMessage: 'Games Played 1 Day Rest',
            description: 'tooltips.gamesPlayedDaysRest1',
        }),
        gamesPlayedDaysRest2: defineMessage({
            defaultMessage: 'Games Played 2 Days Rest',
            description: 'tooltips.gamesPlayedDaysRest2',
        }),
        gamesPlayedDaysRest3: defineMessage({
            defaultMessage: 'Games Played 3 Days Rest',
            description: 'tooltips.gamesPlayedDaysRest3',
        }),
        gamesPlayedDaysRest4Plus: defineMessage({
            defaultMessage: 'Games Played 4 or More Days Rest',
            description: 'tooltips.gamesPlayedDaysRest4Plus',
        }),
        gamesRelieved: defineMessage({
            defaultMessage: 'Games Relieved',
            description: 'tooltips.gamesRelieved',
        }),
        gamesRelievedGoalsAgainst: defineMessage({
            defaultMessage: 'Games Relieved Goals Against',
            description: 'tooltips.gamesRelievedGoalsAgainst',
        }),
        gamesRelievedLosses: defineMessage({
            defaultMessage: 'Games Relieved Losses',
            description: 'tooltips.gamesRelievedLosses',
        }),
        gamesRelievedOtLosses: defineMessage({
            defaultMessage: 'Games Relieved OT Losses',
            description: 'tooltips.gamesRelievedOtLosses',
        }),
        gamesRelievedSavePct: defineMessage({
            defaultMessage: 'Games Relieved Save Percentage',
            description: 'tooltips.gamesRelievedSavePct',
        }),
        gamesRelievedSaves: defineMessage({
            defaultMessage: 'Games Relieved Saves',
            description: 'tooltips.gamesRelievedSaves',
        }),
        gamesRelievedShotsAgainst: defineMessage({
            defaultMessage: 'Games Relieved Shots Against',
            description: 'tooltips.gamesRelievedShotsAgainst',
        }),
        gamesRelievedTies: defineMessage({
            defaultMessage: 'Games Relieved Ties',
            description: 'tooltips.gamesRelievedTies',
        }),
        gamesRelievedWins: defineMessage({
            defaultMessage: 'Games Relieved Wins',
            description: 'tooltips.gamesRelievedWins',
        }),
        gamesStarted: defineMessage({
            defaultMessage: 'Games Started',
            description: 'tooltips.gamesStarted',
        }),
        gamesStartedGoalsAgainst: defineMessage({
            defaultMessage: 'Games Started Goals Against',
            description: 'tooltips.gamesStartedGoalsAgainst',
        }),
        gamesStartedLosses: defineMessage({
            defaultMessage: 'Games Started Losses',
            description: 'tooltips.gamesStartedLosses',
        }),
        gamesStartedOtLosses: defineMessage({
            defaultMessage: 'Games Started OT Losses',
            description: 'tooltips.gamesStartedOtLosses',
        }),
        gamesStartedSavePct: defineMessage({
            defaultMessage: 'Games Started Save Percentage',
            description: 'tooltips.gamesStartedSavePct',
        }),
        gamesStartedSaves: defineMessage({
            defaultMessage: 'Games Started Saves',
            description: 'tooltips.gamesStartedSaves',
        }),
        gamesStartedShotsAgainst: defineMessage({
            defaultMessage: 'Games Started Shots Against',
            description: 'tooltips.gamesStartedShotsAgainst',
        }),
        gamesStartedTies: defineMessage({
            defaultMessage: 'Games Started Ties',
            description: 'tooltips.gamesStartedTies',
        }),
        gamesStartedWins: defineMessage({
            defaultMessage: 'Games Started Wins',
            description: 'tooltips.gamesStartedWins',
        }),
        giveaways: defineMessage({
            defaultMessage: 'Giveaways (since 2005-06)',
            description: 'tooltips.giveaways',
        }),
        giveawaysPer60: defineMessage({
            defaultMessage: 'Giveaways per 60 (since 2005-06)',
            description: 'tooltips.giveawaysPer60',
        }),
        goalieCatches: defineMessage({
            defaultMessage: 'Goalie Catches',
            description: 'tooltips.goalieCatches',
        }),
        goalieFullName: defineMessage({
            defaultMessage: 'Player Name',
            description: 'tooltips.goalieFullName',
        }),
        goalieGoalsAgainst: defineMessage({
            defaultMessage: 'Goalie Goals Against',
            description: 'A phrase describing how many goals were scored against a team when the goalie was in the net',
        }),
        goals: defineMessage({
            defaultMessage: 'Goals',
            description: 'tooltips.goals',
        }),
        goals4v3: defineMessage({
            defaultMessage: 'Goals Four-vs-Three',
            description: 'tooltips.goals4v3',
        }),
        goals5v3: defineMessage({
            defaultMessage: 'Goals Five-vs-Three',
            description: 'tooltips.goals5v3',
        }),
        goals5v4: defineMessage({
            defaultMessage: 'Goals Five-vs-Four',
            description: 'tooltips.goals5v4',
        }),
        goals5v5: defineMessage({
            defaultMessage: 'Goals 5v5',
            description: 'tooltips.goals5v5',
        }),
        goalsAgainst: defineMessage({
            defaultMessage: 'Goals Against',
            description: 'tooltips.goalsAgainst',
        }),
        goalsAgainst3On3: defineMessage({
            defaultMessage: 'Goals Against 3v3',
            description: 'tooltips.goalsAgainst3On3',
        }),
        goalsAgainst3On4: defineMessage({
            defaultMessage: 'Goals Against 3v4',
            description: 'tooltips.goalsAgainst3On4',
        }),
        goalsAgainst3On5: defineMessage({
            defaultMessage: 'Goals Against 3v5',
            description: 'tooltips.goalsAgainst3On5',
        }),
        goalsAgainst3On6: defineMessage({
            defaultMessage: 'Goals Against 3v6',
            description: 'tooltips.goalsAgainst3On6',
        }),
        goalsAgainst3v4: defineMessage({
            defaultMessage: 'Goals Against 3v4',
            description: 'tooltips.goalsAgainst3v4',
        }),
        goalsAgainst3v5: defineMessage({
            defaultMessage: 'Goals Against 3v5',
            description: 'tooltips.goalsAgainst3v5',
        }),
        goalsAgainst4On3: defineMessage({
            defaultMessage: 'Goals Against 4v3',
            description: 'tooltips.goalsAgainst4On3',
        }),
        goalsAgainst4On4: defineMessage({
            defaultMessage: 'Goals Against 4v4',
            description: 'tooltips.goalsAgainst4On4',
        }),
        goalsAgainst4On5: defineMessage({
            defaultMessage: 'Goals Against 4v5',
            description: 'tooltips.goalsAgainst4On5',
        }),
        goalsAgainst4On6: defineMessage({
            defaultMessage: 'Goals Against 4v6',
            description: 'tooltips.goalsAgainst4On6',
        }),
        goalsAgainst4v5: defineMessage({
            defaultMessage: 'Goals Against 4v5',
            description: 'tooltips.goalsAgainst4v5',
        }),
        goalsAgainst5On3: defineMessage({
            defaultMessage: 'Goals Against 5v3',
            description: 'tooltips.goalsAgainst5On3',
        }),
        goalsAgainst5On4: defineMessage({
            defaultMessage: 'Goals Against 5v4',
            description: 'tooltips.goalsAgainst5On4',
        }),
        goalsAgainst5On5: defineMessage({
            defaultMessage: 'Goals Against 5v5',
            description: 'tooltips.goalsAgainst5On5',
        }),
        goalsAgainst5On6: defineMessage({
            defaultMessage: 'Goals Against 5v6',
            description: 'tooltips.goalsAgainst5On6',
        }),
        goalsAgainst6On3: defineMessage({
            defaultMessage: 'Goals Against 6v3',
            description: 'tooltips.goalsAgainst6On3',
        }),
        goalsAgainst6On4: defineMessage({
            defaultMessage: 'Goals Against 6v4',
            description: 'tooltips.goalsAgainst6On4',
        }),
        goalsAgainst6On5: defineMessage({
            defaultMessage: 'Goals Against 6v5',
            description: 'tooltips.goalsAgainst6On5',
        }),
        goalsAgainst6On6: defineMessage({
            defaultMessage: 'Goals Against 6v6',
            description: 'tooltips.goalsAgainst6On6',
        }),
        goalsAgainstAverage: defineMessage({
            defaultMessage: 'Goals Against Average',
            description: 'tooltips.goalsAgainstAverage',
        }),
        goalsAgainstEmptyNet: defineMessage({
            defaultMessage: 'Goals Against Empty Net',
            description: 'A phrase for the amount of goals a team has scored against them when their goalie is pulled',
        }),
        goalsAgainstExtraAttacker: defineMessage({
            defaultMessage: 'Goals Against Extra Attacker',
            description: 'A phrase for the amount of goals a team has scored against them when facing an extra attacker',
        }),
        goalsAgainstPenaltyShots: defineMessage({
            defaultMessage: 'Penalty Shot Goals Against',
            description: 'A phrase the describes how many penalty shots a goaltender or team has allowed',
        }),
        goalsAgainstPerGame: defineMessage({
            defaultMessage: 'Goals Against Per Game Played',
            description: 'tooltips.goalsAgainstPerGame',
        }),
        goalsAgainstPerRegulationLoss: defineMessage({
            defaultMessage: 'Goals Against per Regulation Plus Overtime Losses',
            description: 'tooltips.goalsAgainstPerRegulationLoss',
        }),
        goalsBackhand: defineMessage({
            defaultMessage: 'Backhand Goals (since 2009-10)',
            description: 'tooltips.goalsBackhand',
        }),
        goalsBat: defineMessage({
            defaultMessage: 'Batted in Goals (since 2022-23)',
            description: 'A phrase that describes how many goals a player batted in',
        }),
        goalsBetweenLegs: defineMessage({
            defaultMessage: 'Between the Legs Goals (since 2022-23)',
            description: 'A phrase that describes how many goals a player scored between their legs',
        }),
        goalsCradle: defineMessage({
            defaultMessage: 'Cradle Goals (since 2022-23)',
            description: 'A phrase that describes how many cradle goals a player has',
        }),
        goalsDeflected: defineMessage({
            defaultMessage: 'Goals Deflected (since 2009-10)',
            description: 'tooltips.goalsDeflected',
        }),
        goalsFor: defineMessage({
            defaultMessage: 'Goals For',
            description: 'tooltips.goalsFor',
        }),
        goalsFor3On3: defineMessage({
            defaultMessage: 'Goals For 3v3',
            description: 'tooltips.goalsFor3On3',
        }),
        goalsFor3On4: defineMessage({
            defaultMessage: 'Goals For 3v4',
            description: 'tooltips.goalsFor3On4',
        }),
        goalsFor3On5: defineMessage({
            defaultMessage: 'Goals For 3v5',
            description: 'tooltips.goalsFor3On5',
        }),
        goalsFor3On6: defineMessage({
            defaultMessage: 'Goals For 3v6',
            description: 'tooltips.goalsFor3On6',
        }),
        goalsFor4On3: defineMessage({
            defaultMessage: 'Goals For 4v3',
            description: 'tooltips.goalsFor4On3',
        }),
        goalsFor4On4: defineMessage({
            defaultMessage: 'Goals For 4v4',
            description: 'tooltips.goalsFor4On4',
        }),
        goalsFor4On5: defineMessage({
            defaultMessage: 'Goals For 4v5',
            description: 'tooltips.goalsFor4On5',
        }),
        goalsFor4On6: defineMessage({
            defaultMessage: 'Goals For 4v6',
            description: 'tooltips.goalsFor4On6',
        }),
        goalsFor5On3: defineMessage({
            defaultMessage: 'Goals For 5v3',
            description: 'tooltips.goalsFor5On3',
        }),
        goalsFor5On4: defineMessage({
            defaultMessage: 'Goals For 5v4',
            description: 'tooltips.goalsFor5On4',
        }),
        goalsFor5On5: defineMessage({
            defaultMessage: 'Goals For 5v5',
            description: 'tooltips.goalsFor5On5',
        }),
        goalsFor5On6: defineMessage({
            defaultMessage: 'Goals For 5v6',
            description: 'tooltips.goalsFor5On6',
        }),
        goalsFor6On3: defineMessage({
            defaultMessage: 'Goals For 6v3',
            description: 'tooltips.goalsFor6On3',
        }),
        goalsFor6On4: defineMessage({
            defaultMessage: 'Goals For 6v4',
            description: 'tooltips.goalsFor6On4',
        }),
        goalsFor6On5: defineMessage({
            defaultMessage: 'Goals For 6v5',
            description: 'tooltips.goalsFor6On5',
        }),
        goalsFor6On6: defineMessage({
            defaultMessage: 'Goals For 6v6',
            description: 'A phrase for the amount of goals a team scored when both teams have 6 skaters on the ice',
        }),
        goalsAgainstAllPulls: defineMessage({
            defaultMessage: 'Goals Against All Pulls',
            description: 'A phrase for the amount of goals scored against a team when either goalie is pulled',
        }),
        goalsForAllPulls: defineMessage({
            defaultMessage: 'Goals For All Pulls',
            description: 'A phrase for the amount of goals a team scored when either goalie is pulled',
        }),
        goalsForAverage: defineMessage({
            defaultMessage: 'Goals For Average',
            description: 'tooltips.goalsForAverage',
        }),
        goalsForEmptyNet: defineMessage({
            defaultMessage: 'Empty Net Goals For',
            description: 'A phrase for empty net goals a team scored',
        }),
        goalsForExtraAttacker: defineMessage({
            defaultMessage: 'Extra Attacker Goals For',
            description: 'A phrase for the amount of goals your team scored when you have an extra attacker',
        }),
        goalsForPct: defineMessage({
            defaultMessage: 'Goals For Percentage',
            description: 'tooltips.goalsForPct',
        }),
        goalsForPenaltyShots: defineMessage({
            defaultMessage: 'Penalty Shot Goals For',
            description: 'A phrase the describes how many penalty shots a player or team has scored',
        }),
        goalsForPerGame: defineMessage({
            defaultMessage: 'Goals For Per Game Played',
            description: 'tooltips.goalsForPerGame',
        }),
        goalsPct: defineMessage({
            defaultMessage: 'On-Ice Goals For Pct 5v5',
            description: 'tooltips.goalsPct',
        }),
        goalsPer605v5: defineMessage({
            defaultMessage: 'Goals 5v5 Per 60 Minutes',
            description: 'tooltips.goalsPer605v5',
        }),
        goalsPerGame: defineMessage({
            defaultMessage: 'Goals Per Game Played',
            description: 'tooltips.goalsPerGame',
        }),
        goalsPoke: defineMessage({
            defaultMessage: 'Poke Goals (since 2022-23)',
            description: 'A phrase that describes how many goals a player poked in',
        }),
        goalsSlap: defineMessage({
            defaultMessage: 'Slap Shot Goals (since 2009-10)',
            description: 'tooltips.goalsSlap',
        }),
        goalsSnap: defineMessage({
            defaultMessage: 'Snap Shot Goals (since 2009-10)',
            description: 'tooltips.goalsSnap',
        }),
        goalsTipIn: defineMessage({
            defaultMessage: 'Goals Tipped (since 2009-10)',
            description: 'tooltips.goalsTipIn',
        }),
        goalsWrapAround: defineMessage({
            defaultMessage: 'Wrap Around Goals (since 2009-10)',
            description: 'tooltips.goalsWrapAround',
        }),
        goalsWrist: defineMessage({
            defaultMessage: 'Wrist Shot Goals (since 2009-10)',
            description: 'tooltips.goalsWrist',
        }),
        height: defineMessage({
            defaultMessage: 'Player Height',
            description: 'tooltips.height',
        }),
        hits: defineMessage({
            defaultMessage: 'Hits',
            description: 'tooltips.hits',
        }),
        hitsPer60: defineMessage({
            defaultMessage: 'Hits per 60 (since 2005-06)',
            description: 'tooltips.hitsPer60',
        }),
        hitsPerGame: defineMessage({
            defaultMessage: 'Hits per Game Played',
            description: 'tooltips.hitsPerGame',
        }),
        homeRoad: defineMessage({
            defaultMessage: 'Home or Road',
            description: 'tooltips.homeRoad',
        }),
        incompleteGames: defineMessage({
            defaultMessage: 'Incomplete Games When Starter',
            description: 'tooltips.incompleteGames',
        }),
        individualSatForPer60: defineMessage({
            defaultMessage: 'Individual Shot Attempts For per 60',
            description: 'tooltips.individualSatForPer60',
        }),
        individualShotsForPer60: defineMessage({
            defaultMessage: 'Individual 5v5 Shots For per 60 minutes',
            description: 'tooltips.individualShotsForPer60',
        }),
        isInHallOfFameYn: defineMessage({
            defaultMessage: 'In Hall of Fame',
            description: 'tooltips.isInHallOfFameYn',
        }),
        lossLeadPeriod1: defineMessage({
            defaultMessage: 'Loss After Lead Period 1',
            description: 'tooltips.lossLeadPeriod1',
        }),
        lossLeadPeriod2: defineMessage({
            defaultMessage: 'Loss After Lead Period 2',
            description: 'tooltips.lossLeadPeriod2',
        }),
        lossTrailPeriod1: defineMessage({
            defaultMessage: 'Loss After Trail Period 1',
            description: 'tooltips.lossTrailPeriod1',
        }),
        lossTrailPeriod2: defineMessage({
            defaultMessage: 'Loss After Trail Period 2',
            description: 'tooltips.lossTrailPeriod2',
        }),
        losses: defineMessage({
            defaultMessage: 'Losses',
            description: 'tooltips.losses',
        }),
        lossesEvenShots: defineMessage({
            defaultMessage: 'Loss Even Shots',
            description: 'tooltips.lossesEvenShots',
        }),
        lossesOneGoalGames: defineMessage({
            defaultMessage: 'Loss 1 Goal Game',
            description: 'tooltips.lossesOneGoalGames',
        }),
        lossesOutshootOpponent: defineMessage({
            defaultMessage: 'Loss Outshot Opponent',
            description: 'tooltips.lossesOutshootOpponent',
        }),
        lossesOutshotByOpponent: defineMessage({
            defaultMessage: 'Loss Outshot by Opponent',
            description: 'tooltips.lossesOutshotByOpponent',
        }),
        lossesScoringFirst: defineMessage({
            defaultMessage: 'Losses When Scoring First',
            description: 'tooltips.lossesScoringFirst',
        }),
        lossesThreeGoalGames: defineMessage({
            defaultMessage: 'Loss 3 Goal Game',
            description: 'tooltips.lossesThreeGoalGames',
        }),
        lossesTrailingFirst: defineMessage({
            defaultMessage: 'Losses When Trailing First',
            description: 'tooltips.lossesTrailingFirst',
        }),
        lossesTwoGoalGames: defineMessage({
            defaultMessage: 'Loss 2 Goal Game',
            description: 'tooltips.lossesTwoGoalGames',
        }),
        majorPenalties: defineMessage({
            defaultMessage: 'Penalties Major',
            description: 'tooltips.majorPenalties',
        }),
        majors: defineMessage({
            defaultMessage: 'Major Penalties',
            description: 'tooltips.majors',
        }),
        matchPenalties: defineMessage({
            defaultMessage: 'Match Penalties',
            description: 'tooltips.matchPenalties',
        }),
        minorPenalties: defineMessage({
            defaultMessage: 'Penalties Minor',
            description: 'tooltips.minorPenalties',
        }),
        minors: defineMessage({
            defaultMessage: 'Minor Penalties',
            description: 'tooltips.minors',
        }),
        misconductPenalties: defineMessage({
            defaultMessage: 'Penalties Misconduct',
            description: 'tooltips.misconductPenalties',
        }),
        misconducts: defineMessage({
            defaultMessage: 'Misconduct Penalties',
            description: 'tooltips.misconducts',
        }),
        missedShotCrossbar: defineMessage({
            defaultMessage: 'Missed Shot Hit Crossbar (since 2009-10)',
            description: 'tooltips.missedShotCrossbar',
        }),
        missedShotGoalpost: defineMessage({
            defaultMessage: 'Missed Shots Hit Post (since 2009-10)',
            description: 'tooltips.missedShotGoalpost',
        }),
        missedShotOverNet: defineMessage({
            defaultMessage: 'Missed Shots Over Net (since 2009-10)',
            description: 'tooltips.missedShotOverNet',
        }),
        missedShotShort: defineMessage({
            defaultMessage: 'Missed Shots Short (since 2023-24)',
            description: 'tooltips.missedShotShort',
        }),
        missedShotWideOfNet: defineMessage({
            defaultMessage: 'Missed Shots Wide of Net (since 2009-10)',
            description: 'tooltips.missedShotWideOfNet',
        }),
        missedShots: defineMessage({
            defaultMessage: 'Missed Shots (since 2005-06)',
            description: 'tooltips.missedShots',
        }),
        nationalityCode: defineMessage({
            defaultMessage: 'Player Nationality',
            description: 'tooltips.nationalityCode',
        }),
        netGoalsPerGame: defineMessage({
            defaultMessage: 'Net Goals per Game Played',
            description: 'tooltips.netGoalsPerGame',
        }),
        netMinorPenaltiesPer60: defineMessage({
            defaultMessage: 'Net Minor Penalties 5v5 per 60 Minutes 5v5',
            description: 'tooltips.netMinorPenaltiesPer60',
        }),
        netPenalties: defineMessage({
            defaultMessage: 'Net Penalties',
            description: 'tooltips.netPenalties',
        }),
        netPenaltiesPer60: defineMessage({
            defaultMessage: 'Net Penalties per 60 Minutes',
            description: 'tooltips.netPenaltiesPer60',
        }),
        netShotsPerGame: defineMessage({
            defaultMessage: 'Net Shots per Game',
            description: 'tooltips.netShotsPerGame',
        }),
        neutralZoneFaceoffLosses: defineMessage({
            defaultMessage: 'Neutral Zone Face-off Losses (since 2009-10)',
            description: 'tooltips.neutralZoneFaceoffLosses',
        }),
        neutralZoneFaceoffPct: defineMessage({
            defaultMessage: 'Neutral Zone Face-off Win Percentage (since 2009-10)',
            description: 'tooltips.neutralZoneFaceoffPct',
        }),
        neutralZoneStartPct: defineMessage({
            defaultMessage: 'Percentage of Zone Starts, Neutral Zone',
            description: 'A tooltip for a column showing what percentage of zone starts came in the neutral zone',
        }),
        neutralZoneFaceoffWins: defineMessage({
            defaultMessage: 'Neutral Zone Face-off Wins (since 2009-10)',
            description: 'tooltips.neutralZoneFaceoffWins',
        }),
        neutralZoneFaceoffs: defineMessage({
            defaultMessage: 'Neutral Zone Face-off (since 2009-10)',
            description: 'tooltips.neutralZoneFaceoffs',
        }),
        offensiveZoneFaceoffLosses: defineMessage({
            defaultMessage: 'Offensive Zone Face-off Losses (since 2009-10)',
            description: 'tooltips.offensiveZoneFaceoffLosses',
        }),
        offensiveZoneFaceoffPct: defineMessage({
            defaultMessage: 'Offensive Zone Face-off Win Percentage (since 2009-10)',
            description: 'tooltips.offensiveZoneFaceoffPct',
        }),
        offensiveZoneStartRatio: defineMessage({
            defaultMessage: 'Offensive Zone Start Ratio (excludes neutral zone starts)',
            description: 'A phrase that describes what ratio of face-offs start in the team\'s offensive zone, excluding the neutral zone',
        }),
        offensiveZoneStartPct: defineMessage({
            defaultMessage: 'Percentage of Zone Starts, Offensive Zone',
            description: 'A tooltip for a column showing what percentage of zone starts came in the offensive zone',
        }),
        offensiveZoneFaceoffWins: defineMessage({
            defaultMessage: 'Offensive Zone Face-off Wins (since 2009-10)',
            description: 'tooltips.offensiveZoneFaceoffWins',
        }),
        offensiveZoneFaceoffs: defineMessage({
            defaultMessage: 'Offensive Zone Face-offs (since 2009-10)',
            description: 'tooltips.offensiveZoneFaceoffs',
        }),
        offensiveZoneStartPct5v5: defineMessage({
            defaultMessage: 'Offensive Zone Face-off Percentage 5v5',
            description: 'tooltips.offensiveZoneStartPct5v5',
        }),
        onIceGoalsAgainst: defineMessage({
            defaultMessage: 'Goals Against',
            description: 'tooltips.onIceGoalsAgainst',
        }),
        onIceGoalsFor: defineMessage({
            defaultMessage: 'Goals For',
            description: 'tooltips.onIceGoalsFor',
        }),
        onIceShootingPct: defineMessage({
            defaultMessage: '5v5 On-Ice Shooting Percentage',
            description: 'tooltips.onIceShootingPct',
        }),
        onIceShootingPct5v5: defineMessage({
            defaultMessage: 'On-Ice Shooting Percentage 5v5',
            description: 'tooltips.onIceShootingPct5v5',
        }),
        opponentTeamAbbrev: defineMessage({
            defaultMessage: 'Opponent Team',
            description: 'tooltips.opponentTeamAbbrev',
        }),
        opportunities4v3: defineMessage({
            defaultMessage: 'Opportunities Four-vs-Three',
            description: 'tooltips.opportunities4v3',
        }),
        opportunities5v3: defineMessage({
            defaultMessage: 'Opportunities Five-vs-Three',
            description: 'tooltips.opportunities5v3',
        }),
        opportunities5v4: defineMessage({
            defaultMessage: 'Opportunities Five-vs-Four',
            description: 'tooltips.opportunities5v4',
        }),
        otGoals: defineMessage({
            defaultMessage: 'Overtime Goals',
            description: 'tooltips.otGoals',
        }),
        otLossLeadPeriod1: defineMessage({
            defaultMessage: 'Overtime Loss After Lead Period 1',
            description: 'tooltips.otLossLeadPeriod1',
        }),
        otLossLeadPeriod2: defineMessage({
            defaultMessage: 'Overtime Loss After Lead Period 2',
            description: 'tooltips.otLossLeadPeriod2',
        }),
        otLossTrailPeriod1: defineMessage({
            defaultMessage: 'Overtime Loss After Trail Period 1',
            description: 'tooltips.otLossTrailPeriod1',
        }),
        otLossTrailPeriod2: defineMessage({
            defaultMessage: 'Overtime Loss After Trail Period 2',
            description: 'tooltips.otLossTrailPeriod2',
        }),
        otLosses: defineMessage({
            defaultMessage: 'Overtime Losses',
            description: 'tooltips.otLosses',
        }),
        otLossesEvenShots: defineMessage({
            defaultMessage: 'Overtime Loss Even Shots',
            description: 'tooltips.otLossesEvenShots',
        }),
        otLossesOneGoalGames: defineMessage({
            defaultMessage: 'Overtime Loss 1 Goal Game',
            description: 'tooltips.otLossesOneGoalGames',
        }),
        otLossesOutshootOpponent: defineMessage({
            defaultMessage: 'Overtime Loss Outshot Opponent',
            description: 'tooltips.otLossesOutshootOpponent',
        }),
        otLossesOutshotByOpponent: defineMessage({
            defaultMessage: 'Overtime Loss Outshot by Opponent',
            description: 'tooltips.otLossesOutshotByOpponent',
        }),
        otLossesScoringFirst: defineMessage({
            defaultMessage: 'Overtime Losses When Scoring First',
            description: 'tooltips.otLossesScoringFirst',
        }),
        otLossesTrailingFirst: defineMessage({
            defaultMessage: 'Overtime Losses When Trailing First',
            description: 'tooltips.otLossesTrailingFirst',
        }),
        otPoints: defineMessage({
            defaultMessage: 'Overtime Points',
            description: 'tooltips.otPoints',
        }),
        otTimeOnIce: defineMessage({
            defaultMessage: 'Overtime Time on Ice (since 2009-10)',
            description: 'tooltips.otTimeOnIce',
        }),
        otTimeOnIcePerOtGame: defineMessage({
            defaultMessage: 'Overtime Time on Ice Per Overtime Game Played (since 2009-10)',
            description: 'tooltips.otTimeOnIcePerOtGame',
        }),
        overallPenaltyKillPct: defineMessage({
            defaultMessage: 'Penalty Kill Percentage',
            description: 'tooltips.overallPenaltyKillPct',
        }),
        overallPowerPlayPct: defineMessage({
            defaultMessage: 'Power Play Percentage',
            description: 'tooltips.overallPowerPlayPct',
        }),
        penalties: defineMessage({
            defaultMessage: 'Penalties Taken',
            description: 'tooltips.penalties',
        }),
        penaltiesDrawn: defineMessage({
            defaultMessage: 'Penalties Drawn',
            description: 'tooltips.penaltiesDrawn',
        }),
        penaltiesDrawnPer60: defineMessage({
            defaultMessage: 'Penalties Drawn per 60 Minutes',
            description: 'tooltips.penaltiesDrawnPer60',
        }),
        penaltiesTakenPer60: defineMessage({
            defaultMessage: 'Penalties Taken per 60 Minutes',
            description: 'tooltips.penaltiesTakenPer60',
        }),
        penaltyKillNetPct: defineMessage({
            defaultMessage: 'Penalty Kill Net Pct',
            description: 'tooltips.penaltyKillNetPct',
        }),
        penaltyKillPct: defineMessage({
            defaultMessage: 'Penalty Kill Percentage (since 1977-78)',
            description: 'tooltips.penaltyKillPct',
        }),
        penaltyKillPct3v4: defineMessage({
            defaultMessage: 'Three-vs-Four Penalty Kill Percentage',
            description: 'tooltips.penaltyKillPct3v4',
        }),
        penaltyKillPct3v5: defineMessage({
            defaultMessage: 'Three-vs-Five Penalty Kill Percentage',
            description: 'tooltips.penaltyKillPct3v5',
        }),
        penaltyKillPct4v5: defineMessage({
            defaultMessage: 'Four-vs-Five Penalty Kill Percentage',
            description: 'tooltips.penaltyKillPct4v5',
        }),
        penaltyMinutes: defineMessage({
            defaultMessage: 'Penalty Minutes',
            description: 'tooltips.penaltyMinutes',
        }),
        penaltyMinutesPerGame: defineMessage({
            defaultMessage: 'Penalty Minutes Per Game Played',
            description: 'tooltips.penaltyMinutesPerGame',
        }),
        penaltyMinutesPerTimeOnIce: defineMessage({
            defaultMessage: 'Penalty Minutes per Time on Ice',
            description: 'tooltips.penaltyMinutesPerTimeOnIce',
        }),
        penaltySecondsPerGame: defineMessage({
            defaultMessage: 'Penalty Minutes per Game',
            description: 'tooltips.penaltySecondsPerGame',
        }),
        penaltyShotAttempts: defineMessage({
            defaultMessage: 'Penalty Shot Attempts',
            description: 'tooltips.penaltyShotAttempts',
        }),
        penaltyShotSavePct: defineMessage({
            defaultMessage: 'Penalty Shot Save Percentage',
            description: 'tooltips.penaltyShotSavePct',
        }),
        penaltyShotShootingPct: defineMessage({
            defaultMessage: 'Penalty Shot Shooting Pct',
            description: 'tooltips.penaltyShotShootingPct',
        }),
        penaltyShotsAgainst: defineMessage({
            defaultMessage: 'Penalty Shot Shots Against',
            description: 'tooltips.penaltyShotsAgainst',
        }),
        penaltyShotsFailed: defineMessage({
            defaultMessage: 'Penalty Shots Failed',
            description: 'tooltips.penaltyShotsFailed',
        }),
        penaltyShotsGoals: defineMessage({
            defaultMessage: 'Penalty Shot Goals',
            description: 'tooltips.penaltyShotsGoals',
        }),
        penaltyShotsGoalsAgainst: defineMessage({
            defaultMessage: 'Penalty Shot Goals Against',
            description: 'tooltips.penaltyShotsGoalsAgainst',
        }),
        penaltyShotsSaves: defineMessage({
            defaultMessage: 'Penalty Shot Saves',
            description: 'tooltips.penaltyShotsSaves',
        }),
        period1GoalsAgainst: defineMessage({
            defaultMessage: 'Goals Against In Period 1',
            description: 'tooltips.period1GoalsAgainst',
        }),
        period1GoalsFor: defineMessage({
            defaultMessage: 'Goals For In Period 1',
            description: 'tooltips.period1GoalsFor',
        }),
        period2GoalsAgainst: defineMessage({
            defaultMessage: 'Goals Against In Period 2',
            description: 'tooltips.period2GoalsAgainst',
        }),
        period2GoalsFor: defineMessage({
            defaultMessage: 'Goals For In Period 2',
            description: 'tooltips.period2GoalsFor',
        }),
        period3GoalsAgainst: defineMessage({
            defaultMessage: 'Goals Against In Period 3',
            description: 'tooltips.period3GoalsAgainst',
        }),
        period3GoalsFor: defineMessage({
            defaultMessage: 'Goals For In Period 3',
            description: 'tooltips.period3GoalsFor',
        }),
        periodOtGoalsAgainst: defineMessage({
            defaultMessage: 'Goals Against In Overtime',
            description: 'tooltips.periodOtGoalsAgainst',
        }),
        periodOtGoalsFor: defineMessage({
            defaultMessage: 'Goals For In OT',
            description: 'tooltips.periodOtGoalsFor',
        }),
        pkNetGoals: defineMessage({
            defaultMessage: 'Short Handed Net Goals',
            description: 'tooltips.pkNetGoals',
        }),
        pkNetGoalsPerGame: defineMessage({
            defaultMessage: 'Short Handed Net Goals per Game',
            description: 'tooltips.pkNetGoalsPerGame',
        }),
        pkPctg: defineMessage({
            defaultMessage: 'Penalty Kill Percentage (since 1977-78)',
            description: 'tooltips.pkPctg',
        }),
        pkTimeOnIcePerGame: defineMessage({
            defaultMessage: 'Penalty Kill Time on Ice per Game (since 1997-98)',
            description: 'tooltips.pkTimeOnIcePerGame',
        }),
        playerShoots: defineMessage({
            defaultMessage: 'Skater Shoots',
            description: 'tooltips.playerShoots',
        }),
        playerTeamsPlayedFor: defineMessage({
            defaultMessage: 'Player Teams Played For',
            description: 'tooltips.playerTeamsPlayedFor',
        }),
        plusMinus: defineMessage({
            defaultMessage: 'Plus-Minus (since 1959-60)',
            description: 'tooltips.plusMinus',
        }),
        pointPct: defineMessage({
            defaultMessage: 'Point Pctg',
            description: 'tooltips.pointPct',
        }),
        points: defineMessage({
            defaultMessage: 'Points',
            description: 'tooltips.points',
        }),
        points5v5: defineMessage({
            defaultMessage: 'Points 5v5',
            description: 'tooltips.points5v5',
        }),
        pointsPct: defineMessage({
            defaultMessage: 'Point Percentage',
            description: 'tooltips.pointsPct',
        }),
        pointsPer605v5: defineMessage({
            defaultMessage: 'Points 5v5 Per 60 Minutes 5v5',
            description: 'tooltips.pointsPer605v5',
        }),
        pointsPerGame: defineMessage({
            defaultMessage: 'Points per Game Played',
            description: 'tooltips.pointsPerGame',
        }),
        positionCode: defineMessage({
            defaultMessage: 'Player Position',
            description: 'tooltips.positionCode',
        }),
        powerPlayGoalFor: defineMessage({
            defaultMessage: 'On-Ice Power Play Goals For',
            description: 'tooltips.powerPlayGoalFor',
        }),
        powerPlayGoalsAgainst: defineMessage({
            defaultMessage: 'On-Ice Power Play Goals Against',
            description: 'tooltips.powerPlayGoalsAgainst',
        }),
        powerPlayGoalsFor: defineMessage({
            defaultMessage: 'Power Play Goals For',
            description: 'tooltips.powerPlayGoalsFor',
        }),
        powerPlayNetPct: defineMessage({
            defaultMessage: 'Power Play Net Pct',
            description: 'tooltips.powerPlayNetPct',
        }),
        powerPlayPct: defineMessage({
            defaultMessage: 'Power Play Percentage (since 1977-78)',
            description: 'tooltips.powerPlayPct',
        }),
        powerPlayPct4v3: defineMessage({
            defaultMessage: 'Four-vs-Three Power Play Percentage',
            description: 'tooltips.powerPlayPct4v3',
        }),
        powerPlayPct5v3: defineMessage({
            defaultMessage: 'Five-vs-Three Power Play Percentage',
            description: 'tooltips.powerPlayPct5v3',
        }),
        powerPlayPct5v4: defineMessage({
            defaultMessage: 'Five-vs-Four Power Play Percentage',
            description: 'tooltips.powerPlayPct5v4',
        }),
        powerPlayTimeOnIcePerGame: defineMessage({
            defaultMessage: 'Power Play Time On Ice Per Game',
            description: 'tooltips.powerPlayTimeOnIcePerGame',
        }),
        ppAssists: defineMessage({
            defaultMessage: 'Power Play Assists (since 1933-34)',
            description: 'tooltips.ppAssists',
        }),
        ppFaceoffLosses: defineMessage({
            defaultMessage: 'Power Play Face-offs Lost (since 1997-98)',
            description: 'tooltips.ppFaceoffLosses',
        }),
        ppFaceoffPct: defineMessage({
            defaultMessage: 'Power Play Face-off Win Percentage (since 1997-98)',
            description: 'tooltips.ppFaceoffPct',
        }),
        ppFaceoffWins: defineMessage({
            defaultMessage: 'Power Play Face-offs Won (since 1997-98)',
            description: 'tooltips.ppFaceoffWins',
        }),
        ppFaceoffs: defineMessage({
            defaultMessage: 'Power Play Face-offs (since 1997-98)',
            description: 'tooltips.ppFaceoffs',
        }),
        ppFaceoffsLost: defineMessage({
            defaultMessage: 'Power Play Face-offs Lost (since 1997-98)',
            description: 'tooltips.ppFaceoffsLost',
        }),
        ppFaceoffsWon: defineMessage({
            defaultMessage: 'Power Play Face-offs Won (since 1997-98)',
            description: 'tooltips.ppFaceoffsWon',
        }),
        ppGoals: defineMessage({
            defaultMessage: 'Power Play Goals (since 1933-34)',
            description: 'tooltips.ppGoals',
        }),
        ppGoalsAgainst: defineMessage({
            defaultMessage: 'Power Play Goals Against (since 1933-34)',
            description: 'tooltips.ppGoalsAgainst',
        }),
        ppGoalsAgainstPer60: defineMessage({
            defaultMessage: 'Power Play Goals Against per 60 minutes',
            description: 'tooltips.ppGoalsAgainstPer60',
        }),
        ppGoalsAgainstPerGame: defineMessage({
            defaultMessage: 'Power Play Goals Against per Game',
            description: 'tooltips.ppGoalsAgainstPerGame',
        }),
        ppGoalsFor: defineMessage({
            defaultMessage: 'Power Play Goals For (since 1933-34)',
            description: 'tooltips.ppGoalsFor',
        }),
        ppGoalsForPer60: defineMessage({
            defaultMessage: 'Power Play Goals For per 60 minutes',
            description: 'tooltips.ppGoalsForPer60',
        }),
        ppGoalsPer60: defineMessage({
            defaultMessage: 'Power Play Goals per 60',
            description: 'tooltips.ppGoalsPer60',
        }),
        ppGoalsPerGame: defineMessage({
            defaultMessage: 'Power Play Goals per Game',
            description: 'tooltips.ppGoalsPerGame',
        }),
        ppIndividualSatFor: defineMessage({
            defaultMessage: 'Power Play Individual SAT For (since 2009-10)',
            description: 'tooltips.ppIndividualSatFor',
        }),
        ppIndividualSatForPer60: defineMessage({
            defaultMessage: 'Power Play Individual SAT For per 60 (since 2009-10)',
            description: 'tooltips.ppIndividualSatForPer60',
        }),
        ppNetGoals: defineMessage({
            defaultMessage: 'Power Play Net Goals',
            description: 'tooltips.ppNetGoals',
        }),
        ppNetGoalsPerGame: defineMessage({
            defaultMessage: 'Power Play Net Goals per Game',
            description: 'tooltips.ppNetGoalsPerGame',
        }),
        ppOpportunities: defineMessage({
            defaultMessage: 'Power Play Opportunities (since 1977-78)',
            description: 'tooltips.ppOpportunities',
        }),
        ppOpportunitiesPerGame: defineMessage({
            defaultMessage: 'Power Play Opportunities per Game Played (since 1977-78)',
            description: 'tooltips.ppOpportunitiesPerGame',
        }),
        ppPctg: defineMessage({
            defaultMessage: 'Power Play Percentage (since 1977-78)',
            description: 'tooltips.ppPctg',
        }),
        ppPoints: defineMessage({
            defaultMessage: 'Power Play Points (since 1933-34)',
            description: 'tooltips.ppPoints',
        }),
        ppPointsPer60: defineMessage({
            defaultMessage: 'Power Play Points per 60',
            description: 'tooltips.ppPointsPer60',
        }),
        ppPrimaryAssists: defineMessage({
            defaultMessage: 'Power Play Primary Assists',
            description: 'tooltips.ppPrimaryAssists',
        }),
        ppPrimaryAssistsPer60: defineMessage({
            defaultMessage: 'Power Play Primary Assists per 60',
            description: 'tooltips.ppPrimaryAssistsPer60',
        }),
        ppSavePct: defineMessage({
            defaultMessage: 'Power Play Save Percentage',
            description: 'tooltips.ppSavePct',
        }),
        ppSaves: defineMessage({
            defaultMessage: 'Power Play Saves',
            description: 'tooltips.ppSaves',
        }),
        ppSecondaryAssists: defineMessage({
            defaultMessage: 'Power Play Secondary Assists',
            description: 'tooltips.ppSecondaryAssists',
        }),
        ppSecondaryAssistsPer60: defineMessage({
            defaultMessage: 'Power Play Secondary Assists per 60',
            description: 'tooltips.ppSecondaryAssistsPer60',
        }),
        ppShootingPct: defineMessage({
            defaultMessage: 'Power Play Shooting Pct',
            description: 'tooltips.ppShootingPct',
        }),
        ppShots: defineMessage({
            defaultMessage: 'Power Play Shots',
            description: 'tooltips.ppShots',
        }),
        ppShotsAgainst: defineMessage({
            defaultMessage: 'Power Play Shots Against',
            description: 'tooltips.ppShotsAgainst',
        }),
        ppShotsPer60: defineMessage({
            defaultMessage: 'Power Play Shots per 60',
            description: 'tooltips.ppShotsPer60',
        }),
        ppTimeOnIce: defineMessage({
            defaultMessage: 'Power Play Time On Ice',
            description: 'tooltips.ppTimeOnIce',
        }),
        ppTimeOnIcePctPerGame: defineMessage({
            defaultMessage: "Player's % of Team Power Play Time, per Game",
            description: 'tooltips.ppTimeOnIcePctPerGame',
        }),
        ppTimeOnIcePerGame: defineMessage({
            defaultMessage: 'Power Play Time On Ice Per Game (since 1997-98)',
            description: 'tooltips.ppTimeOnIcePerGame',
        }),
        'ppt.attackZonePercent': defineMessage({
            defaultMessage:
                "% of player's TOI spent in the offensive zone vs. defensive zone, all situations. TOI in neutral zone ignored",
            description: 'tooltips.ppt.attackZonePercent',
        }),
        'ppt.distance': defineMessage({
            defaultMessage: 'Total distance skated',
            description: 'tooltips.ppt.distance',
        }),
        'ppt.distancePerShift': defineMessage({
            defaultMessage: 'Total distance skated/shifts',
            description: 'Total distance a skaters skates on the ice per shift',
        }),
        'ppt.player': defineMessage({
            defaultMessage: 'Player Name',
            description: 'tooltips.ppt.player',
        }),
        'ppt.speedAvg': defineMessage({
            defaultMessage: 'Average skating speed',
            description: 'tooltips.ppt.speedAvg',
        }),
        'ppt.speedMax': defineMessage({
            defaultMessage: 'Maximum skating speed',
            description: 'tooltips.ppt.speedMax',
        }),
        primaryAssists5v5: defineMessage({
            defaultMessage: 'Primary Assists 5v5',
            description: 'tooltips.primaryAssists5v5',
        }),
        primaryAssistsPer605v5: defineMessage({
            defaultMessage: 'Primary Assists per 60 Minutes 5v5',
            description: 'tooltips.primaryAssistsPer605v5',
        }),
        primaryAssistsPerGame: defineMessage({
            defaultMessage: 'Primary Assists per Game Played',
            description: 'tooltips.primaryAssistsPerGame',
        }),
        qualityStart: defineMessage({
            defaultMessage: 'Games Started > .900 Save Percentage',
            description: 'tooltips.qualityStart',
        }),
        qualityStartsPct: defineMessage({
            defaultMessage: 'Percentage of Games Started with > .900 Save Percentage',
            description: 'tooltips.qualityStartsPct',
        }),
        regulationAndOtWins: defineMessage({
            defaultMessage: 'Regulation Plus Overtime Wins (a Standings tiebreaker since 2010-11)',
            description: 'tooltips.regulationAndOtWins',
        }),
        regulationLosses: defineMessage({
            defaultMessage: 'Regulation Losses Plus Overtime Losses',
            description: 'tooltips.regulationLosses',
        }),
        regulationWins: defineMessage({
            defaultMessage: 'Regulation Wins Plus Overtime Wins',
            description: 'tooltips.regulationWins',
        }),
        satAgainst: defineMessage({
            defaultMessage: 'Shot Attempts Against',
            description: 'tooltips.satAgainst',
        }),
        satAhead: defineMessage({
            defaultMessage: 'Shot Attempts Ahead Differential',
            description: 'tooltips.satAhead',
        }),
        satBehind: defineMessage({
            defaultMessage: 'Shot Attempts Behind Differential',
            description: 'tooltips.satBehind',
        }),
        satClose: defineMessage({
            defaultMessage: 'Shot Attempts Close Differential',
            description: 'tooltips.satClose',
        }),
        satFor: defineMessage({
            defaultMessage: 'Shot Attempts For',
            description: 'tooltips.satFor',
        }),
        satPct: defineMessage({
            defaultMessage: 'Shot Attempts Percentage',
            description: 'tooltips.satPct',
        }),
        satPctAhead: defineMessage({
            defaultMessage: 'Shot Attempts Percentage - Ahead',
            description: 'tooltips.satPctAhead',
        }),
        satPctBehind: defineMessage({
            defaultMessage: 'Shot Attempts Percentage - Behind',
            description: 'tooltips.satPctBehind',
        }),
        satPctClose: defineMessage({
            defaultMessage: 'Shot Attempts Percentage - Close',
            description: 'tooltips.satPctClose',
        }),
        satPctTied: defineMessage({
            defaultMessage: 'Shot Attempts Percentage - Tied',
            description: 'tooltips.satPctTied',
        }),
        satPercentage: defineMessage({
            defaultMessage: 'SAT Percentage',
            description: 'tooltips.satPercentage',
        }),
        satPercentageAhead: defineMessage({
            defaultMessage: 'SAT Percentage Ahead',
            description: 'tooltips.satPercentageAhead',
        }),
        satPercentageBehind: defineMessage({
            defaultMessage: 'SAT Percentage Behind',
            description: 'tooltips.satPercentageBehind',
        }),
        satPercentageClose: defineMessage({
            defaultMessage: 'SAT Percentage Close',
            description: 'tooltips.satPercentageClose',
        }),
        satPercentageTied: defineMessage({
            defaultMessage: 'SAT Percentage Tied',
            description: 'tooltips.satPercentageTied',
        }),
        satRelative: defineMessage({
            defaultMessage: 'Shot Attempts Relative',
            description: 'tooltips.satRelative',
        }),
        satRelative5v5: defineMessage({
            defaultMessage: 'Shot Attempts Relative Percentage',
            description: 'tooltips.satRelative5v5',
        }),
        satTied: defineMessage({
            defaultMessage: 'Shot Attempts Tied Differential',
            description: 'tooltips.satTied',
        }),
        satTotal: defineMessage({
            defaultMessage: 'Shot Attempts Differential',
            description: 'tooltips.satTotal',
        }),
        savePct: defineMessage({
            defaultMessage: 'Save Percentage',
            description: 'tooltips.savePct',
        }),
        savePct5v5: defineMessage({
            defaultMessage: '5v5 Save Percentage',
            description: 'tooltips.savePct5v5',
        }),
        savePctDaysRest0: defineMessage({
            defaultMessage: 'Save Percentage 0 Days Rest',
            description: 'tooltips.savePctDaysRest0',
        }),
        savePctDaysRest1: defineMessage({
            defaultMessage: 'Save Percentage 1 Day Rest',
            description: 'tooltips.savePctDaysRest1',
        }),
        savePctDaysRest2: defineMessage({
            defaultMessage: 'Save Percentage 2 Days Rest',
            description: 'tooltips.savePctDaysRest2',
        }),
        savePctDaysRest3: defineMessage({
            defaultMessage: 'Save Percentage 3 Days Rest',
            description: 'tooltips.savePctDaysRest3',
        }),
        savePctDaysRest4Plus: defineMessage({
            defaultMessage: 'Save Percentage 4 or More Days Rest',
            description: 'tooltips.savePctDaysRest4Plus',
        }),
        saves: defineMessage({
            defaultMessage: 'Saves',
            description: 'tooltips.saves',
        }),
        scoringFirstGamesPlayed: defineMessage({
            defaultMessage: 'Scoring First Games Played',
            description: 'tooltips.scoringFirstGamesPlayed',
        }),
        seasonId: defineMessage({
            defaultMessage: 'Season',
            description: 'tooltips.seasonId',
        }),
        secondaryAssists5v5: defineMessage({
            defaultMessage: 'Secondary Assists 5v5',
            description: 'tooltips.secondaryAssists5v5',
        }),
        secondaryAssistsPer605v5: defineMessage({
            defaultMessage: 'Secondary Assists per 60 Minutes 5v5',
            description: 'tooltips.secondaryAssistsPer605v5',
        }),
        secondaryAssistsPerGame: defineMessage({
            defaultMessage: 'Secondary Assists per Game Played',
            description: 'tooltips.secondaryAssistsPerGame',
        }),
        shAssists: defineMessage({
            defaultMessage: 'Shorthanded Assists (since 1933-34)',
            description: 'tooltips.shAssists',
        }),
        shFaceoffLosses: defineMessage({
            defaultMessage: 'Shorthanded Face-offs Lost (since 1997-98)',
            description: 'tooltips.shFaceoffLosses',
        }),
        shFaceoffPct: defineMessage({
            defaultMessage: 'Shorthanded Face-off Win Percentage (since 1997-98)',
            description: 'tooltips.shFaceoffPct',
        }),
        shFaceoffWins: defineMessage({
            defaultMessage: 'Shorthanded Face-offs Won (since 1997-98)',
            description: 'tooltips.shFaceoffWins',
        }),
        shFaceoffs: defineMessage({
            defaultMessage: 'Shorthanded Face-offs (since 1997-98)',
            description: 'tooltips.shFaceoffs',
        }),
        shFaceoffsLost: defineMessage({
            defaultMessage: 'Shorthanded Face-offs Lost (since 1997-98)',
            description: 'tooltips.shFaceoffsLost',
        }),
        shFaceoffsWon: defineMessage({
            defaultMessage: 'Shorthanded Face-offs Won (since 1997-98)',
            description: 'tooltips.shFaceoffsWon',
        }),
        shGoals: defineMessage({
            defaultMessage: 'Shorthanded Goals (since 1933-34)',
            description: 'tooltips.shGoals',
        }),
        shGoalsAgainst: defineMessage({
            defaultMessage: 'Shorthanded Goals Against (since 1933-34)',
            description: 'tooltips.shGoalsAgainst',
        }),
        shGoalsAgainstPerGame: defineMessage({
            defaultMessage: 'Shorthanded Goals Against per Game',
            description:
                'A phrase the describes the amount of goals a team or players allows per game when they are shorthanded',
        }),
        shGoalsFor: defineMessage({
            defaultMessage: 'Shorthanded Goals For (since 1933-34)',
            description: 'tooltips.shGoalsFor',
        }),
        shGoalsForPerGame: defineMessage({
            defaultMessage: 'Shorthanded Goals For per Game',
            description: 'tooltips.shGoalsForPerGame',
        }),
        shGoalsPer60: defineMessage({
            defaultMessage: 'Shorthanded Goals per 60 minutes',
            description: 'tooltips.shGoalsPer60',
        }),
        shIndividualSatFor: defineMessage({
            defaultMessage: 'Shorthanded Individual SAT For (since 2009-10)',
            description: 'tooltips.shIndividualSatFor',
        }),
        shIndividualSatForPer60: defineMessage({
            defaultMessage: 'Shorthanded Individual SAT For per 60 minutes (since 2009-10)',
            description: 'tooltips.shIndividualSatForPer60',
        }),
        shNumTimes: defineMessage({
            defaultMessage: 'Times Shorthanded (since 1977-78)',
            description: 'tooltips.shNumTimes',
        }),
        shPoints: defineMessage({
            defaultMessage: 'Shorthanded Points (since 1933-34)',
            description: 'tooltips.shPoints',
        }),
        shPointsPer60: defineMessage({
            defaultMessage: 'Shorthanded Points per 60',
            description: 'tooltips.shPointsPer60',
        }),
        shPrimaryAssists: defineMessage({
            defaultMessage: 'Shorthanded Primary Assists',
            description: 'tooltips.shPrimaryAssists',
        }),
        shPrimaryAssistsPer60: defineMessage({
            defaultMessage: 'Shorthanded Primary Assists per 60 minutes',
            description: 'tooltips.shPrimaryAssistsPer60',
        }),
        shSavePct: defineMessage({
            defaultMessage: 'Shorthanded Save Percentage',
            description: 'tooltips.shSavePct',
        }),
        shSaves: defineMessage({
            defaultMessage: 'Shorthanded Saves',
            description: 'tooltips.shSaves',
        }),
        shSecondaryAssists: defineMessage({
            defaultMessage: 'Shorthanded Secondary Assists',
            description: 'tooltips.shSecondaryAssists',
        }),
        shSecondaryAssistsPer60: defineMessage({
            defaultMessage: 'Shorthanded Secondary Assists per 60 minutes',
            description: 'tooltips.shSecondaryAssistsPer60',
        }),
        shShootingPct: defineMessage({
            defaultMessage: 'Shorthanded Shooting Pct',
            description: 'tooltips.shShootingPct',
        }),
        shShots: defineMessage({
            defaultMessage: 'Shorthanded Shots',
            description: 'tooltips.shShots',
        }),
        shShotsAgainst: defineMessage({
            defaultMessage: 'Shorthanded Shots Against',
            description: 'tooltips.shShotsAgainst',
        }),
        shShotsPer60: defineMessage({
            defaultMessage: 'Shorthanded Shots per 60 minutes',
            description: 'tooltips.shShotsPer60',
        }),
        shTimeOnIce: defineMessage({
            defaultMessage: 'Shorthanded Time On Ice',
            description: 'tooltips.shTimeOnIce',
        }),
        shTimeOnIcePctPerGame: defineMessage({
            defaultMessage: "Player's % of Team Shorthanded Time, per Game",
            description: 'tooltips.shTimeOnIcePctPerGame',
        }),
        shTimeOnIcePerGame: defineMessage({
            defaultMessage: 'Shorthanded Time on Ice per Game Played',
            description: 'tooltips.shTimeOnIcePerGame',
        }),
        shifts: defineMessage({
            defaultMessage: 'Shifts',
            description: 'tooltips.shifts',
        }),
        shiftsPerGame: defineMessage({
            defaultMessage: 'Shifts Per Game Played (since 1997-98)',
            description: 'tooltips.shiftsPerGame',
        }),
        shootingPct: defineMessage({
            defaultMessage: 'Shooting Percentage (since 1959-60)',
            description: 'tooltips.shootingPct',
        }),
        shootingPct5v5: defineMessage({
            defaultMessage: 'Shooting Percentage 5v5',
            description: 'tooltips.shootingPct5v5',
        }),
        shootingPctBackhand: defineMessage({
            defaultMessage: 'Shooting Pct Backhand (since 2009-10)',
            description: 'tooltips.shootingPctBackhand',
        }),
        shootingPctBat: defineMessage({
            defaultMessage: 'Shooting Pct Batted in (since 2022-23)',
            description: 'A phrase that describes a players batted in shooting percentage',
        }),
        shootingPctBetweenLegs: defineMessage({
            defaultMessage: 'Shooting Pct Between the Legs (since 2022-23)',
            description: 'A phrase that describes a players shooting percentage when the shot is between their legs',
        }),
        shootingPctCradle: defineMessage({
            defaultMessage: 'Shooting Pct Cradle (since 2022-23)',
            description: 'A phrase that describes a players shooting percentage when the shot is cradled',
        }),
        shootingPctDeflected: defineMessage({
            defaultMessage: 'Shooting Pct Deflected (since 2009-10)',
            description: 'tooltips.shootingPctDeflected',
        }),
        shootingPctPoke: defineMessage({
            defaultMessage: 'Shooting Pct Poke (since 2022-23)',
            description: 'A phrase that describes a players shooting percentage when the shot is poked',
        }),
        shootingPctSlap: defineMessage({
            defaultMessage: 'Shooting Pct Slap (since 2009-10)',
            description: 'tooltips.shootingPctSlap',
        }),
        shootingPctSnap: defineMessage({
            defaultMessage: 'Shooting Pct Snap (since 2009-10)',
            description: 'tooltips.shootingPctSnap',
        }),
        shootingPctTipIn: defineMessage({
            defaultMessage: 'Shooting Pct Tip-In (since 2009-10)',
            description: 'tooltips.shootingPctTipIn',
        }),
        shootingPctWrapAround: defineMessage({
            defaultMessage: 'Shooting Pct WrapAround (since 2009-10)',
            description: 'tooltips.shootingPctWrapAround',
        }),
        shootingPctWrist: defineMessage({
            defaultMessage: 'Shooting Pct Wrist (since 2009-10)',
            description: 'tooltips.shootingPctWrist',
        }),
        shootingPctg: defineMessage({
            defaultMessage: 'Shooting Percentage (since 1959-60)',
            description: 'tooltips.shootingPctg',
        }),
        shootingPlusSavePct5v5: defineMessage({
            defaultMessage: '5v5 Shooting Plus Save Percentage',
            description: 'tooltips.shootingPlusSavePct5v5',
        }),
        shootoutGameDecidingGoals: defineMessage({
            defaultMessage: 'Game Deciding Goals',
            description: 'tooltips.shootoutGameDecidingGoals',
        }),
        shootoutGamesPlayed: defineMessage({
            defaultMessage: 'Shootout Games Played',
            description: 'tooltips.shootoutGamesPlayed',
        }),
        shootoutGoals: defineMessage({
            defaultMessage: 'Shootout Goals',
            description: 'tooltips.shootoutGoals',
        }),
        shootoutGoalsAgainst: defineMessage({
            defaultMessage: 'Shootout Goals Against',
            description: 'tooltips.shootoutGoalsAgainst',
        }),
        shootoutLosses: defineMessage({
            defaultMessage: 'Shootout Games Lost (since 2005-06)',
            description: 'tooltips.shootoutLosses',
        }),
        shootoutPoints: defineMessage({
            defaultMessage: 'Standings points earned in Shootout games',
            description: 'tooltips.shootoutPoints',
        }),
        shootoutSavePct: defineMessage({
            defaultMessage: 'Shootout Save Percentage',
            description: 'tooltips.shootoutSavePct',
        }),
        shootoutSaves: defineMessage({
            defaultMessage: 'Shootout Saves',
            description: 'tooltips.shootoutSaves',
        }),
        shootoutShootingPct: defineMessage({
            defaultMessage: 'Shootout Shooting Percentage',
            description: 'tooltips.shootoutShootingPct',
        }),
        shootoutShootingPlusSavePct: defineMessage({
            defaultMessage: 'Shootout Shooting plus Save Percentage',
            description: 'tooltips.shootoutShootingPlusSavePct',
        }),
        shootoutShots: defineMessage({
            defaultMessage: 'Shootout Shots',
            description: 'tooltips.shootoutShots',
        }),
        shootoutShotsAgainst: defineMessage({
            defaultMessage: 'Shootout Shots Against',
            description: 'tooltips.shootoutShotsAgainst',
        }),
        shootoutWinPct: defineMessage({
            defaultMessage: 'Shootout Win Percentage',
            description: 'A phrase which denotes a goaltenders win percentage in a shootout',
        }),
        shootoutWins: defineMessage({
            defaultMessage: 'Shootout Games Won (since 2005-06)',
            description: 'tooltips.shootoutWins',
        }),
        shootsCatches: defineMessage({
            defaultMessage: 'Skater Shoots/Goalie Catches',
            description: 'tooltips.shootsCatches',
        }),
        shortHandedGoalsAgainst: defineMessage({
            defaultMessage: 'On-Ice Shorthanded Goals Against',
            description: 'tooltips.shortHandedGoalsAgainst',
        }),
        shortHandedGoalsFor: defineMessage({
            defaultMessage: 'On-Ice Shorthanded Goals For',
            description: 'tooltips.shortHandedGoalsFor',
        }),
        shortHandedTimeOnIcePerGame: defineMessage({
            defaultMessage: 'Shorthanded Time On Ice Per Game',
            description: 'tooltips.shortHandedTimeOnIcePerGame',
        }),
        shorthandedGoalsAgainst: defineMessage({
            defaultMessage: 'Shorthanded Goals Against',
            description: 'tooltips.shorthandedGoalsAgainst',
        }),
        shotAttemptsBlocked: defineMessage({
            defaultMessage: 'Attempts blocked',
            description:
                'A phrase that describes shot attempts blocked. This is recorded for the player taking a shot not the blocker of the shot',
        }),
        shotDifferentialPerGame: defineMessage({
            defaultMessage: 'Shot Differential per Game',
            description: 'tooltips.shotDifferentialPerGame',
        }),
        shots: defineMessage({
            defaultMessage: 'Shots (since 1959-60)',
            description: 'tooltips.shots',
        }),
        shots5v5: defineMessage({
            defaultMessage: 'Shots on Net 5v5',
            description: 'tooltips.shots5v5',
        }),
        shotsAgainst: defineMessage({
            defaultMessage: 'Shots Against',
            description: 'tooltips.shotsAgainst',
        }),
        shotsAgainstPer60: defineMessage({
            defaultMessage: 'Shots Against Per 60 Minutes',
            description: 'tooltips.shotsAgainstPer60',
        }),
        shotsAgainstPerGame: defineMessage({
            defaultMessage: 'Shots Against per Game (since 1959-60)',
            description: 'tooltips.shotsAgainstPerGame',
        }),
        shotsFor: defineMessage({
            defaultMessage: 'Shots For',
            description: 'tooltips.shotsFor',
        }),
        shotsForPerGame: defineMessage({
            defaultMessage: 'Shots For per Game (since 1959-60)',
            description: 'tooltips.shotsForPerGame',
        }),
        shotsOnNet: defineMessage({
            defaultMessage: 'Shots (since 2009-10)',
            description: 'tooltips.shotsOnNet',
        }),
        shotsOnNetBackhand: defineMessage({
            defaultMessage: 'Backhand Shots (since 2009-10)',
            description: 'tooltips.shotsOnNetBackhand',
        }),
        shotsOnNetBat: defineMessage({
            defaultMessage: 'Batted in Shots (since 2022-23)',
            description: 'A phrase that describes how many shots a player batted in on net',
        }),
        shotsOnNetBetweenLegs: defineMessage({
            defaultMessage: 'Between the Legs Shots (since 2022-23)',
            description: 'A phrase that describes how many shots a player has between their legs',
        }),
        shotsOnNetCradle: defineMessage({
            defaultMessage: 'Cradle Shots (since 2022-23)',
            description: 'A phrase that describes how many shots a player cradled in on net',
        }),
        shotsOnNetDeflected: defineMessage({
            defaultMessage: 'Shots Deflected (since 2009-10)',
            description: 'tooltips.shotsOnNetDeflected',
        }),
        shotsOnNetPoke: defineMessage({
            defaultMessage: 'Poke Shots (since 2022-23)',
            description: 'A phrase that describes how many shots a player pokes toward the net',
        }),
        shotsOnNetSlap: defineMessage({
            defaultMessage: 'Slap Shots (since 2009-10)',
            description: 'tooltips.shotsOnNetSlap',
        }),
        shotsOnNetSnap: defineMessage({
            defaultMessage: 'Snap Shots (since 2009-10)',
            description: 'tooltips.shotsOnNetSnap',
        }),
        shotsOnNetTipIn: defineMessage({
            defaultMessage: 'Shots Tipped (since 2009-10)',
            description: 'tooltips.shotsOnNetTipIn',
        }),
        shotsOnNetWrapAround: defineMessage({
            defaultMessage: 'Wrap Around Shots (since 2009-10)',
            description: 'tooltips.shotsOnNetWrapAround',
        }),
        shotsOnNetWrist: defineMessage({
            defaultMessage: 'Wrist Shots (since 2009-10)',
            description: 'tooltips.shotsOnNetWrist',
        }),
        shotsPerGame: defineMessage({
            defaultMessage: 'Shots per Game Played',
            description: 'tooltips.shotsPerGame',
        }),
        shutouts: defineMessage({
            defaultMessage: 'Shutouts',
            description: 'tooltips.shutouts',
        }),
        skaterFullName: defineMessage({
            defaultMessage: 'Player Name',
            description: 'tooltips.skaterFullName',
        }),
        skaterSavePct5v5: defineMessage({
            defaultMessage: "Team's 5v5 Save % when Player on Ice",
            description: 'tooltips.skaterSavePct5v5',
        }),
        skaterShootingPlusSavePct5v5: defineMessage({
            defaultMessage: "Team's 5v5 Shooting + Save % when Player on Ice",
            description: 'tooltips.skaterShootingPlusSavePct5v5',
        }),
        takeaways: defineMessage({
            defaultMessage: 'Takeaways (since 2005-06)',
            description: 'tooltips.takeaways',
        }),
        takeawaysPer60: defineMessage({
            defaultMessage: 'Takeaways per 60 (since 2005-06)',
            description: 'tooltips.takeawaysPer60',
        }),
        teamAbbrev: defineMessage({
            defaultMessage: 'Team',
            description: 'tooltips.teamAbbrev',
        }),
        teamAbbrevs: defineMessage({
            defaultMessage: 'Teams Played For',
            description: 'tooltips.teamAbbrevs',
        }),
        teamFullName: defineMessage({
            defaultMessage: 'Team',
            description: 'tooltips.teamFullName',
        }),
        teamShutouts: defineMessage({
            defaultMessage: 'Team Shutouts',
            description: 'A term for the number of games in which a team did not concede any goals to their opponent',
        }),
        ties: defineMessage({
            defaultMessage: 'Ties',
            description: 'tooltips.ties',
        }),
        tiesEvenShots: defineMessage({
            defaultMessage: 'Ties Even Shots',
            description: 'tooltips.tiesEvenShots',
        }),
        tiesLeadPeriod1: defineMessage({
            defaultMessage: 'Ties Leading After Period 1',
            description: 'tooltips.tiesLeadPeriod1',
        }),
        tiesLeadPeriod2: defineMessage({
            defaultMessage: 'Ties Leading After Period 2',
            description: 'tooltips.tiesLeadPeriod2',
        }),
        tiesOutshootOpponent: defineMessage({
            defaultMessage: 'Ties Outshot Opponent',
            description: 'tooltips.tiesOutshootOpponent',
        }),
        tiesOutshotByOpponent: defineMessage({
            defaultMessage: 'Ties Outshot by Opponent',
            description: 'tooltips.tiesOutshotByOpponent',
        }),
        tiesScoringFirst: defineMessage({
            defaultMessage: 'Ties When Scoring First',
            description: 'tooltips.tiesScoringFirst',
        }),
        tiesTrailPeriod1: defineMessage({
            defaultMessage: 'Ties Trailing After Period 1',
            description: 'tooltips.tiesTrailPeriod1',
        }),
        tiesTrailPeriod2: defineMessage({
            defaultMessage: 'Ties Trailing After Period 2',
            description: 'tooltips.tiesTrailPeriod2',
        }),
        tiesTrailingFirst: defineMessage({
            defaultMessage: 'Ties When Trailing First',
            description: 'tooltips.tiesTrailingFirst',
        }),
        timeOnIce: defineMessage({
            defaultMessage: 'Time On Ice',
            description: 'tooltips.timeOnIce',
        }),
        timeOnIce3v4: defineMessage({
            defaultMessage: 'Time on Ice Three-vs-Four',
            description: 'tooltips.timeOnIce3v4',
        }),
        timeOnIce3v5: defineMessage({
            defaultMessage: 'Time on Ice Three-vs-Five',
            description: 'tooltips.timeOnIce3v5',
        }),
        timeOnIce4v3: defineMessage({
            defaultMessage: 'Time on Ice Four-vs-Three',
            description: 'tooltips.timeOnIce4v3',
        }),
        timeOnIce4v5: defineMessage({
            defaultMessage: 'Time on Ice Four-vs-Five',
            description: 'tooltips.timeOnIce4v5',
        }),
        timeOnIce5v3: defineMessage({
            defaultMessage: 'Time on Ice Five-vs-Three',
            description: 'tooltips.timeOnIce5v3',
        }),
        timeOnIce5v4: defineMessage({
            defaultMessage: 'Time on Ice  Five-vs-Four',
            description: 'tooltips.timeOnIce5v4',
        }),
        timeOnIcePerGame: defineMessage({
            defaultMessage: 'Time On Ice per Game Played (since 1997-98)',
            description: 'tooltips.timeOnIcePerGame',
        }),
        timeOnIcePerGame5v5: defineMessage({
            defaultMessage: '5v5 Time on Ice per Game Played',
            description: 'tooltips.timeOnIcePerGame5v5',
        }),
        timeOnIcePerShift: defineMessage({
            defaultMessage: 'Time On Ice Per Shift',
            description: 'tooltips.timeOnIcePerShift',
        }),
        timeOnIcePp: defineMessage({
            defaultMessage: 'Power Play Time On Ice',
            description: 'tooltips.timeOnIcePp',
        }),
        timeOnIceShorthanded: defineMessage({
            defaultMessage: 'Shorthanded Time On Ice',
            description: 'tooltips.timeOnIceShorthanded',
        }),
        timesShorthanded: defineMessage({
            defaultMessage: 'Times Shorthanded (since 1977-78)',
            description: 'tooltips.timesShorthanded',
        }),
        timesShorthanded3v4: defineMessage({
            defaultMessage: 'Times Shorthanded Three-vs-Four',
            description: 'tooltips.timesShorthanded3v4',
        }),
        timesShorthanded3v5: defineMessage({
            defaultMessage: 'Times Shorthanded Three-vs-Five',
            description: 'tooltips.timesShorthanded3v5',
        }),
        timesShorthanded4v5: defineMessage({
            defaultMessage: 'Times Shorthanded Four-vs-Five',
            description: 'tooltips.timesShorthanded4v5',
        }),
        timesShorthandedPerGame: defineMessage({
            defaultMessage: 'Times Shorthanded per Game Played (since 1977-78)',
            description: 'tooltips.timesShorthandedPerGame',
        }),
        totalFaceoffLosses: defineMessage({
            defaultMessage: 'Face-offs Lost (since 1997-98)',
            description: 'tooltips.totalFaceoffLosses',
        }),
        totalFaceoffWins: defineMessage({
            defaultMessage: 'Face-offs Won (since 1997-98)',
            description: 'tooltips.totalFaceoffWins',
        }),
        totalFaceoffs: defineMessage({
            defaultMessage: 'Face-offs (since 1997-98)',
            description: 'tooltips.totalFaceoffs',
        }),
        totalPenaltiesDrawn: defineMessage({
            defaultMessage: 'Total Penalties Drawn',
            description: 'tooltips.totalPenaltiesDrawn',
        }),
        totalPrimaryAssists: defineMessage({
            defaultMessage: 'Primary Assists',
            description: 'tooltips.totalPrimaryAssists',
        }),
        totalSecondaryAssists: defineMessage({
            defaultMessage: 'Secondary Assists',
            description: 'tooltips.totalSecondaryAssists',
        }),
        trailingFirstGamesPlayed: defineMessage({
            defaultMessage: 'Trailing First Games Played',
            description: 'tooltips.trailingFirstGamesPlayed',
        }),
        usatAgainst: defineMessage({
            defaultMessage: 'Unblocked Shot Attempts Against',
            description: 'tooltips.usatAgainst',
        }),
        usatAhead: defineMessage({
            defaultMessage: 'Unblocked Shot Attempts Ahead Differential',
            description: 'tooltips.usatAhead',
        }),
        usatBehind: defineMessage({
            defaultMessage: 'Unblocked Shot Attempts Behind Differential',
            description: 'tooltips.usatBehind',
        }),
        usatClose: defineMessage({
            defaultMessage: 'Unblocked Shot Attempts Close Differential',
            description: 'tooltips.usatClose',
        }),
        usatFor: defineMessage({
            defaultMessage: 'Unblocked Shot Attempts For',
            description: 'tooltips.usatFor',
        }),
        usatPct: defineMessage({
            defaultMessage: 'Unblocked Shot Attempts Percentage',
            description: 'tooltips.usatPct',
        }),
        usatPctAhead: defineMessage({
            defaultMessage: 'Unblocked Shot Attempts Percentage - Ahead',
            description: 'tooltips.usatPctAhead',
        }),
        usatPctBehind: defineMessage({
            defaultMessage: 'Unblocked Shot Attempts Percentage - Behind',
            description: 'tooltips.usatPctBehind',
        }),
        usatPctClose: defineMessage({
            defaultMessage: 'Unblocked Shot Attempts Percentage - Close',
            description: 'tooltips.usatPctClose',
        }),
        usatPctTied: defineMessage({
            defaultMessage: 'Unblocked Shot Attempts Percentage - Tied',
            description: 'tooltips.usatPctTied',
        }),
        usatPercentage: defineMessage({
            defaultMessage: 'USAT Percentage',
            description: 'tooltips.usatPercentage',
        }),
        usatPercentageAhead: defineMessage({
            defaultMessage: 'USAT Percentage Ahead',
            description: 'tooltips.usatPercentageAhead',
        }),
        usatPercentageBehind: defineMessage({
            defaultMessage: 'USAT Percentage Behind',
            description: 'tooltips.usatPercentageBehind',
        }),
        usatPercentageTied: defineMessage({
            defaultMessage: 'USAT Percentage Tied',
            description: 'tooltips.usatPercentageTied',
        }),
        usatPrecentageClose: defineMessage({
            defaultMessage: 'USAT Percentage Close',
            description: 'tooltips.usatPrecentageClose',
        }),
        usatRelative: defineMessage({
            defaultMessage: 'Unblocked Shot Attempts Relative',
            description: 'tooltips.usatRelative',
        }),
        usatTied: defineMessage({
            defaultMessage: 'Unblocked Shot Attempts Tied Differential',
            description: 'tooltips.usatTied',
        }),
        usatTotal: defineMessage({
            defaultMessage: 'Unblocked Shot Attempts Differential',
            description: 'tooltips.usatTotal',
        }),
        weight: defineMessage({
            defaultMessage: 'Player Weight',
            description: 'tooltips.weight',
        }),
        winPctLeadPeriod1: defineMessage({
            defaultMessage: 'Win Percentage After Lead Period 1',
            description: 'tooltips.winPctLeadPeriod1',
        }),
        winPctLeadPeriod2: defineMessage({
            defaultMessage: 'Win Percentage After Lead Period 2',
            description: 'tooltips.winPctLeadPeriod2',
        }),
        winPctOneGoalGames: defineMessage({
            defaultMessage: 'Win Percentage 1 Goal Game',
            description: 'tooltips.winPctOneGoalGames',
        }),
        winPctScoringFirst: defineMessage({
            defaultMessage: 'Win Percentage When Scoring First',
            description: 'tooltips.winPctScoringFirst',
        }),
        winPctThreeGoalGames: defineMessage({
            defaultMessage: 'Win Percentage 3 Goal Game',
            description: 'tooltips.winPctThreeGoalGames',
        }),
        winPctTrailPeriod1: defineMessage({
            defaultMessage: 'Win Percentage After Trail Period 1',
            description: 'tooltips.winPctTrailPeriod1',
        }),
        winPctTrailPeriod2: defineMessage({
            defaultMessage: 'Win Percentage After Trail Period 2',
            description: 'tooltips.winPctTrailPeriod2',
        }),
        winPctTrailingFirst: defineMessage({
            defaultMessage: 'Win Percentage When Trailing First',
            description: 'tooltips.winPctTrailingFirst',
        }),
        winPctTwoGoalGames: defineMessage({
            defaultMessage: 'Win Percentage 2 Goal Game',
            description: 'tooltips.winPctTwoGoalGames',
        }),
        wins: defineMessage({
            defaultMessage: 'Wins',
            description: 'tooltips.wins',
        }),
        winsEvenShots: defineMessage({
            defaultMessage: 'Wins Even Shots',
            description: 'tooltips.winsEvenShots',
        }),
        winsInRegulation: defineMessage({
            defaultMessage: 'Regulation Wins (a Standings tiebreaker since 2019-20)',
            description: 'tooltips.winsInRegulation',
        }),
        winsInShootout: defineMessage({
            defaultMessage: 'Shootout Games Won (since 2005-06)',
            description: 'tooltips.winsInShootout',
        }),
        winsLeadPeriod1: defineMessage({
            defaultMessage: 'Wins After Lead Period 1',
            description: 'tooltips.winsLeadPeriod1',
        }),
        winsLeadPeriod2: defineMessage({
            defaultMessage: 'Wins After Lead Period 2',
            description: 'tooltips.winsLeadPeriod2',
        }),
        winsOneGoalGames: defineMessage({
            defaultMessage: 'Wins 1 Goal Game',
            description: 'tooltips.winsOneGoalGames',
        }),
        winsOutshootOpponent: defineMessage({
            defaultMessage: 'Wins Outshot Opponent',
            description: 'tooltips.winsOutshootOpponent',
        }),
        winsOutshotByOpponent: defineMessage({
            defaultMessage: 'Wins Outshot by Opponent',
            description: 'tooltips.winsOutshotByOpponent',
        }),
        winsScoringFirst: defineMessage({
            defaultMessage: 'Wins When Scoring First',
            description: 'tooltips.winsScoringFirst',
        }),
        winsThreeGoalGames: defineMessage({
            defaultMessage: 'Wins 3 Goal Game',
            description: 'tooltips.winsThreeGoalGames',
        }),
        winsTrailPeriod1: defineMessage({
            defaultMessage: 'Wins After Trail Period 1',
            description: 'tooltips.winsTrailPeriod1',
        }),
        winsTrailPeriod2: defineMessage({
            defaultMessage: 'Wins After Trail Period 2',
            description: 'tooltips.winsTrailPeriod2',
        }),
        winsTrailingFirst: defineMessage({
            defaultMessage: 'Wins When Trailing First',
            description: 'tooltips.winsTrailingFirst',
        }),
        winsTwoGoalGames: defineMessage({
            defaultMessage: 'Wins 2 Goal Game',
            description: 'tooltips.winsTwoGoalGames',
        }),
        zoneStartPct5v5: defineMessage({
            defaultMessage: 'Offensive Zone Face-off Percentage',
            description: 'tooltips.zoneStartPct5v5',
        }),
    },

    // The items below are all related to filter values
    experienceValues: {
        0: defineMessage({
            defaultMessage: 'Veteran',
            description: 'experienceValues.0',
        }),
        1: defineMessage({
            defaultMessage: 'Rookie',
            description: 'experienceValues.1',
        }),
    },
    gameResultValues: {
        L: defineMessage({
            defaultMessage: 'Loss',
            description: 'gameResultValues.L',
        }),
        O: defineMessage({
            defaultMessage: 'Overtime Loss',
            description: 'gameResultValues.O',
        }),
        T: defineMessage({
            defaultMessage: 'Tie',
            description: 'gameResultValues.T',
        }),
        W: defineMessage({
            defaultMessage: 'Win',
            description: 'gameResultValues.W',
        }),
        a: defineMessage({
            defaultMessage: 'All Results',
            description: 'gameResultValues.a',
        }),
    },
    gameType: {
        2: defineMessage({
            defaultMessage: 'Regular Season',
            description: 'GameType.2',
        }),
        3: defineMessage({
            defaultMessage: 'Playoffs',
            description: 'GameType.3',
        }),
    },
    handDominanceValues: {
        L: defineMessage({
            defaultMessage: 'Left',
            description: 'handDominance.L',
        }),
        R: defineMessage({
            defaultMessage: 'Right',
            description: 'handDominance.R',
        }),
        goalieBoth: defineMessage({
            defaultMessage: 'Catches Left or Right',
            description: 'handDominance.goalieBoth',
        }),
        goalieLeft: defineMessage({
            defaultMessage: 'Catches Left',
            description: 'handDominance.goalieLeft',
        }),
        goalieRight: defineMessage({
            defaultMessage: 'Catches Right',
            description: 'handDominance.goalieRight',
        }),
        skaterBoth: defineMessage({
            defaultMessage: 'Shoots Left or Right',
            description: 'handDominance.skaterBoth',
        }),
        skaterLeft: defineMessage({
            defaultMessage: 'Shoots Left',
            description: 'handDominance.skaterLeft',
        }),
        skaterRight: defineMessage({
            defaultMessage: 'Shoots Right',
            description: 'handDominance.skaterRight',
        }),
    },
    homeRoadValues: {
        H: defineMessage({
            defaultMessage: 'Home',
            description: 'homeRoad.H',
        }),
        R: defineMessage({
            defaultMessage: 'Road',
            description: 'homeRoad.R',
        }),
    },
    playerStatusValues: {
        active: defineMessage({
            defaultMessage: 'Active',
            description: 'playerStatusValues.active',
        }),
        allTime: defineMessage({
            defaultMessage: 'Active + Inactive',
            description: 'playerStatusValues.allTime',
        }),
        hof: defineMessage({
            defaultMessage: 'Hockey Hall of Fame',
            description: 'playerStatusValues.hof',
        }),
    },
    positions: {
        D: defineMessage({
            defaultMessage: 'Defenseman',
            description: 'Word for the position of Defense',
        }),
        F: defineMessage({
            defaultMessage: 'Forward',
            description: 'Phrase for the position of Forward',
        }),
        G: defineMessage({
            defaultMessage: 'Goalie',
            description: 'Word for the position of Goalie',
        }),
        L: defineMessage({
            defaultMessage: 'Left Wing',
            description: 'Phrase for the position of Left Wing',
        }),
        R: defineMessage({
            defaultMessage: 'Right Wing',
            description: 'Phrase for the position of Right Wing',
        }),
        C: defineMessage({
            defaultMessage: 'Center',
            description: 'Word for the position of Center',
        }),
    },
};

/**
 * These messages are all report specific messages
 * Ex. in the Goalie Shootout report when we refer to GP we refer to 'S/O GP' not 'GP'
 */
export const reportSpecificMessages = {
    columns: {
        goalie: {
            shootout: {
                gamesPlayed: defineMessage({
                    defaultMessage: 'S/O GP',
                    description: 'columns.gamesPlayed',
                }),
            },
        },
        skater: {
            percentages: {
                shootingPct5v5: defineMessage({
                    defaultMessage: 'On-Ice S%',
                    description: 'columns.shootingPct5v5',
                }),
                zoneStartPct5v5: defineMessage({
                    defaultMessage: 'OZ%',
                    description: 'columns.zoneStartPct5v5',
                }),
            },
            scoringRates: {
                shootingPct5v5: defineMessage({
                    defaultMessage: 'S%',
                    description: 'columns.shootingPct5v5',
                }),
            },
        },
        team: {
            percentages: {
                shootingPct5v5: defineMessage({
                    defaultMessage: '5v5 S%',
                    description: 'columns.shootingPct5v5',
                }),
                zoneStartPct5v5: defineMessage({
                    defaultMessage: '5v5 OZ%',
                    description: 'columns.zoneStartPct5v5',
                }),
            },
            realtime: {
                timeOnIcePerGame5v5: defineMessage({
                    defaultMessage: '5v5 TOI/GP',
                    description: 'columns.timeOnIcePerGame5v5',
                }),
            },
            savePercentage: {
                savePct: defineMessage({
                    defaultMessage: 'Team Sv%',
                    description: 'An abbreviation for Team Save Percentage',
                }),
            }
        },
    },
    fullReportName: {
        team: {
            penaltykill: defineMessage({
                defaultMessage: 'Penalty Kill (since 1977-78)',
                description: 'reportsFull.penaltykill',
            }),
            powerplay: defineMessage({
                defaultMessage: 'Power Play (since 1977-78)',
                description: 'reportsFull.powerplay',
            }),
            savePercentage: defineMessage({
                defaultMessage: 'Team Save Percentage',
                description: "The title of a report describing the team's save percentage",
            }),
        },
        skater: {
            penaltykill: defineMessage({
                defaultMessage: 'Penalty Kill (since 1997-98)',
                description: 'reportsFull.penaltykill',
            }),
            powerplay: defineMessage({
                defaultMessage: 'Power Play (since 1997-98)',
                description: 'reportsFull.powerplay',
            }),
        },
    },
    resultFilterValues: {
        skater: {
            percentages: {
                shootingPct5v5: defineMessage({
                    defaultMessage: 'On-Ice Shooting %',
                    description: 'resultFiltersValues.shootingPct5v5',
                }),
            },
            scoringRates: {
                shootingPct5v5: defineMessage({
                    defaultMessage: 'Shooting % 5v5',
                    description: 'resultFiltersValues.shootingPct5v5',
                }),
            },
        },
        team: {
            percentages: {
                shootingPct5v5: defineMessage({
                    defaultMessage: '5v5 Shooting %',
                    description: 'resultFiltersValues.shootingPct5v5',
                }),
            },
        },
    },
    tooltips: {
        skater: {
            scoringpergame: {
                blockedShots: defineMessage({
                    defaultMessage: 'Blocked Shots',
                    description: 'tooltips.blockedShots',
                }),
            },
            realtime: {
                hits: defineMessage({
                    defaultMessage: 'Hits (since 2005-06)',
                    description: 'tooltips.hits',
                }),
            },
            percentages: {
                shootingPct5v5: defineMessage({
                    defaultMessage: "Team's 5v5 Shooting % when Player on Ice",
                    description: 'tooltips.shootingPct5v5',
                }),
            },
        },
        goalie: {
            advanced: {
                goalsFor: defineMessage({
                    defaultMessage: 'Team Goals For while Goalie On Ice (since 2009-10)',
                    description: 'tooltips.goalsFor',
                }),
            },
        },
        team: {
            realtime: {
                hits: defineMessage({
                    defaultMessage: 'Hits (since 2005-06)',
                    description: 'tooltips.hits',
                }),
            },
        },
    },
};
